import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

export const LANG_STORAGE_KEY = 'afl_admin_lang';

const translations = {
  ru: {
    login: 'Войти',
    loginAdmin: 'Войти в админку',
    menu: 'Меню',
    logout: 'Выйти',
    accEdit: 'Мой профиль',
    accTitle: 'Мой профиль',
    accSaved: 'Профиль сохранён',
    accVkHint: 'Пустое значение сбрасывает ссылку',
    accTimezoneOffset: 'Смещение часового пояса, мин',
    accTimezoneHint: 'Как Date.getTimezoneOffset(): Москва обычно −180. Уходит на сервер при входе. Меняйте, только если браузерный сдвиг неверный.',
    accTimezoneInvalid: 'Укажите число от −1440 до 1440',
    language: 'Язык',
    heroBrand: 'Любительская футбольная лига',
    heroTitle: 'Панель администратора',
    heroSubtitle: 'Турниры, заявки, статистика и результаты — все инструменты лиги в одном месте.',
    community: 'Сообщество',
    featuresTitle: 'Ключевые возможности',
    featureMatches: 'Матчи',
    featureMatchesTitle: 'Управление матчами',
    featureMatchesText: 'Создавайте матчи, назначайте судей и стадионы, вносите результаты в реальном времени',
    featureApps: 'Заявки',
    featureAppsTitle: 'Управление заявками',
    featureAppsText: 'Просматривайте и управляйте заявками команд, добавляйте и исключайте игроков',
    featureStats: 'Статистика',
    featureStatsTitle: 'Статистика и отчеты',
    featureStatsText: 'Полная статистика по игрокам, командам и матчам обновляется автоматически',
    ctaTitle: 'Готовы начать работу?',
    ctaSubtitle: 'Получите полный доступ к инструментам администрирования вашей лиги',
    authTitle: 'Вход для администраторов',
    loginPlaceholder: 'Телефон или email',
    passwordPlaceholder: 'Пароль',
    authTermsPrefix: 'Нажимая кнопку "Войти", Вы соглашаетесь с',
    authTermsLink: 'условиями пользования',
    authContinue: 'Продолжить',
    authBack: 'Назад',
    authLoading: 'Подождите…',
    authNeedLogin: 'Укажите телефон или email',
    authNeedPassword: 'Введите пароль',
    authNeedCode: 'Введите код подтверждения',
    authNeedEmail: 'Укажите email',
    authNeedEmailCode: 'Введите код из письма',
    authPasswordShort: 'Пароль не короче 8 символов',
    authPasswordsMismatch: 'Пароли не совпадают',
    authCheckError: 'Не удалось проверить логин',
    authLoginError: 'Неверный логин или пароль',
    authCodeInvalid: 'Неверный или просроченный код',
    authResendError: 'Не удалось отправить код повторно',
    authSmsError: 'Не удалось отправить SMS',
    authEmailSendError: 'Не удалось отправить код на email',
    authSetupError: 'Не удалось завершить настройку',
    authForgotError: 'Не удалось начать сброс пароля',
    authPhoneRequired: 'У аккаунта нет телефона и пароля — восстановить вход кодом нельзя',
    authMergeAccounts: 'Склеить аккаунты',
    authMergeConfirm: 'Подтвердить склейку',
    authMergeTitle: 'Склейка аккаунтов',
    authMergeHint: 'Найден клиентский дубль с тем же телефоном. Можно объединить его с админским аккаунтом.',
    authMergeKeep: 'Останется админский аккаунт #{id}',
    authMergeKill: 'Будет склеен клиентский: #{ids}',
    authMergePhone: 'Телефон: {phone}',
    authMergeEmails: 'Email дубля: {emails}',
    authMergeSuccess: 'Аккаунты склеены. Продолжаем вход…',
    authMergeError: 'Не удалось склеить аккаунты',
    authMergeUnavailable: 'Склейка недоступна для этого логина',
    authTitleTelegram: 'Код из Telegram',
    authTitleSms: 'Код из SMS',
    authTitleSetup: 'Создайте пароль',
    authTitleForgot: 'Сброс пароля',
    authTitleForgotCode: 'Код для сброса',
    authTitleForgotReset: 'Новый пароль',
    authCodePlaceholder: 'Код ({n} цифр)',
    authCodeSentTelegram: 'Код отправлен в Telegram',
    authCodeSentSms: 'Код отправлен по SMS',
    authEmailCodeSent: 'Код отправлен на email',
    authMockCode: 'Тестовый код: {code}',
    authConfirmCode: 'Подтвердить',
    authResendCode: 'Отправить код ещё раз',
    authResendIn: 'Повторно через {n} с',
    authSendSmsInstead: 'Отправить SMS',
    authForgotPassword: 'Забыли пароль?',
    authSendReset: 'Отправить код',
    authForgotEmailSent: 'Код отправлен на {email}',
    authForgotSmsSent: 'Код для сброса отправлен по SMS',
    authForgotSetPassword: 'Придумайте новый пароль',
    authSetupNeedEmail: 'Укажите email и придумайте пароль',
    authSetupNeedPassword: 'Придумайте пароль для входа',
    authEmailPlaceholder: 'Email',
    authEmailCodePlaceholder: 'Код из письма',
    authSendEmailCode: 'Код на email',
    authNewPasswordPlaceholder: 'Новый пароль',
    authConfirmPasswordPlaceholder: 'Повторите пароль',
    authSavePassword: 'Сохранить и войти',
    accChangePassword: 'Смена пароля',
    accOldPassword: 'Текущий пароль',
    accNewPassword: 'Новый пароль',
    accConfirmPassword: 'Повтор нового пароля',
    accPasswordChanged: 'Пароль изменён',
    accPasswordChangeError: 'Не удалось сменить пароль',
    accPasswordShort: 'Пароль не короче 8 символов',
    accPasswordsMismatch: 'Пароли не совпадают',
    unknownError: 'Неизвестная ошибка',
    documents: 'Документы',
    downloadDocument: 'Скачать документ',
    docPrivacy: 'Политика конфиденциальности',
    docTerms: 'Пользовательское соглашение',
    docPersonalData: 'Политика обработки персональных данных',
    docAgreement: 'Согласие на обработку персональных данных',
    docCookies: 'Политика использования файлов cookies',
    navMatches: 'Игры',
    navApplications: 'Заявки',
    navClientForms: 'Обращения',
    navBlackList: 'Черный список',
    cfLoading: 'Загрузка обращений…',
    cfLoadError: 'Не удалось загрузить обращения',
    cfNotFound: 'Обращение не найдено',
    cfEmpty: 'Обращений пока нет',
    cfEmptyHint: 'Новые формы с сайта и приложения появятся здесь',
    cfFound: 'Найдено: {count}',
    cfScopeCity: 'город #{id}',
    cfFilterStatus: 'Статус',
    cfFilterType: 'Тип',
    cfFilterAll: 'Все',
    cfStatusNew: 'Новая',
    cfStatusDone: 'Обработана',
    cfStatusRejected: 'Отклонена',
    cfStatusUnknown: 'Статус',
    cfTypeJoin: 'Участие в чемпионате',
    cfTypeOpenLeague: 'Открыть лигу',
    cfTypeRegisterTeam: 'Заявить команду',
    cfTypeUnknown: 'Форма',
    cfColDate: 'Дата',
    cfColType: 'Тип',
    cfColName: 'Имя',
    cfColContact: 'Контакт',
    cfColStatus: 'Статус',
    cfColProcessedBy: 'Кто обработал',
    cfDetailTitle: 'Обращение',
    cfPhone: 'Телефон',
    cfEmail: 'Email',
    cfCity: 'Город',
    cfContact: 'Контакт',
    cfVk: 'ВКонтакте',
    cfHowLearned: 'Откуда узнали',
    cfExperience: 'Опыт',
    cfComment: 'Комментарий',
    cfChampionship: 'Чемпионат',
    cfUserId: 'Пользователь',
    cfCreatedAt: 'Создано',
    cfUpdatedAt: 'Обновлено',
    cfProcessedAt: 'Обработано',
    cfProcessedBy: 'Кто обработал',
    cfMarkDone: 'Обработана',
    cfMarkRejected: 'Отклонить',
    cfMarkNew: 'Вернуть в новые',
    cfStatusSaved: 'Статус обновлён',
    cfStatusError: 'Не удалось сменить статус',
    cfNoAccess: 'Нет доступа к обращениям',
    cfNoValue: '—',
    navStages: 'Управление стадиями',
    navChampions: 'Призеры лиги',
    navChampionsShort: 'Призеры',
    navTourTeam: 'Сборная тура',
    navTourTeamShort: 'Сборная',
    navDisqualifications: 'Дисквалификации',
    navMedia: 'Управление медиа',
    navTeams: 'Команды',
    navPlayers: 'Игроки',
    navDuplicates: 'Дубликаты',
    navSchedule: 'Управление расписанием',
    navTournaments: 'Турниры',
    navStadiums: 'Стадионы',
    navUsers: 'Пользователи',
    navTransferWindows: 'Трансферное окно',
    navMatchStaff: 'Назначения',
    navTablo: 'Табло',
    tabloTitle: 'Табло для OBS',
    tabloSubtitle: 'Сессия матча + прозрачный overlay для Browser Source',
    tabloPickMatchTitle: 'Матч',
    tabloSessionTitle: 'Сессия и overlay',
    tabloAirTools: 'Эфир: сцены и стиль',
    tabloAirToolsShow: 'Показать настройки эфира',
    tabloAirToolsHide: 'Скрыть настройки эфира',
    tabloControlsTitle: 'Управление',
    tabloPreviewTitle: 'Превью',
    tabloPickMatch: 'Выберите матч',
    tabloChangeMatch: 'Сменить матч',
    tabloMatchSearchPh: 'Поиск матча…',
    tabloRefresh: 'Обновить',
    tabloNoMatches: 'Матчей не найдено',
    tabloMatchesError: 'Не удалось загрузить матчи',
    tabloStyle: 'Стиль табло',
    tabloCreateSession: 'Создать сессию',
    tabloUpdateSession: 'Обновить стиль',
    tabloSessionReady: 'Сессия табло готова',
    tabloSessionError: 'Не удалось создать сессию табло',
    tabloNeedSession: 'Создайте сессию, чтобы получить URL для OBS',
    tabloOverlayKey: 'Ключ',
    tabloCopyUrl: 'Копировать URL',
    tabloOpenOverlay: 'Открыть overlay',
    tabloOpenMatch: 'Карточка матча',
    tabloUrlCopied: 'URL скопирован',
    tabloLive: 'live',
    tabloControlsHint: 'Счёт и статус уходят в overlay по socket. События и составы — в карточке матча.',
    tabloWaitingState: 'Ожидание данных матча…',
    tabloHome: 'Хозяева',
    tabloGuest: 'Гости',
    tabloLayoutLineupsHint: 'Полные составы в этой версии пока как счёт + метка стиля',
    tabloLayoutStatsHint: 'Статистика в этой версии пока как счёт + метка стиля',
    tabloScenes: 'Сцена',
    tabloScoreGroup: 'Табло',
    tabloGroupPrematch: 'До матча',
    tabloGroupBreak: 'Перерыв',
    tabloGroupFulltime: 'Конец матча',
    tabloScoreToggleHint: 'Табло всегда под сценой. Повторный клик по сцене выключает её — остаётся только табло',
    tabloEventPulses: 'Плашки событий',
    tabloEventPulsesHint: 'ЖК, КК и голы автоматически показывают карточку и подробный результат. Выключите, чтобы события только писались в протокол без плашек на эфире',
    tabloScoreLayerMissing: 'Слой табло не пришёл с сервера',
    tabloUnderlozhka: 'Цвет',
    tabloAccent: 'Акцент',
    tabloBackground: 'Фон',
    tabloTextColor: 'Текст',
    tabloStyleSource: 'Источник стиля',
    tabloResetStyle: 'Сброс на стиль лиги',
    tabloEventFallback: 'Событие',
    tabloCloseAir: 'Закрыть эфир',
    tabloRotateKey: 'Сменить ключ',
    tabloCloseConfirm: 'Закрыть эфир? Overlay-ссылка перестанет работать.',
    tabloRotateConfirm: 'Сменить overlay_key? Старую ссылку в OBS нужно заменить.',
    tabloClosedOk: 'Эфир закрыт',
    tabloRotatedOk: 'Ключ обновлён — обновите URL в OBS',
    tabloCloseError: 'Не удалось закрыть эфир',
    tabloRotateError: 'Не удалось сменить ключ',
    tabloClosed: 'Эфир закрыт',
    tabloNoLineup: 'Нет состава',
    tabloQuickHint: 'Нажмите на игрока, чтобы быстро добавить гол, ЖК или КК по текущему времени матча.',
    tabloQuickAt: 'на',
    tabloQuickAssistTitle: 'Кто отдал пас?',
    tabloQuickNoAssist: 'Без ассиста',
    tabloShowTools: 'Сцены и эфир OBS',
    tabloHideTools: 'Скрыть сцены и эфир',
    navNews: 'Новости',
    navHelp: 'Инструкция',
    navTimeSlots: 'Временные слоты',
    navReports: 'Отчёт',
    navPlayerStats: 'Статистика игроков',
    navInfographics: 'Инфографика',
    navSponsors: 'Мои спонсоры',
    igPictureType: 'Шаблон',
    igPictureTypePh: 'Выберите шаблон',
    igPictureTypeNotFound: 'Шаблон не найден',
    igTypeTable: 'Таблица',
    igTypeTop10: 'Топ-10',
    igTypeCards: 'Карточки',
    igTypeDisqualifications: 'Дисквалификации',
    igTypeAfisha: 'Афиша',
    igTypePlayoff: 'Сетка',
    igTypePreview: 'Превью матча',
    igTypeDetailedResult: 'Подробный результат',
    igTypeAnnouncement: 'Объявление',
    igTypeQuote: 'Цитата',
    igTypeAchievements: 'Достижения',
    igTypeMatchCoverGoal: 'Плашки на видео',
    igTypeBroadcastPreview: 'Превью трансляции',
    igBroadcastTitle: 'Заголовок трансляции',
    igBroadcastTournamentTitle: 'Строка турнира',
    igBroadcastTournamentTitlePh: 'КУГА | 2026',
    igBroadcastTournamentTitleHint: 'Необязательно. Если пусто — сервер соберёт из лиги и года матча.',
    igTypeSchedule: 'Расписание',
    igTypeResults: 'Результаты',
    igTypeChess: 'Шахматка',
    igTypeGroupTables: 'Таблицы групп',
    igTypeCalendar: 'Календарь',
    igAfishaDate: 'Дата',
    igAfishaCode: 'Текст над датой',
    igAfishaCodePh: 'Произвольный текст',
    igAfishaCodeHint: 'Опционально — строка над датой на макете',
    igPlayoffLayout: 'Раскладка',
    igPlayoffVerticalHint: 'Односторонняя раскладка — все ветки слева направо к финалу',
    igPlayoffVerticalForcedHint: 'Зеркало недоступно — односторонняя раскладка (без финала или фильтр команд)',
    igPlayoffTracks: 'Кубки',
    igPlayoffTracksHint: 'Пусто — все кубки. Можно любой набор; стадии выбираются уже внутри кубков',
    igPlayoffTracksClear: 'Сбросить кубки',
    igPlayoffStages: 'Стадии',
    igPlayoffStagesHint: 'Пусто — вся сетка. Несколько — только подряд внутри одного кубка (1/8+1/4+1/2). Без финала → односторонняя',
    igPlayoffStagesLoading: 'Список стадий появится после превью',
    igPlayoffStagesClear: 'Сбросить стадии',
    igPlayoffStagesInvalid: 'Стадии должны идти подряд внутри кубка. «За 3 место» — только с финалом или отдельно',
    igPlayoffStageEmpty: 'пусто',
    igPlayoffTeams: 'Команды',
    igPlayoffTeamsHint: 'Пусто — все. Иначе только матчи с выбранными командами (зеркалка выключается)',
    igPlayoffTeamsLoading: 'Список команд появится после превью',
    igPlayoffTeamsClear: 'Сбросить команды',
    igAnnouncementText: 'Текст объявления',
    igAnnouncementTextPh: 'ОБЪЯВЛЕНИЕ',
    igAnnouncementTextHint: 'До 6 строк — каждая с новой строки',
    igQuoteTeam: 'Команда',
    igQuoteTeamPh: 'Выберите команду',
    igQuoteTeamNotFound: 'Команды не найдены',
    igQuoteTeamsError: 'Не удалось загрузить команды',
    igQuoteName: 'Имя',
    igQuoteNamePh: 'ИМЯ',
    igQuoteText: 'Цитата',
    igQuoteTextPh: 'ЦИТАТА',
    igQuoteTextHint: 'До 4 строк — каждая с новой строки',
    igAchievementsTitle: 'Достижение',
    igAchievementsTitlePh: 'MVP',
    igAchievementsName: 'Имя',
    igAchievementsNamePh: 'NAME',
    igCoverGoalDownload: 'Скачать ZIP',
    igCoverGoalDownloadDone: 'Пак плашек скачан',
    igCoverGoalTitle: 'MATCHDAY',
    igCoverGoalSettings: 'Плашки на видео',
    igCoverGoalSettingsHint: 'Matchday 1920×1080: подложка, accent, соцсети; ZIP с кадрами гол/карточки',
    igErrMissingLeagueOrMatch: 'Нужны лига и матч.',
    igErrMissingTeamId: 'Нужна команда.',
    igErrMissingPlayerId: 'Нужен игрок.',
    igErrMissingTourTeamOrPlayers: 'Нужна сохранённая сборная или состав игроков.',
    igErrPlayerNotFound: 'Игрок не найден.',
    igErrTeamNotFound: 'Команда не найдена.',
    igMvpPlayer: 'Игрок',
    igMvpTeam: 'Команда',
    igMvpTeamPh: 'Выберите команду',
    igMvpLabel: 'Лейбл',
    igMvpLabelPh: 'MVP ТУРА',
    igMatchSubsRoster: 'Состав',
    igMatchSubsFromDb: 'Из базы',
    igMatchSubsManual: 'Вручную',
    igMatchSubsDbHint: 'Состав из заявки матча. Позицию можно дописать вручную (LB, ЦЗ…) — уйдёт как positionOverrides. Если пусто — ручной ввод.',
    igMatchSubsManualHint: 'Поиск в базе или ручной ввод: номер, фамилия, имя, позиция. Число игроков не ограничено.',
    igMatchSubsStarters: 'Основной состав',
    igMatchSubsBench: 'Запас',
    igMatchSubsHome: 'Хозяева',
    igMatchSubsGuest: 'Гости',
    igMatchSubsFamilyPh: 'Фамилия',
    igMatchSubsNamePh: 'Имя',
    igMatchSubsPositionPh: 'Поз.',
    igMatchSubsPositionHint: 'Код или короткое имя: LB, ЦЗ, CM…',
    igMatchSubsSearchPlayer: 'Найти игрока в базе',
    igMatchSubsEditPositions: 'Дописать позиции',
    igMatchSubsHidePositions: 'Скрыть позиции',
    igMatchSubsOverwritePositions: 'Перезаписывать позиции из профиля',
    igMatchSubsAdd: 'Добавить игрока',
    igMatchSubsRemove: 'Удалить',
    igMatchSubsReloadDb: 'Подставить из базы',
    igMatchLineupsDbHint: 'Стартеры на двух полях (из lineup_position_id), запас строками. Позицию/слот можно дописать вручную.',
    igMatchLineupsManualHint: 'Для схемы на поле укажите слот: gk, def_0, mid_1, fwd_2… Плюс номер, ФИО и амплуа.',
    igMatchLineupsSlotPh: 'Слот',
    igMatchLineupsSlotHint: 'lineup_position_id: fwd_0…gk',
    igPictureGroupTournament: 'По турниру',
    igPictureGroupMatch: 'По матчу',
    igPictureGroupOther: 'Прочее',
    igFiltersNeedSeason: 'Сначала выберите сезон',
    igMatchSubsNeedMatch: 'Сначала выберите матч',
    igTourTeamPick: 'Сборная тура',
    igTourTeamPh: 'Выберите сборную',
    igTourTeamNotFound: 'Сборные не найдены',
    igTourTeamsError: 'Не удалось загрузить сборные тура',
    igTourTeamFallback: 'Сборная',
    igTourTeamHint: 'Редактировать состав можно в разделе',
    igTourTeamOpenEditor: 'Сборная тура',
    igPreviewMatch: 'Матч',
    igPreviewMatchPh: 'Выберите матч',
    igPreviewMatchNotFound: 'Матчи не найдены',
    igPreviewMatchesError: 'Не удалось загрузить матчи',
    igPreviewPhotos: 'Фото по бокам',
    igPreviewPhotosHint: 'Слоты 300×1080 слева и справа. Без фото — пустые панели',
    igPreviewPhotoLeft: 'Слева',
    igPreviewPhotoRight: 'Справа',
    igPreviewPhotoEmpty: 'Нет фото',
    igPreviewPhotoUpload: 'Загрузить',
    igPreviewPhotoReplace: 'Заменить',
    igPreviewPhotoCrop: 'Обрезать фото слота',
    igPreviewHeadline: 'Заголовок',
    igPreviewHeadlinePh: 'Стадион по умолчанию',
    igCalendarColumns: 'Колонки',
    igCalendarGroupStagesOnly: 'Только группы',
    igCalendarGroupStagesOnlyHint: 'Для групповых лиг — только туры группового этапа',
    igGroupTablesPick: 'Группы',
    igGroupTablesPickHint: 'До 4 групп. Пусто — сервер возьмёт первые по приоритету',
    igGroupTablesEmpty: 'Группы сезона не найдены',
    igSplitByGroups: 'Разбивка',
    igSplitByGroupsOn: 'По группам',
    igSplitByGroupsOff: 'Вся лига',
    igTopStatsGroupsPick: 'Группы',
    igTopStatsGroupsHint: 'Пусто — все группы сезона. Выберите, чтобы ограничить картинку',
    igErrLeagueTypeNotGroups: 'Эта лига не групповая (не type 2). Для неё используйте шаблоны «Таблица» или «Шахматка».',
    igErrLeagueTypeNotPlayoff: 'Сетка только для лиг с плей-офф (league_type = 2).',
    igErrLeagueSettingsMissing: 'Нет настроек сезона для этой лиги — проверьте сезон.',
    igErrNoGroups: 'В сезоне нет групп. Добавьте группы в составе сезона или выберите другую лигу.',
    igErrNoPlayoffRounds: 'В сезоне нет стадий плей-офф.',
    igErrGroupsNotFound: 'Выбранные группы не найдены в сезоне. Обновите список групп и выберите заново.',
    igErrUnknownStageIds: 'Выбрана стадия, которой нет в сетке.',
    igErrStagesNotContiguous: 'Стадии должны идти подряд по сетке.',
    igErrUnknownTrackKeys: 'Неизвестные кубки в выборе.',
    igErrEmptyTrackSelection: 'Выберите хотя бы один кубок.',
    igErrThirdRequiresFinal: '«За 3 место» можно только с финалом (или отдельно).',
    igErrUnknownTeamIds: 'Выбрана команда, которой нет в плей-офф.',
    igErrNoMatchesForTeams: 'Нет матчей для выбранных команд.',
    igErrMissingLeagueOrSeason: 'Нужны лига и сезон.',
    igErrMissingLeagueSeasonOrDate: 'Нужны лига, сезон и дата.',
    igErrMissingMatchId: 'Нужен матч.',
    igErrMatchNotFound: 'Матч не найден.',
    igMatchStatsBars: 'Цвета шкал',
    igMatchStatsBarsHint: 'По умолчанию — цвет команды или accent / полупрозрачный белый. Сброс убирает ручной override.',
    igMatchStatsHomeBar: 'Хозяева',
    igMatchStatsGuestBar: 'Гости',
    igMatchStatsBarReset: 'К команде',
    igMatchStatsBarSourceOverride: 'вручную',
    igMatchStatsBarSourceTeam: 'цвет команды',
    igMatchStatsBarSourceDefault: 'дефолт темы',
    igErrInvalidDate: 'Дата должна быть в формате ГГГГ-ММ-ДД.',
    igResultsIncludeUpcoming: 'Несыгранные',
    igResultsIncludeUpcomingHint: 'Показать время матчей без счёта',
    igScheduleFilter: 'Матчи',
    igScheduleByStage: 'По туру',
    igScheduleByDates: 'По датам',
    igScheduleStage: 'Тур',
    igScheduleStagePh: 'Выберите тур',
    igScheduleStageNotFound: 'Туры не найдены',
    igScheduleDateFrom: 'С',
    igScheduleDateTo: 'По',
    igScheduleSeasonOptional: 'Сезон (необяз.)',
    igScheduleSeasonOptionalPh: 'Сузить по сезону',
    igMatchListPick: 'Матчи на картинке',
    igMatchListPickHint: 'По умолчанию все. Снимите галочки, чтобы убрать матчи с картинки.',
    igMatchListMyStaff: 'Мои назначения',
    igMatchListMyStaffHint: 'Только матчи, где вы назначены в персонале',
    igMatchListMyStaffEmpty: 'Нет матчей с вашим назначением',
    igMatchListAll: 'Все',
    igMatchListNone: 'Снять все',
    igMatchListEmpty: 'Матчей нет',
    igMatchListLoading: 'Загрузка матчей…',
    igMatchListError: 'Не удалось загрузить список матчей',
    igMatchListSelected: 'Выбрано: {n} из {total}',
    igSubtitle: 'Турнирная таблица для соцсетей',
    igPreview: 'Превью',
    igPreviewCollapse: 'Свернуть',
    igPreviewExpand: 'Показать превью',
    igPreviewOpen: 'Открыть',
    igPreviewClose: 'Закрыть',
    igSponsors: 'Спонсоры',
    igSponsorsHint: 'Выберите логотип из пула, перетащите на превью, масштабируйте за угол',
    igSponsorsMy: 'Мои спонсоры',
    igSponsorsPickPh: 'Найти спонсора…',
    igSponsorsPickEmpty: 'Пул пуст — добавьте в «Мои спонсоры»',
    igSponsorsPickNeedLeague: 'Сначала выберите лигу',
    igSponsorsNeedLeague: 'Выберите лигу сверху — тогда подгрузится пул спонсоров',
    igSponsorsAddBtn: 'Добавить на картинку',
    igSponsorsLeague: 'Эталон лиги',
    igSponsorsLeagueEmpty: 'Ещё нет эталона — сохранится при PNG',
    igSponsorsLeagueFallback: 'Эталон лиги (другой тип)',
    igSponsorsLeagueHint: 'Обновляется сам при скачивании PNG',
    igSponsorsLeagueApply: 'Применить эталон',
    igSponsorsSchemes: 'Схемы спонсоров',
    igSponsorsSchemeNamePh: 'Название схемы спонсоров',
    igSponsorsSchemeSave: 'Сохранить схему',
    igSponsorsSchemeSaved: 'Схема спонсоров сохранена',
    igSponsorsSchemeSaveError: 'Не удалось сохранить схему спонсоров',
    igSponsorsSchemeDeleted: 'Схема спонсоров удалена',
    igSponsorsSchemeDeleteError: 'Не удалось удалить схему спонсоров',
    igSponsorsSchemeDelete: 'Удалить схему',
    igSponsorsSchemeNameRequired: 'Введите название схемы',
    igSponsorsLoadError: 'Не удалось загрузить спонсоров',
    igSponsorsPlaced: 'На картинке',
    igSponsorsEmpty: 'Пока нет спонсоров на картинке',
    igSponsorsNeedPreview: 'Сначала выберите лигу и сезон',
    igSponsorsBringFront: 'Наверх',
    igSponsorsRemove: 'Удалить',
    igSponsorsAddError: 'Не удалось добавить спонсора',
    igSponsorsAnchorHint: 'Логотипы в нижней половине кадра автоматически крепятся к низу — на любой высоте картинки останутся снизу',
    spLoadError: 'Не удалось загрузить спонсоров',
    spLoading: 'Загрузка спонсоров…',
    spSearchPh: 'Поиск по названию',
    spFound: 'Найдено: {count}',
    spEmpty: 'Спонсоров пока нет',
    spEmptyHint: 'Добавьте логотип — он появится в пуле инфографики',
    spImage: 'Логотип',
    spName: 'Название',
    spNamePh: 'Например, Puma',
    spNameRequired: 'Введите название спонсора',
    spImageRequired: 'Загрузите картинку спонсора',
    spAdd: 'Добавить спонсора',
    spAddShort: 'Добавить',
    spAddTitle: 'Новый спонсор',
    spSaving: 'Сохранение…',
    spAdded: 'Спонсор добавлен',
    spAddError: 'Не удалось добавить спонсора',
    spDelete: 'Удалить',
    spDeleteTitle: 'Удалить спонсора?',
    spDeleteConfirm: 'Удалить спонсора «{name}»?',
    spDeleteText: 'Вы уверены, что хотите удалить «{name}»? Это действие нельзя отменить.',
    spDeleted: 'Спонсор удалён',
    spDeleteError: 'Не удалось удалить спонсора',
    spBackToInfographics: 'К инфографике',
    igDownload: 'Скачать PNG',
    igDownloading: 'Рендер PNG…',
    igLoadingPreview: 'Загрузка превью…',
    igLoadingPreviewHint: 'Это может занять несколько секунд',
    igSelectLeagueSeason: 'Выберите лигу и сезон',
    igTheme: 'Подложка',
    igUnderSolid: 'Новые',
    igUnderPattern: 'Старые',
    igThemeBlue: 'Синяя',
    igThemeGreen: 'Зелёная',
    igThemeBrown: 'Коричневая',
    igThemeYellow: 'Жёлтая',
    igThemeRed: 'Красная',
    igThemePurple: 'Фиолетовая',
    igLogoCaption: 'Подпись на щите',
    igLogoCaptionPh: 'Например, MOSCOW 8X8',
    igTitle: 'Заголовок',
    igTitleColor: 'Цвет заголовка',
    igAccent: 'Акцент',
    igBgColor: 'Цвет фона',
    igStadiumBg: 'Лента стадиона',
    igTableBg: 'Фон таблицы',
    igLeagueBarBg: 'Фон полосы лиги',
    igAlpha: 'Прозрачность',
    igFooter: 'Соцсети внизу',
    igFooterColor: 'Цвет соцсетей',
    igFooterWeb: 'Сайт',
    igBgUrl: 'Подложка',
    igUploadOwn: 'Своя',
    igUploadHint: 'PNG, JPG или WebP · кроп под размер таблицы',
    igUploadBusy: 'Обработка…',
    igUploadError: 'Не удалось загрузить картинку',
    igUploadTypeError: 'Нужен файл PNG, JPG или WebP',
    igUploadNeedPreview: 'Сначала выберите лигу и сезон — нужен размер превью для кропа',
    igCropTitle: 'Кадр подложки',
    igCustomPalette: 'Палитра для своей подложки',
    igRemoveUpload: 'Убрать файл',
    igAdvanced: 'Дополнительно',
    igStyles: 'Цветовые схемы',
    igStyleApplied: 'Выбрано',
    igStyleLeague: 'Схема этой лиги',
    igStyleLeagueFallback: 'Схема этой лиги',
    igStyleFallbackShort: 'похожая',
    igStyleLeagueHint: 'Обновляется сама при скачивании PNG',
    igStyleLeagueHintZip: 'Обновляется сама при скачивании ZIP',
    igStyleLeagueEmpty: 'Появится после первого скачивания PNG',
    igStyleLeagueEmptyZip: 'Появится после первого скачивания ZIP',
    igStyleLeagueSave: 'Сохранить для лиги',
    igStyleLeagueSaved: 'Схема лиги сохранена',
    igStyleLeagueSaveError: 'Не удалось сохранить схему лиги',
    igSchemes: 'Общие схемы',
    igSchemeSave: 'Сохранить схему',
    igSchemeNamePh: 'Название цветовой схемы',
    igSchemeNameRequired: 'Введите название схемы',
    igSchemeSaved: 'Цветовая схема сохранена',
    igSchemeSaveError: 'Не удалось сохранить схему',
    igSchemeDelete: 'Удалить схему',
    igSchemeDeleted: 'Схема удалена',
    igSchemeDeleteError: 'Не удалось удалить схему',
    igRecent: 'Недавние цвета',
    igStylesLoadError: 'Не удалось загрузить цветовые схемы',
    igReset: 'Сбросить',
    igPreviewEmpty: 'Выберите лигу и сезон, чтобы увидеть превью',
    igPreviewError: 'Не удалось загрузить превью',
    igDownloadError: 'Не удалось скачать PNG',
    igDownloadDone: 'PNG скачан',
    igUnderlozhkiError: 'Каталог подложек недоступен, показаны локальные пресеты',
    rpSummary: 'Сводный отчёт',
    rpMatches: 'Отчёт по матчам',
    rpStaff: 'Персонал',
    rpPlayersCount: 'Количество игроков',
    rpBirthdays: 'Дни рождения',
    rpBest: 'Лучшие игроки / команды',
    rpTabPlayersCount: 'Игроки',
    rpTabBirthdays: 'Д.Р.',
    rpTabBest: 'Лучшие',
    rpTabSummary: 'Обзор',
    rpTabMatches: 'Игры',
    rpTabStaff: 'Персонал',
    rpDateFrom: 'С даты',
    rpDateTo: 'По дату',
    rpSearchTeams: 'Поиск по командам',
    rpSearchStaff: 'Имя или должность',
    rpSearchCity: 'Поиск по городу',
    rpFlag: 'Игры',
    rpFlagAll: 'Все игры',
    rpFlagNoResult: 'Нет результата',
    rpFlagNoVideo: 'Без видео',
    rpFlagNoPhoto: 'Без фото',
    rpFlagNoLineup: 'Не отмечены составы',
    rpGender: 'Пол',
    rpGenderAll: 'Все',
    rpGenderMale: 'Мужчины',
    rpGenderFemale: 'Женщины',
    rpStatus: 'Статус',
    rpStatusAll: 'Все',
    rpStatusAmateur: 'Любители',
    rpStatusPro: 'Профессионалы',
    rpAge: 'Возраст',
    rpAgeFrom: 'От',
    rpAgeTo: 'До',
    rpAgeInvalid: 'Возраст «от» не может быть больше возраста «до»',
    rpMatchesCount: 'Матчей: {count}',
    rpPlayersTotal: 'Игроков: {count}',
    rpShowPlayers: 'Показать игроков',
    rpHidePlayers: 'Скрыть игроков',
    rpPlayersLoading: 'Загрузка игроков…',
    rpInsured: 'Застрахован',
    rpNotInsured: 'Не застрахован',
    rpInsuranceUntil: 'до {date}',
    rpNoStadium: 'Без стадиона',
    rpNoData: 'Нет данных',
    rpNeedDates: 'Укажите даты',
    rpNeedChamp: 'Выберите чемпионат',
    rpCapLineup: 'Капитан отметил состав',
    rpAdminLineup: 'Состав',
    rpHome: 'Хозяева',
    rpGuest: 'Гости',
    rpSlots: 'Слоты',
    rpGamesPlayed: 'Игр: {count}',
    rpScorers: 'Бомбардиры',
    rpAssists: 'Ассистенты',
    rpGoalsAssists: 'Гол + пас',
    rpYellow: 'Жёлтые',
    rpRed: 'Красные',
    rpTeamsGoals: 'Команды по голам',
    rpBiggestWins: 'Крупные победы',
    rpRoughest: 'Грубые игры',
    rpUnknown: 'Без названия',
    rpLeagues: 'Лиги',
    tsAddMatch: 'Добавить игру',
    tsGames: 'Игры',
    tsAddSlot: 'Добавить временной слот',
    tsSlots: 'Временные слоты',
    tsSelectCountry: 'Страна',
    tsLeague: 'Лига',
    tsSelectLeague: 'Лига',
    tsSeason: 'Сезон',
    tsSelectSeason: 'Сезон',
    tsTour: 'Тур',
    tsSelectTour: 'Все туры',
    tsSearchTeams: 'Поиск по команде',
    tsPickCascade: 'Выберите страну, лигу и сезон',
    tsMatchesLoading: 'Загрузка игр',
    tsMatchesEmpty: 'Игры не найдены',
    tsLoadMore: 'Ещё игры',
    tsLoading: 'Загрузка...',
    tsGamesEmpty: 'Выберите игры в первом блоке',
    tsRemoveMatch: 'Убрать игру',
    tsDeleteWishes: 'Удалить пожелания',
    tsOpenWishes: 'Открыть пожелания',
    tsStadium: 'Стадион',
    tsStadiumPh: 'Поиск стадиона',
    tsStadiumLoading: 'Поиск стадионов...',
    tsStadiumEmpty: 'Стадионы не найдены',
    tsTimezone: 'Часовой пояс площадки',
    tsTimezoneAuto: 'Авто ({tz})',
    tsTimezoneHint: 'Стенное время места игры (город чемпионата / стадион), не пояс ноутбука',
    tsClearStadium: 'Сбросить стадион',
    tsPitch: 'Поле',
    tsSelectPitch: 'Выберите поле',
    tsStart: 'Начало',
    tsEnd: 'Конец',
    tsDuration: 'Продолжительность, мин',
    tsAddSlots: 'Добавить слоты',
    tsNeedRange: 'Укажите начало, конец и продолжительность',
    tsRangeInvalid: 'Конец должен быть позже начала',
    tsNeedStadium: 'Сначала выберите стадион',
    tsTooManySlots: 'Слишком много слотов — добавлена часть',
    tsNoSlotsFit: 'В выбранный промежуток не помещается ни одного слота',
    tsSlotsAdded: 'Добавлено слотов: {count}',
    tsSelectScheme: 'Сохранённая схема',
    tsLoadScheme: 'Загрузить',
    tsDeleteScheme: 'Удалить схему',
    tsDeleteSchemeConfirm: 'Удалить схему на сервере?',
    tsSchemeName: 'Название схемы',
    tsSchemeNamePh: 'Например, Выходные, база №1',
    tsNeedSchemeName: 'Введите название схемы',
    tsSlotsEmpty: 'Слотов пока нет. Загрузите схему или добавьте слоты',
    tsEmptySlot: 'Свободно',
    tsAssignHint: 'Чтобы поставить игру в слот, выберите её здесь, затем нажмите на свободный слот',
    tsDropHere: 'Назначить выбранную игру',
    tsRemoveSlot: 'Удалить слот',
    tsDetachMatch: 'Открепить матч от слота',
    tsAssignTime: 'Назначить время',
    tsAutoAssign: 'Проставить автоматически',
    tsAutoAssignOk: 'Проставлено игр: {count}. Нажмите «Назначить время», чтобы сохранить',
    tsAutoAssignPartial: 'Автоматически назначено {ok}, не удалось {fail}',
    tsAutoAssignNone: 'Некуда проставлять: нет свободных слотов',
    tsAutoAssignError: 'Не удалось проставить автоматически',
    tsWishHome: 'Хозяева',
    tsWishAway: 'Гости',
    tsWishFits: 'Подходит {times}',
    tsWishNoFits: 'Не подходит {times}',
    tsWishNoAnswer: 'Ответа по пожеланиям ещё нет',
    tsSlotWishHint: 'Пожелания капитанов на это время: хозяева / гости',
    tsSaveScheme: 'Сохранить схему слотов',
    tsSaveText: 'Сохранить текст',
    tsLoadCountriesError: 'Не удалось загрузить страны',
    tsLoadLeaguesError: 'Не удалось загрузить лиги',
    tsLoadSeasonsError: 'Не удалось загрузить сезоны',
    tsLoadStagesError: 'Не удалось загрузить туры',
    tsLoadMatchesError: 'Не удалось загрузить игры',
    tsLoadPitchesError: 'Не удалось загрузить поля',
    tsLoadSchemesError: 'Не удалось загрузить схемы',
    tsSchemeLoaded: 'Загружена схема «{name}», матчей в слотах: {count}',
    tsSchemeLoadedEmpty: 'Схема «{name}» загружена, но сервер вернул пустые слоты',
    tsSchemeLoadedNoMatches: 'Схема «{name}» загружена. Слоты пустые, пока обе команды не поставят fits = 1 — это ожидаемо.',
    tsNeedWeekDate: 'Нет даты недели',
    tsSchemeDeleted: 'Схема удалена',
    tsDeleteSchemeError: 'Не удалось удалить схему',
    tsWishesOpened: 'Пожелания открыты. Не создано для матчей: {skipped}.',
    tsWishesOpenedOk: 'Пожелания открыты.',
    tsWishesSkippedHint: 'Пропущенные — матчи, для которых пожелания не создались. Обычно это уже сыгранные игры.',
    tsOpenWishesError: 'Не удалось открыть пожелания',
    tsDeleteWishesConfirm: 'Удалить все пожелания выбранных игр?',
    tsWishesDeleted: 'Удалено пожеланий: {deleted}',
    tsDeleteWishesError: 'Не удалось удалить пожелания',
    tsAssignOk: 'Назначено игр: {count}',
    tsAssignPartial: 'Назначено {ok}, не удалось {fail}',
    tsAssignError: 'Не удалось назначить время',
    tsSchemeSaved: 'Схема сохранена',
    tsSaveSchemeError: 'Не удалось сохранить схему',
    tsTxtEmpty: 'Нет игр в слотах для текстового файла',
    tsOk: 'Ок',
    tsOkTitle: 'Готово',
    tsErrorTitle: 'Ошибка',
    tsTxtSaved: 'Файл сохранён',
    newsSearchPh: 'Поиск по заголовку',
    newsFound: 'Найдено новостей: {count}',
    newsEmpty: 'Новости не найдены',
    newsEmptyHint: 'Измените поиск или добавьте новый пост',
    newsLoading: 'Загрузка новостей',
    newsLoadingCard: 'Загрузка новости',
    newsLoadError: 'Не удалось загрузить новости',
    newsNotFound: 'Новость не найдена',
    newsCreate: 'Добавить пост',
    newsNew: 'Новая новость',
    newsEdit: 'Редактирование новости',
    newsTitle: 'Заголовок',
    newsTitlePh: 'Заголовок новости',
    newsPreview: 'Подзаголовок',
    newsPreviewPh: 'Краткое описание',
    newsTags: 'Теги',
    newsTagsPh: 'Найти или добавить тег',
    newsTagsFilterPh: 'Фильтр по тегу',
    newsTagAdd: 'Добавить «{key}»',
    newsTagRemove: 'Убрать тег {key}',
    newsTagInvalid: 'Тег: латиница, цифры, _ и -',
    newsTagsLoading: 'Загрузка тегов',
    newsTagsEmpty: 'Теги не найдены',
    newsTagsLoadError: 'Не удалось загрузить теги',
    newsNoTags: 'Без тегов',
    newsNoEntities: 'Без сущностей',
    newsText: 'Текст поста',
    newsTextPh: 'Напишите текст новости',
    newsSave: 'Сохранить новость',
    newsSaved: 'Новость сохранена',
    newsCreated: 'Новость создана',
    newsSaveError: 'Не удалось сохранить новость',
    newsDeleteTitle: 'Удалить новость?',
    newsDeleteText: 'Новость, теги и отметки прочтения будут удалены. Это действие нельзя отменить.',
    newsDeleted: 'Новость удалена',
    newsDeleteError: 'Не удалось удалить новость',
    newsNeedTitle: 'Укажите заголовок',
    newsDate: 'Дата',
    newsSortDate: 'По дате',
    newsSortTitle: 'По заголовку',
    newsSortTag: 'По тегу',
    newsTagBindingsHint: 'Привязки попадут в новый тег. Уже добавленные теги не меняются.',
    newsEntities: 'Привязанные сущности',
    newsEntitiesPh: 'Найти команду, игрока, матч…',
    newsEntityRemove: 'Убрать {name}',
    searchAddFilter: 'Добавить фильтр',
    searchTypeAll: 'Все типы',
    searchTypeCity: 'Город',
    searchTypeLeague: 'Лига',
    searchTypeChamp: 'Чемпионат',
    searchTypeTeam: 'Команда',
    searchTypeStadium: 'Стадион',
    searchTypeMatch: 'Матч',
    searchTypePlayer: 'Игрок',
    searchTypeClient: 'Клиент',
    searchTypePerson: 'Персона',
    searchTypeMigration: 'Migration ID',
    searchEntityPh: 'Найти объект',
    searchMigrationPh: 'migrationId',
    searchApply: 'Ок',
    searchLoading: 'Поиск...',
    searchEmpty: 'Ничего не найдено',
    searchLoadError: 'Не удалось выполнить поиск',
    searchRemoveFilter: 'Убрать фильтр {label}',
    globalSearchPh: 'Игрок, команда, лига, стадион, матч',
    globalSearchPhShort: 'Поиск',
    globalSearchLabel: 'Глобальный поиск',
    globalSearchNeedChamp: 'Сначала выберите чемпионат',
    globalSearchHint: 'Начните вводить название',
    globalSearchType: 'Тип сущности',
    globalSearchOpen: 'Открыть поиск',
    globalSearchClose: 'Закрыть поиск',
    newsEditorBold: 'Жирный',
    newsEditorItalic: 'Курсив',
    newsEditorHeading: 'Заголовок',
    newsEditorQuote: 'Цитата',
    newsEditorLink: 'Ссылка',
    newsEditorImage: 'Вставить фото',
    newsEditorLinkPh: 'Адрес ссылки',
    usrSearchPh: 'Логин, имя, фамилия, email или идентификатор',
    usrFound: 'Найдено пользователей: {count}',
    usrLogin: 'Логин',
    usrId: 'ID',
    usrRoles: 'Роли',
    usrChampionships: 'Чемпионаты',
    usrEmpty: 'Пользователи не найдены',
    usrEmptyHint: 'Измените поиск или фильтры',
    usrLoading: 'Загрузка пользователей',
    usrLoadingCard: 'Загрузка карточки пользователя',
    usrLoadError: 'Не удалось загрузить пользователей',
    usrNotFound: 'Пользователь не найден',
    usrAllRoles: 'Все роли',
    usrAllChamps: 'Все чемпионаты',
    usrCardTitle: 'Карточка пользователя',
    usrFields: 'Данные пользователя',
    usrEditRoles: 'Роли и чемпионаты',
    usrEditChamps: 'Чемпионаты',
    usrPlayers: 'Привязанные игроки',
    usrMainRole: 'Главная роль',
    usrConfirmed: 'Подтверждён',
    usrYes: 'Да',
    usrNo: 'Нет',
    usrNoChamps: 'Чемпионатов нет',
    usrNoPlayers: 'Привязанных игроков нет',
    usrEmail: 'Email',
    usrPhone: 'Телефон',
    usrCity: 'Город',
    usrCityId: 'ID города',
    usrIdentificator: 'Идентификатор',
    usrDefaultChamp: 'Чемпионат по умолчанию',
    usrBirthday: 'Дата рождения',
    usrVk: 'VK',
    usrTelegram: 'Telegram',
    usrName: 'Имя',
    usrFamily: 'Фамилия',
    usrFatherName: 'Отчество',
    usrRootLocked: 'Нельзя снять роль root у себя',
    usrAutoRolesHint: 'Каждое назначение — пара роль + чемпионат. Капитана и вице-капитана назначают с командой. Роли «пользователь» и «игрок» сервер ставит сам: есть привязанный игрок — игрок, нет — пользователь.',
    usrRolesScopedHint: 'Показаны только назначения ваших чемпионатов. При сохранении этот список уходит как полный набор для вашей зоны — чужие чемпионаты сервер сохранит сам.',
    usrRolesAutosaveHint: 'Роль сохраняется сразу при нажатии «Добавить» или удалении.',
    usrForbidden: 'Нет доступа: роль выше вашей, чужой чемпионат или пользователь с более высокой ролью',
    usrNoPlayerRole: 'Пользователь без игрока не может быть игроком.',
    usrLinkPlayer: 'Привязать игрока',
    usrUnlinkPlayer: 'Отвязать игрока',
    usrUnlinkPlayerText: 'Отвязать {name} от этого аккаунта?',
    usrLinkError: 'Не удалось привязать игрока',
    usrUnlinkError: 'Не удалось отвязать игрока',
    usrPickPlayerTitle: 'Привязать игрока',
    usrPlayerSearchPh: 'Фамилия или имя',
    usrAlreadyLinked: 'Уже привязан',
    usrCreate: 'Создать пользователя',
    usrNewUser: 'Новый пользователь',
    usrPassword: 'Пароль',
    usrConfirmPassword: 'Повтор пароля',
    usrPasswordPh: 'Минимум 8 символов',
    usrPhonePh: '+7 999 123-45-67',
    usrPasswordOrPhone: 'Нужен пароль или телефон',
    usrPasswordMin: 'Пароль должен быть не меньше 8 символов',
    usrPasswordMismatch: 'Пароли не совпадают',
    usrLoginRequired: 'Укажите логин',
    usrNameRequired: 'Укажите имя',
    usrFamilyRequired: 'Укажите фамилию',
    usrPhoneInvalid: 'Неправильно введен телефон',
    usrChampSearchPh: 'Поиск чемпионата',
    usrChampsSelected: 'Выбрано: {count}',
    usrAddAssignment: 'Добавить',
    usrSelectRole: 'Роль',
    usrSelectChamp: 'Чемпионат',
    usrSelectTeam: 'Команда',
    usrPickTeam: 'Выбрать команду',
    usrPickTeamTitle: 'Назначить команду',
    usrTeamSearchPh: 'Название команды',
    usrAssignmentExists: 'Такое назначение уже есть',
    usrChampRequired: 'Выберите чемпионат для этой роли',
    usrChampNoAccess: 'Нет прав на изменение команды этого чемпионата',
    usrTeamRequired: 'Для капитана и вице-капитана нужна команда',
    usrNoAssignments: 'Назначений нет',
    usrAssignmentsSelected: 'Назначений: {count}',
    usrRemoveAssignment: 'Удалить назначение',
    usrAlreadyAssignedTeam: 'Команда уже назначена',
    roleGuest: 'Пользователь',
    rolePlayer: 'Игрок',
    roleCaptain: 'Капитан',
    roleViceCap: 'Вице-капитан',
    roleAdministrator: 'Администратор',
    roleHead: 'Глава',
    roleRoot: 'Root',
    roleOperator: 'Оператор',
    roleJournalist: 'Журналист',
    rolePhotographer: 'Фотограф',
    roleDoctor: 'Врач',
    roleInspector: 'Инспектор',
    roleReferee: 'Судья',
    msStaff: 'Сотрудники',
    msStaffSearch: 'Найти сотрудника',
    msStaffEmpty: 'Сотрудники не найдены',
    msPool: 'Выбранные сотрудники',
    msPoolEmpty: 'Список пуст — выберите сотрудника сверху',
    msPoolHint: 'Нажмите на сотрудника, затем на «+» на матче, или перетащите карточку',
    msMatches: 'Грядущие матчи',
    msMatchesHint: 'Несыгранные матчи на 7 следующих календарных дней',
    msMatchesEmpty: 'Матчей на ближайшие 7 дней нет',
    msNoStadium: 'Без стадиона',
    msNoStaff: 'Персонал не назначен',
    msAssignHint: 'Нажмите «+» или перетащите, чтобы назначить: {name}',
    msUnassignHint: 'Убрать {name} с матча',
    msInspectorHint: 'Инспектор есть в списке сотрудников, но на матч не назначается',
    msAlreadyAssigned: '{name} уже назначен на этот матч',
    msSlotsFull: 'На этом матче нет свободного слота для роли «{role}»',
    msCannotAssign: 'Этого сотрудника нельзя назначить на матч',
    msRefereePickTitle: 'Тип рефери',
    msRefereeMain: 'Главный судья',
    msRefereeAssistant1: 'Первый помощник',
    msRefereeAssistant2: 'Второй помощник',
    msRefereeTimekeeper: 'Хронометрист',
    msRefereeLine: 'Линейный судья',
    msRemoveMatch: 'Убрать матч из выборки',
    msRemoveStaff: 'Убрать сотрудника из пула',
    msRestoreAll: 'Показать все матчи',
    msLoading: 'Загрузка назначений',
    msLoadError: 'Не удалось загрузить назначения',
    msSaved: 'Назначения сохранены',
    msSaveError: 'Не удалось сохранить назначения',
    msNoChamp: 'Выберите чемпионат в шапке, чтобы назначить персонал',
    msNeedWrite: 'Просмотр. Чтобы назначать персонал, нужны права на запись матчей',
    msVs: 'против',
    msGames: 'игр: {count}',
    capSearchPh: 'Команда, капитан, комментарий или заявка',
    capAllLeagues: 'Все лиги',
    capEmpty: 'Заявок нет',
    capEmptyHint: 'Измените фильтр или дождитесь новых заявок капитанов',
    capLoading: 'Загрузка заявок',
    capLoadingOne: 'Загрузка заявки',
    capTeam: 'Команда',
    capPlace: 'Страна / лига',
    capName: 'Название заявки',
    capDate: 'Дата',
    capStatus: 'Статус',
    capStatusAccepted: 'Подтверждена',
    capStatusDeclined: 'Отклонена',
    capStatusPartial: 'Частично принята',
    capStatusPending: 'Ждёт подтверждения',
    capFromBot: 'С бота',
    capOnlyNew: 'Показывать только новые',
    capLoadError: 'Не удалось загрузить заявки',
    capNotFound: 'Заявка не найдена',
    capManageTitle: 'Заявка #{id}',
    capInfo: 'Информация',
    capComments: 'Комментарии',
    capCounts: 'Количество',
    capPlayers: 'Игроки',
    capCaptain: 'Капитан',
    capCapComment: 'Комментарий капитана',
    capAdminComment: 'Комментарий администратора',
    capTotal: 'Всего заявлено',
    capApproved: 'Подтверждено',
    capRejected: 'Отклонено',
    capWaiting: 'Ждут подтверждения',
    capExpandAll: 'Развернуть всех игроков',
    capCollapseAll: 'Свернуть всех игроков',
    capApproveAll: 'Подтвердить всех игроков',
    capResetAll: 'Сбросить статус всех игроков',
    capCurrentRoster: 'Текущая заявка ({count})',
    capAccept: 'Подтвердить',
    capDecline: 'Отклонить',
    capSaving: 'Сохранение...',
    capActionAdd: 'Заявить',
    capActionRemove: 'Отзаявить',
    capActionChange: 'Изменить',
    capPlayerStatusPending: 'Ждёт подтверждения',
    capPlayerStatusAccepted: 'Подтверждён',
    capPlayerStatusDeclined: 'Отклонён',
    capHeight: 'Рост',
    capWeight: 'Вес',
    capBirthday: 'Дата рождения',
    capNationality: 'Национальность',
    capFoot: 'Рабочая нога',
    capPosition: 'Позиция',
    capPlayerApps: 'Участие в заявках',
    capMoreApps: 'И ещё {count}',
    capNoActiveApps: 'Активных заявок нет',
    capMore: 'Подробнее',
    capBlacklist: 'Игрок находится в чёрном списке!',
    capWarnSameNumber: 'Два игрока с одинаковым номером',
    capWarnNumberTaken: 'Данный номер занят другим игроком в заявке команды',
    capWarnAlreadyIn: 'Игрок уже есть в заявке команды',
    capCommentTitle: 'Оставить комментарий',
    capCommentPh: 'Комментарий',
    capAddComment: 'Добавить',
    capPlayerTeamsTitle: 'Команды игрока {name}',
    capLeague: 'Лига',
    capPlayerAppsEmpty: 'Активных заявок нет',
    capPlayerAppsError: 'Не удалось загрузить заявки игрока',
    capDeclineTitle: 'Отклонение заявки',
    capDeclineText: 'Изменения не будут добавлены в заявку. Вы действительно хотите отклонить заявку?',
    capDeclineText2: 'При необходимости добавьте комментарий для капитана',
    capDeclinePh: 'Причина отклонения заявки',
    capAcceptTitle: 'Подтверждение заявки',
    capAcceptText: 'Изменения будут добавлены в заявку ({decided} игроков из {total}). Вы действительно хотите принять заявку?',
    capContinue: 'Продолжить',
    capAcceptError: 'Не удалось подтвердить заявку',
    capDeclineError: 'Не удалось отклонить заявку',
    capAcceptSuccess: 'Заявка подтверждена',
    capDeclineSuccess: 'Заявка отклонена',
    capForgotDecisions: 'Вы не отметили ни одного игрока — примите или отклоните изменения по каждому игроку',
    capAcceptEmptyWarn: 'Внимание: ни один игрок не отмечен. Заявка будет подтверждена без изменений состава.',
    capRelated: 'И ещё {count} {word}',
    capRelatedOne: 'связанная команда',
    capRelatedFew: 'связанные команды',
    capRelatedMany: 'связанных команд',
    capNumber: 'Игровой номер',
    capNoPlayers: 'В этой заявке нет игроков',
    capRoster: 'Состав',
    capRosterLoading: 'Загрузка состава',
    capRosterLoadError: 'Не удалось загрузить состав',
    capRosterEmpty: 'В этой заявке нет игроков',
    capRosterEmptyHint: 'Выберите другую заявку или добавьте игроков в карточке команды',
    capRosterEmptySearchHint: 'Измените запрос или сбросьте поиск',
    matchCenter: 'Игры',
    createMatch: 'Создать игру',
    cmTitle: 'Создание матча',
    cmNeedCountry: 'Выберите страну',
    cmNeedHome: 'Выберите домашнюю команду',
    cmNeedGuest: 'Выберите гостевую команду',
    cmTeamsDifferent: 'Команды должны быть разными',
    cmCreateError: 'Не удалось создать матч',
    cmCountryNotFound: 'Страна не найдена',
    cmCountryPh: 'Выберите страну',
    cmSeasonNotFound: 'Сезон не найден',
    cmNoStages: 'Нет доступных стадий для этого сезона',
    cmStageNotFound: 'Стадия не найдена',
    cmNeedStage: 'Выберите стадию',
    cmHomeTeam: 'Домашняя команда',
    cmGuestTeam: 'Гостевая команда',
    cmLoadingTeams: 'Загрузка команд...',
    cmPickTeam: 'Нажмите, чтобы выбрать команду',
    cmNoTeams: 'В этом сезоне нет команд',
    cmCheckingDuplicates: 'Проверка на дубликаты...',
    cmDuplicatesFound: 'Найдено дублей: {count}',
    cmTour: 'Тур',
    cmStillCreate: 'Матч всё равно можно создать',
    cmStadiumNotFound: 'Стадион не найден',
    cmStadiumPh: 'Выберите стадион',
    cmRefereePh: 'Выберите судью',
    cmRefereeNotFound: 'Судья не найден',
    cmDateOptional: 'Дата (нужна, если указано время)',
    cmHalfMinutes: 'Время тайма, минуты',
    cmNetPosition: 'Позиция в сетке',
    cmNetPositionAuto: 'Авто (следующий свободный слот)',
    cmNetPositionClear: 'Сбросить',
    cmNetPositionSlot: 'Слот {slot}',
    cmNetPositionHint: 'Выберите ячейку раунда (например 1/8-1). Пары 1+2 → следующий раунд-1, 3+4 → -2',
    cmCreating: 'Создание...',
    cmClear: 'Очистить',
    gmSearchPh: 'Команда, стадион или лига',
    gmFound: 'Найдено игр: {count}',
    gmMyGames: 'Мои игры',
    gmNoLineup: 'Без состава',
    gmUnplayed: 'Незаконченные',
    gmNoDate: 'Без даты',
    gmFilterAll: 'Все игры',
    gmAllCountries: 'Все страны',
    gmAllLeagues: 'Все лиги',
    gmAllSeasons: 'Все сезоны',
    gmAllDates: 'Все даты',
    gmEmpty: 'Игры не найдены',
    gmEmptyHint: 'Измените поиск или настройки выборки',
    gmDate: 'Дата',
    gmPitch: 'Поле',
    gmPitchPlaceholder: 'Выберите поле',
    gmPitchNotFound: 'Поле не найдено',
    gmLoadMore: 'Показать ещё',
    gmResult: 'Результат',
    gmTournament: 'Информация по турниру',
    gmPlace: 'Дата и место',
    gmStaff: 'Персонал',
    gmVideos: 'Видео',
    gmPhotos: 'Фото',
    gmEvents: 'События',
    gmMainEventsOnly: 'Только основные',
    gmQuickEvents: 'Быстрые события',
    gmQuickHotkeysHint: 'Клавиши G / A / Y / R — гол, автогол, ЖК, КК. Работают вне полей ввода, без Ctrl/⌘. Enter в модалке — сохранить.',
    gmUseLiveClock: 'Сейчас',
    gmLineups: 'Составы',
    gmProtocol: 'Протокол',
    gmFillProtocol: 'Заполнить в виде протокола',
    gmFillEvents: 'Показать события',
    gmDownloadPdf: 'Скачать PDF',
    gmMessageIdle: 'Каждый блок сохраняется своей кнопкой — здесь появится результат сохранения',
    gmProtocolTimeNote: 'В этом режиме вы вносите только итоги матча, поэтому события записываются со случайными минутами, а передачи к голам назначаются случайным партнёрам. Время и ассистентов можно поправить в блоке «События» или выключить таймлайн в настройках матча — тогда в приложении минуты не показываются.',
    gmSaveLineup: 'Сохранить',
    gmLineupSaved: 'Состав сохранён',
    gmLineupSetup: 'Расстановка',
    gmSaveSetup: 'Сохранить расстановку',
    gmLineupSetupSaved: 'Расстановка сохранена',
    gmCaptainLineup: 'Состав капитана',
    gmCaptainShort: 'кап.',
    gmCaptainLineupPending: 'Есть состав, не одобрен админом',
    gmCaptainLineupHint: 'Капитан отправил заявку. Можно работать по ней; после сохранения она станет админской.',
    gmApproveLineup: 'Одобрить состав',
    gmEditSetup: 'Изменить',
    gmNoFormation: 'Схема не выбрана',
    gmLegendMvp: 'лучший игрок матча',
    gmLegendKeeper: 'вратарь',
    gmLegendDouble: 'игрок из дубля',
    gmLongPressHint: 'Зажмите строку игрока (или нажмите правой кнопкой), чтобы отметить MVP или вратаря',
    gmMarkMvp: 'Отметить MVP',
    gmUnmarkMvp: 'Снять отметку MVP',
    gmMaxMvp: 'На одну команду можно отметить не больше {count} MVP',
    gmMarkKeeper: 'Отметить вратарём',
    gmUnmarkKeeper: 'Снять отметку вратаря',
    gmSubmitProtocol: 'Внести',
    gmProtocolEmpty: 'Незаполненный протокол',
    gmProtocolFilled: 'Заполненный протокол',
    gmProtocolEmptyHint: 'Составы есть, события не заполнены — для печати',
    gmProtocolFilledHint: 'Составы и события матча',
    gmSaveChanges: 'Сохранить изменения',
    gmSetPenalties: 'Установить пенальти',
    gmEditPenalties: 'Изменить серию',
    gmDeleteMatch: 'Удалить матч',
    gmDeleteMatchError: 'Не удалось удалить матч',
    gmDeletePenalties: 'Удалить серию',
    gmPenaltiesDeleted: 'Серия пенальти удалена',
    gmMarkPostponed: 'Пометить как перенесённый',
    gmUnpostpone: 'Снять перенос',
    gmPostponed: 'Матч перенесен',
    gmAddStaff: 'Добавить персонал',
    gmAddVideo: 'Добавить видео',
    gmAddEvent: 'Добавить событие',
    gmEditEvent: 'Редактирование события',
    gmDeleteEvent: 'Удалить событие',
    gmSecondPlayer: 'Второй игрок',
    gmPlayerIn: 'Вышедший игрок',
    gmEventTime: 'Время',
    gmMinute: 'Минута',
    gmSecond: 'Секунда',
    gmMinuteRequired: 'Укажите минуту события',
    gmNeedEventPlayer: 'Укажите игрока',
    gmNeedEventPlayerIn: 'Укажите вышедшего игрока',
    gmPosition: 'Позиция',
    gmMatchNumber: 'Номер на матч',
    gmMvp: 'MVP',
    gmNotListed: 'Не заявлен',
    gmAddPhotoSet: 'Ссылка на альбом',
    gmInvalidPhotoUrl: 'Укажите корректную ссылку, например https://vk.com/album-...',
    gmSavePhotoSet: 'Сохранить альбом',
    gmDeletePhotoSet: 'Убрать альбом',
    gmUploadPhotos: 'Загрузить фото',
    gmOpenMedia: 'Открыть медиа',
    gmStatistics: 'Статистика',
    gmEnterStatistics: 'Ввести статистику',
    gmSaveStatistics: 'Сохранить статистику',
    gmExtraTime: 'Возможны дополнительные таймы',
    gmHalfTime: 'Время тайма, мин',
    gmExtraHalfTime: 'Время доп. тайма, мин',
    gmPenaltiesAvailable: 'Возможны пенальти',
    gmEnableTimeline: 'Таймлайн',
    gmTimelineHint: 'В приложении появится лента матча: голы, карточки и замены с минутой',
    gmMatchFlags: 'Настройки',
    gmPlayState: 'Ход матча',
    gmPlayStart: 'Начать матч',
    gmPlayTimeout: 'Перерыв',
    gmPlayContinue: 'Второй тайм',
    gmPlayEnd: 'Закончить матч',
    gmPlayReset: 'Сбросить',
    gmPlayExtraBreak: 'Пауза перед доп. временем',
    gmPlayExtraStart: 'Доп. время',
    gmPlayExtraTimeout: 'Перерыв доп. времени',
    gmPlayExtraSecond: 'Второй доп. тайм',
    gmPlayExtraEnd: 'Конец доп. времени',
    gmPlayStateSaved: 'Состояние матча обновлено',
    gmSaveScore: 'Проставить счёт',
    gmSaveScoreAndFinish: 'Проставить счёт и закончить матч',
    gmSaveComment: 'Сохранить комментарий',
    gmClearComment: 'Очистить комментарий',
    gmCommentPlaceholder: 'Комментарий будет виден в приложении до начала матча. Это может быть причина переноса, техпоражения или произвольная информация',
    gmScoreSaved: 'Счёт сохранён',
    gmScoreFinished: 'Счёт сохранён, матч окончен',
    gmSettingsSaved: 'Настройки матча сохранены',
    gmNoStaff: 'Персонал не назначен',
    gmNoVideos: 'Видео нет',
    gmNoPhotos: 'Фотографий нет',
    gmNoEvents: 'Событий пока нет',
    gmHome: 'Хозяева',
    gmGuest: 'Гости',
    gmPenaltiesTitle: 'Серия пенальти',
    gmPenaltiesSaved: 'Пенальти сохранены',
    gmTournamentSaved: 'Турнир сохранён',
    gmPlaceSaved: 'Дата и место сохранены',
    gmTimeNeedsDate: 'Чтобы сохранить время, сначала укажите дату матча',
    gmSavePlace: 'Сохранить дату и время',
    gmStaffSaved: 'Персонал сохранён',
    gmEventSaved: 'Событие сохранено',
    gmEventDeleted: 'Событие удалено',
    gmVideoSaved: 'Видео сохранено',
    gmVideoDeleted: 'Видео удалено',
    gmStatsSaved: 'Статистика сохранена',
    gmLoadError: 'Не удалось загрузить игру',
    gmSaveError: 'Не удалось сохранить изменения',
    gmNeedChamp: 'Выберите чемпионат',
    gmVideoUrl: 'Ссылка на видео',
    gmInvalidVideoUrl: 'Укажите корректную ссылку, например https://vkvideo.ru/...',
    gmVideoName: 'Название',
    gmVideoType: 'Тип видео',
    gmPickStaff: 'Выберите сотрудника',
    gmStaffSearch: 'Имя, логин или должность',
    gmAllStaffRoles: 'Все должности',
    gmStaffEmpty: 'Сотрудники не найдены',
    gmCountry: 'Страна',
    gmStage: 'Стадия',
    gmDatetime: 'Дата и время',
    gmAddPhotos: 'Добавить фото',
    evt_goal: 'Гол!',
    evt_assist: 'Передача',
    evt_yellow_card: 'Жёлтая карточка',
    evt_red_card: 'Удаление',
    evt_penalty_kick: 'Пенальти!',
    evt_penalty_kick_goal: 'Забитый пенальти',
    evt_penalty_kick_no_goal: 'Незабитый пенальти',
    evt_autogoal: 'Автогол',
    evt_match_begin: 'Матч начался',
    evt_timeout: 'Перерыв',
    evt_match_end: 'Матч окончен',
    evt_penalty_series: 'Серия пенальти',
    evt_second_yellow_card: 'Вторая желтая карточка',
    evt_main_time_end: 'Конец основного времени',
    evt_substitution: 'Замена',
    evt_ten_meters_goal: 'Забитый 10м',
    evt_ten_meters_nogoal: 'Незабитый 10м',
    evt_six_meters_penalty_goal: 'Забитый 6м пенальти',
    evt_six_meters_penalty_nogoal: 'Незабитый 6м пенальти',
    evt_goal_assist: 'Гол+пас',
    evt_free_event: 'Свободное событие',
    evt_shtanga: 'Штанга',
    evt_perekladina: 'Перекладина',
    evt_shot: 'Удар по воротам',
    evt_miss: 'Промах',
    evt_corner: 'Угловой',
    evt_dangerous_moment: 'Опасный момент',
    evt_foul: 'Нарушение',
    championship: 'Чемпионат',
    championshipPlaceholder: 'Выберите чемпионат',
    championshipNotFound: 'Чемпионат не найден',
    championshipSearchPh: 'Поиск чемпионата',
    championshipsLoading: 'Загрузка чемпионатов...',
    championshipsEmpty: 'Чемпионаты не найдены',
    championshipsLoadError: 'Не удалось загрузить чемпионаты',
    champNoAccess: 'В этом чемпионате нет доступа к разделу',
    league: 'Лига',
    leaguePlaceholder: 'Выберите лигу',
    leagueNotFound: 'Лига не найдена',
    yesterday: 'Вчера',
    today: 'Сегодня',
    tomorrow: 'Завтра',
    time: 'Время',
    match: 'Матч',
    stadium: 'Стадион',
    status: 'Статус',
    noMatches: 'Похоже в это день матчей нет...',
    loadingMatches: 'Загрузка матчей',
    matchPostponed: 'Матч перенесен',
    technicalDefeat: 'ТП',
    halfTime: 'Перерыв',
    matchFinished: 'Матч окончен',
    matchNotStarted: 'Матч не начался',
    firstHalf: 'Идет 1-ый тайм',
    extraFirstHalf: 'Доп. время. Идет 1-ый тайм',
    secondHalf: 'Идет 2-ый тайм',
    extraSecondHalf: 'Доп. время. Идет 2-ый тайм',
    extraBreak: 'Пауза перед доп. временем',
    extraHalfTime: 'Перерыв доп. времени',
    success: 'Успешно',
    error: 'Ошибка',
    cancel: 'Отменить',
    add: 'Добавить',
    next: 'Далее',
    done: 'Готово',
    save: 'Сохранить',
    delete: 'Удалить',
    close: 'Закрыть',
    referee: 'Судья',
    dateTime: 'Дата и время',
    player: 'Игрок',
    team: 'Команда',
    goal: 'Гол',
    assist: 'Пас',
    comment: 'Комментарий',
    evtGoal: 'Гол',
    evtPenScored: 'Забитый пенальти',
    evtPenMissed: 'Незабитый пенальти',
    evtOG: 'Автогол',
    evt10Scored: 'Забитый 10м',
    evt10Missed: 'Незабитый 10м',
    evt6Scored: 'Забитый 6м',
    evt6Missed: 'Незабитый 6м',
    evtYC: 'ЖК',
    evtRC: 'КК',
    evtPenScoredShort: 'Пен (забит)',
    evtPenMissedShort: 'Пен (незабит)',
    evt10ScoredShort: '10м (забит)',
    evt10MissedShort: '10м (незабит)',
    evt6ScoredShort: '6м (забит)',
    evt6MissedShort: '6м (незабит)',
    evt2YC: '2-я ЖК',
    evtSub: 'Замена',
    evtShtanga: 'Штанга',
    evtPerekladina: 'Перекладина',
    sysKickOff: '▶ Начало матча',
    sysHalfTime: '⏸ Перерыв',
    sysFullTime: '🏁 Конец матча',
    posFW: 'НАП',
    posMF: 'ПЗ',
    posDF: 'ЗАЩ',
    posGK: 'ВРТ',
    posUNI: 'УНВ',
    mrTitle: 'Матч. Изменение результатов.',
    mrMedia: 'Медиа матча',
    mrSaveMeta: 'Сохранить дату, время, стадион, судью',
    mrTechLose: 'Тех. поражение',
    mrPostpone: 'Перенос',
    mrMinutes: 'Указать минуты',
    mrMinutesCount: 'Минуты ({count})',
    mrOnlineMatch: 'Онлайн матч',
    mrLoading: 'Загрузка матча',
    mrEventTimeline: 'Время событий',
    mrStadiumNotFound: 'Стадион не найден',
    mrRefereeNotFound: 'Судья не найден',
    mrDateNotSet: 'Не указана',
    mrHours: 'Часы',
    mrMinutesField: 'Минуты',
    mrPresence: 'П*',
    mrOG: 'АГ',
    mrYC: 'ЖК',
    mrRC: 'КК',
    mrTotal: 'Всего',
    mrNoSquad: 'Состав команды не заявлен',
    mrHintPresence: 'присутствие на матче',
    mrHintGoals: 'голы',
    mrHintAssists: 'голевые передачи',
    mrHintOG: 'автоголы',
    mrHintYC: 'жёлтые карточки',
    mrHintRC: 'красные карточки',
    mrHintMvp: 'Нажмите на фамилию игрока, чтобы отметить его MVP или вратарём',
    mrWarning: 'Предупреждение',
    mrCommentTitle: 'Оставить комментарий к матчу',
    mrPostponeTitle: 'Отметить матч перенесенным',
    mrPostponePh: 'Укажите причину или дату переноса при необходимости',
    mrTechLoseTitle: 'Тех. поражение',
    mrTechLosePh: 'Укажите причину технического поражения при необходимости',
    mrTechHomeWins: 'Победа хозяев 5:0',
    mrTechGuestWins: 'Победа гостей 0:5',
    mrScore: 'Счет',
    mrEventsTitle: 'Указать минуты событий',
    mrEventType: 'Тип события',
    mrSelect: '-- Выберите --',
    mrAssistOptional: 'Ассистент (необязательно)',
    mrNoAssist: '-- Без ассистента --',
    mrMinute: 'Минута',
    mrSecond: 'Секунда',
    mrAddedEvents: 'Добавленные события ({count})',
    mrMin: 'Мин.',
    mrType: 'Тип',
    mrEventsAllSet: '✓ Все события указаны. При сохранении будут использованы указанные минуты.',
    mrEventsNotAll: '⚠ Не все события указаны. Необходимо добавить минуты для всех голов, автоголов, ЖК и КК, указанных в таблице.',
    mrClearAll: 'Очистить все',
    mrResultsSaved: 'Результаты матча успешно изменены.',
    mrCommentSaved: 'Комментарий к матчу успешно добавлен.',
    mrPlayerNotListed: 'Игрок {name} ( {team} ) совершил события, но не заявлен на матч.',
    mrPlayersNotListed: 'Игроки {name} ( {team} ) и еще {count} совершили события, но не заявлены на матч.',
    mrManualDqUntil: 'Ручная дисквалификация до {date}',
    mrManualDqMatches: 'Ручная дисквалификация на {count} матч(а/ей)',
    mrGoalsMismatch: 'Количество голов команды {team} ({goals}) не совпадает с счетом ({score})',
    mrDqInSquad: 'В активной заявке есть дисквалифицированные игроки: {list}',
    mrPlayerDq: 'игрок дисквалифицирован',
    mrDouble: '(Д)',
    mrKeeperTag: '(ВРТ)',
    mrKeeperShort: 'ВРТ',
    mrDqTag: '(ДИСКВ)',
    mrGoalkeeper: 'Вратарь',
    mrPresenceName: 'Присутствие',
    blTitle: 'Черный список',
    blAdd: 'Добавить в список',
    blAddShort: 'Добавить',
    blSearchPh: 'Имя, фамилия или отчество',
    blEmpty: 'В чёрном списке никого нет',
    blEmptyHint: 'Добавьте игрока или измените поиск',
    blLoading: 'Загрузка черного списка',
    blDate: 'Дата',
    blReason: 'Комментарий',
    blPlayer: 'Игрок',
    blAddedBy: 'Кто добавил',
    blFound: 'Найдено: {count}',
    blNotSet: 'Не указано',
    blDeleteTitle: 'Удаление из черного списка',
    blDeleteConfirm: 'Вы действительно хотите удалить игрока из черного списка?',
    blNew: 'Новый игрок в списке',
    blEdit: 'Игрок в чёрном списке',
    blPickPlayer: 'Выбрать игрока',
    blNeedPlayer: 'Выберите игрока',
    blNeedComment: 'Укажите комментарий',
    blAlreadyListed: 'Уже в чёрном списке',
    blLoadError: 'Не удалось загрузить чёрный список',
    blSaveError: 'Не удалось сохранить изменения',
    blRemoveError: 'Не удалось удалить игрока из списка',
    blSaved: 'Изменения сохранены',
    blNotFound: 'Игрок не найден в черном списке',
    blNoPlayers: 'Игроки не найдены',
    blReasonPh: 'Укажите причину',
    blAddConfirm: 'Добавить в список',
    stTitle: 'Управление стадиями',
    stCreate: 'Создать стадию',
    stCreateMultiple: 'Создать несколько',
    stCreateFirst: 'Создать первую стадию',
    stLoading: 'Загрузка стадий...',
    stNoStages: 'Стадии не найдены для выбранного сезона',
    stSelectPrompt: 'Выберите лигу и сезон для просмотра стадий',
    stGenerate: 'Сгенерировать матчи',
    stGenerateShort: 'Генерация',
    stCreateMatch: 'Создать матч',
    stCreateMatchShort: 'Матч',
    stSeason: 'Сезон',
    stSeasonPlaceholder: 'Выберите сезон',
    stSeasonNotFound: 'Сезон не найден',
    stNoMatches: 'Матчи не найдены',
    stStatusFinished: 'Завершен',
    stStatusLive: 'Идет',
    stStatusNotStarted: 'Не начат',
    stStatusUnknown: 'Не определен',
    stDeleteTitle: 'Удаление стадии',
    stDeleteConfirm: 'Вы уверены, что хотите удалить эту стадию?',
    stDeleteHasMatches: 'Невозможно удалить стадию. В ней содержится {count} матчей. Сначала удалите все матчи.',
    stDeleteError: 'Ошибка при удалении стадии',
    stCreateTitle: 'Создание стадии',
    stName: 'Название стадии',
    stNamePh: 'Например: 1 Тур, Полуфинал, Группа А',
    stShortName: 'Короткое название (опционально)',
    stShortPh: 'Например: 1Т, ПФ',
    stPlayoff: 'Стадия плей-офф',
    stCreating: 'Создание...',
    stCreateBtn: 'Создать стадию',
    stNameRequired: 'Введите название стадии',
    stCreated: 'Стадия успешно создана!',
    stCreateError: 'Ошибка при создании стадии',
    stEditTitle: 'Редактирование стадии',
    stPriority: 'Приоритет (опционально)',
    stPriorityPh: 'Порядковый номер',
    stSaving: 'Сохранение...',
    stSaveChanges: 'Сохранить изменения',
    stUpdated: 'Стадия успешно обновлена!',
    stUpdateError: 'Ошибка при обновлении стадии',
    stMultiTitle: 'Создание нескольких стадий',
    stMultiCount: 'Количество стадий',
    stMultiHint: 'Будет создано указанное количество стадий с автоматической нумерацией',
    stMultiBase: 'Базовое название',
    stMultiBaseHint: 'Стадии будут названы: «1 {name}», «2 {name}» и т.д.',
    stMultiCreate: 'Создать {count} стадий',
    stMultiAmountError: 'Введите количество от 1 до 50',
    stMultiNameError: 'Введите базовое название',
    stMultiCreated: 'Успешно создано {count} стадий!',
    stMultiError: 'Ошибка при создании стадий',
    noChampionship: 'Без чемпионата',
    lcSubtitle: 'Настройка 1, 2 и 3 места для выбранной лиги и сезона.',
    lcLoadLeaguesError: 'Не удалось загрузить список лиг',
    lcLoadDataError: 'Не удалось загрузить данные по призерам лиги',
    lcTeamAlreadyPlace: 'Команда «{name}» уже выбрана для {place} места',
    lcSelectLeagueSeason: 'Выберите лигу и сезон',
    lcDuplicateTeams: 'Нельзя назначить одну и ту же команду на несколько призовых мест',
    lcSaved: 'Призеры успешно сохранены',
    lcSaveError: 'Не удалось сохранить призеров',
    lcNotSelected: 'Не выбрано',
    lcTeamNotSelected: 'Команда не выбрана',
    lcPlace1: '1 место',
    lcPlace2: '2 место',
    lcPlace3: '3 место',
    lcTeamNotFound: 'Команда не найдена',
    lcTeamPlaceholder: 'Выберите команду',
    lcSelectPrompt: 'Выберите страну, лигу и сезон',
    lcSelectHint: 'После выбора загрузятся текущие призеры и список команд для настройки 1–3 мест.',
    lcLoading: 'Загрузка призеров и команд...',
    ttSubtitle: 'Выберите страну, лигу, сезон, тур и схему. Нажмите на игрока на поле, чтобы заменить его.',
    ttLoadError: 'Не удалось загрузить составы тура',
    ttSelectLeagueSeasonTour: 'Выберите страну, лигу, сезон и тур',
    ttSaved: 'Сборная тура успешно сохранена',
    ttSaveError: 'Не удалось сохранить сборную тура',
    ttLoading: 'Загрузка данных сборной тура...',
    ttSelectHint: 'После выбора будет загружена сборная тура и список игроков лиги.',
    ttPlayersInTeam: 'Игроки в сборной',
    ttSelect: 'Выбрать',
    ttNotSelected: 'Не выбран',
    ttChange: 'Изменить',
    ttPickTitle: 'Выбор игрока для позиции #{n}',
    ttSearching: 'Поиск...',
    ttSearch: 'Искать',
    ttLoadingPlayers: 'Загрузка игроков...',
    ttNoPlayers: 'Игроки не найдены',
    ttSearchHint: 'Введите запрос и нажмите «Искать»',
    ttNoTeam: 'Без команды',
    ttTour: 'Тур',
    ttTourPlaceholder: 'Выберите тур',
    ttTourNotFound: 'Тур не найден',
    ttScheme: 'Схема',
    ttSchemeNotFound: 'Схема не найдена',
    ttFieldAlt: 'Футбольное поле',
    dqTitle: 'Дисквалификации',
    dqAutoTitle: 'Автоматические',
    dqCurrentTitle: 'Текущие дисквалификации',
    dqCurrentTab: 'Текущие',
    dqAddAutoShort: 'Авто',
    dqAddShort: 'Дисквал.',
    dqStatus: 'Статус',
    dqLeague: 'Лига',
    dqYC: 'ЖК',
    dqYCCount: 'ЖК',
    dqPlayer: 'Игрок',
    dqTournament: 'Турнир',
    dqTournamentPh: 'Выберите турнир',
    dqGames: 'Игры',
    dqEnabled: 'Включен',
    dqDisabled: 'Выключен',
    dqMode: 'Режим',
    dqModeMatches: 'Игры',
    dqModeTime: 'Время',
    dqUntilDate: 'До',
    dqComment: 'Комментарий',
    dqCommentPh: 'Например: грубая игра',
    dqSearchPh: 'Поиск по игроку или турниру',
    dqAddAuto: 'Добавить дисквалификатор',
    dqEditAuto: 'Изменить дисквалификатор',
    dqNewAuto: 'Новый дисквалификатор',
    dqAdd: 'Добавить дисквалификацию',
    dqNewManual: 'Новая дисквалификация',
    dqEditManual: 'Изменить дисквалификацию',
    dqPickPlayer: 'Выбрать игрока',
    dqChangePlayer: 'Изменить игрока',
    dqPickTitle: 'Выбор игрока',
    dqAuto: 'Авто',
    dqAutoReadonlyHint: 'Автоматические дисквалификации нельзя изменить или удалить.',
    dqAutoEmpty: 'Автоматические дисквалификаторы не настроены',
    dqAutoEmptyHint: 'Добавьте дисквалификатор для лиги',
    dqCurrentEmpty: 'Текущих дисквалификаций нет',
    dqCurrentEmptyHint: 'Измените запрос или добавьте ручную дисквалификацию',
    dqLoading: 'Загрузка дисквалификаций',
    dqLoadMore: 'Показать ещё',
    dqFound: 'Найдено: {count}',
    dqNoTournaments: 'Нет доступных турниров',
    dqNoLeaguesInCountry: 'В этой стране нет доступных лиг',
    dqNeedTournament: 'Выберите лигу',
    dqNeedPlayer: 'Выберите игрока',
    dqNeedYC: 'Укажите количество жёлтых карточек',
    dqInvalidMatches: 'Укажите корректное количество игр',
    dqNeedEndDate: 'Укажите дату окончания',
    dqLoadError: 'Не удалось загрузить данные дисквалификаций',
    dqSaveError: 'Не удалось сохранить изменения',
    dqAddError: 'Не удалось добавить дисквалификацию',
    dqRemoveError: 'Не удалось удалить дисквалификацию',
    dqLoadPlayersError: 'Не удалось загрузить игроков',
    dqSaved: 'Изменения сохранены',
    dqCreated: 'Дисквалификация добавлена',
    dqAutoCreated: 'Дисквалификатор добавлен',
    dqRemoved: 'Удалено',
    dqUntil: 'До {date}',
    dqPlayerFallback: 'Игрок #{id}',
    dqNotFound: 'Запись не найдена',
    dqDeleteAutoTitle: 'Удалить дисквалификатор?',
    dqDeleteAutoText: 'Настройки автоматической дисквалификации для этой лиги будут сброшены.',
    dqDeleteTitle: 'Удалить дисквалификацию?',
    dqDeleteConfirm: 'Ручная дисквалификация будет удалена. Это действие нельзя отменить.',
    twStatus: 'Статус',
    twLeague: 'Лига',
    twFrom: 'Начало',
    twTo: 'Конец',
    twPeriod: 'Период',
    twRange: 'с {from} по {to}',
    twRangeTime: 'с {from} {fromTime} по {to} {toTime}',
    twEnabled: 'Включен',
    twDisabled: 'Выключен',
    twNotSet: 'Не задано',
    twDayFrom: 'С какого дня',
    twTimeFrom: 'С какого часа',
    twDayTo: 'До какого дня',
    twTimeTo: 'До какого часа',
    twDayPh: 'Выберите день',
    twLeaguePh: 'Выберите лигу',
    twAdd: 'Добавить окно',
    twAddShort: 'Окно',
    twCreate: 'Создать трансферное окно',
    twNew: 'Новое трансферное окно',
    twEdit: 'Изменить трансферное окно',
    twEmpty: 'Включённых трансферных окон нет',
    twEmptyHint: 'Добавьте окно заявок для лиги',
    twLoading: 'Загрузка трансферных окон',
    twLoadError: 'Не удалось загрузить трансферные окна',
    twSaveError: 'Не удалось сохранить трансферное окно',
    twRemoveError: 'Не удалось удалить трансферное окно',
    twSaved: 'Изменения сохранены',
    twNeedLeague: 'Выберите лигу',
    twNeedCountry: 'Выберите страну',
    twNeedDay: 'Выберите день',
    twNeedTime: 'Укажите время',
    twNoLeagues: 'Нет лиг без включённого окна',
    twNoCountries: 'Нет доступных стран',
    twPickCountryFirst: 'Сначала выберите страну',
    twNoLeaguesInCountry: 'В этой стране нет лиг без включённого окна',
    twSearchPh: 'Поиск по названию лиги',
    twFound: 'Найдено: {count}',
    twNotFound: 'Трансферное окно не найдено',
    twDeleteTitle: 'Удалить трансферное окно?',
    twDeleteText: 'Расписание окна заявок для этой лиги будет сброшено.',
    twScheduleTitle: 'Расписание окна',
    twSeasonTitle: 'Окно сезона',
    twSeasonHint: 'Открыто ли трансферное окно у активного сезона',
    twSeasonOpen: 'Открыто',
    twSeasonClosed: 'Закрыто',
    twSeasonNone: 'Нет сезона',
    twSeasonEmpty: 'Лиг нет',
    twSeasonEmptyHint: 'В этом чемпионате пока нет лиг',
    twSeasonsTitle: 'Сезоны лиги',
    twSeasonName: 'Сезон',
    twSeasonActive: 'Активный',
    twOpenWindow: 'Открыть',
    twCloseWindow: 'Закрыть',
    twSeasonLoadError: 'Не удалось загрузить сезоны',
    twSeasonSaveError: 'Не удалось изменить трансферное окно сезона',
    twNoSeasons: 'Сезонов нет',
    twNoSeasonsHint: 'Сначала создайте сезон в разделе турниров',
    twDay0: 'Воскресенье',
    twDay1: 'Понедельник',
    twDay2: 'Вторник',
    twDay3: 'Среда',
    twDay4: 'Четверг',
    twDay5: 'Пятница',
    twDay6: 'Суббота',
    twDayFrom0: 'воскресенья',
    twDayFrom1: 'понедельника',
    twDayFrom2: 'вторника',
    twDayFrom3: 'среды',
    twDayFrom4: 'четверга',
    twDayFrom5: 'пятницы',
    twDayFrom6: 'субботы',
    twDayTo0: 'воскресенье',
    twDayTo1: 'понедельник',
    twDayTo2: 'вторник',
    twDayTo3: 'среду',
    twDayTo4: 'четверг',
    twDayTo5: 'пятницу',
    twDayTo6: 'субботу',
    mmSelectTitle: 'Выбор матча для медиа',
    mmSelectPrompt: 'Выберите чемпионат, лигу, сезон и стадию',
    mmStage: 'Стадия / Тур',
    mmStagePlaceholder: 'Выберите стадию',
    mmStageNotFound: 'Стадия не найдена',
    mmMedia: 'Медиа',
    mmTitle: 'Медиа матча #{id}',
    mmSummary: 'Видео: {videos} из 3, фото: {photos}',
    mmSummaryTotal: 'Видео: {videos} из 3, фото: {photos} из {total}',
    mmBack: 'Назад к матчу',
    mmLoadError: 'Не удалось загрузить данные медиа матча',
    mmPhotosLoadError: 'Не удалось загрузить фотографии матча',
    mmLoading: 'Загрузка медиа...',
    mmVideos: 'Видео',
    mmSaveVideos: 'Сохранить видео',
    mmVideosSaved: 'Видео успешно сохранены',
    mmVideosSaveError: 'Не удалось сохранить ссылки на видео',
    mmBroadcast: '1. Трансляция',
    mmReview: '2. Обзор',
    mmExtra: '3. Дополнительно',
    mmUrlPh: 'https://...',
    mmVkTitle: 'Импорт из ВКонтакте',
    mmVkPh: 'Ссылка на альбом ВК...',
    mmLoad: 'Загрузить',
    mmLoadingGeneric: 'Загрузка...',
    mmVkLoadError: 'Не удалось загрузить альбом ВК',
    mmVkAlbumLoading: 'Загрузка альбома...',
    mmVkAlbumTitle: '{title} — {count} фото',
    mmVkCount: '{count} фото',
    mmAddToMatch: 'Добавить к матчу',
    mmAdding: 'Добавление...',
    mmVkAdded: 'Фото из ВК успешно добавлены к матчу',
    mmVkAddError: 'Не удалось добавить фото из ВК',
    mmPhotos: 'Фотографии',
    mmAddPhotos: 'Добавить фото',
    mmUploading: 'Загрузка...',
    mmPhotosLoading: 'Загрузка фото...',
    mmNoPhotos: 'Фотографий пока нет',
    mmPhotoDeleted: 'Фото удалено',
    mmPhotoDeleteError: 'Не удалось удалить фото',
    mmPhotosUploaded: 'Фото успешно добавлены',
    mmPhotosUploadError: 'Не удалось загрузить фото',
    mmLoadMore: 'Загрузить еще',
    mmDeletePhotoTitle: 'Удаление фото',
    mmDeletePhotoConfirm: 'Удалить это фото?',
    tmAdd: 'Добавить команду',
    tmAddShort: 'Команда',
    tmSearchPh: 'Поиск по имени или стране',
    tmFound: 'Найдено команд: {count}',
    tmShown: '(показано {shown} из {count})',
    tmLoading: 'Загрузка команд...',
    tmLoadError: 'Ошибка загрузки команд: {error}',
    tmNoResults: 'По запросу «{query}» ничего не найдено',
    tmEmpty: 'Команды не найдены',
    tmUntitled: 'Без названия',
    tmPlayers: 'Игроков',
    tmPlayersBlock: 'Игроки',
    tmPlayerSearchPh: 'Имя, фамилия или номер',
    tmNoPlayerSearch: 'Никого не найдено',
    tmAdded: 'Команда успешно добавлена',
    tmSessionExpired: 'Сессия истекла. Пожалуйста, войдите заново.',
    tmSaveError: 'Ошибка при сохранении команды',
    tmAddTitle: 'Добавить новую команду',
    tmListName: 'Название',
    tmName: 'Название команды',
    tmNameRequired: 'Название команды обязательно',
    tmNamePh: 'Введите название команды',
    tmPlayer: 'Игрок',
    tmShort: 'Короткое название (макс. 3 буквы)',
    tmShortError: 'Короткое название не должно превышать 3 буквы',
    tmLogo: 'Логотип команды',
    tmPickImage: 'Выберите изображение',
    tmImageHint: 'PNG, JPG, GIF до 5MB',
    tmNeedImage: 'Пожалуйста, выберите изображение',
    tmFileSize: 'Размер файла не должен превышать 5MB',
    tmLogoDefault: 'Если логотип не добавлен, будет использован логотип по умолчанию',
    tmRemoveLogo: 'Удалить',
    tmEditTitle: 'Редактировать команду',
    tmChangeLogo: 'Изменить логотип',
    tmLogoDefaultHint: 'Нажмите на крестик, чтобы поставить логотип по умолчанию',
    tmUpdated: 'Команда успешно обновлена',
    tmUpdateError: 'Ошибка при обновлении команды',
    tmEmptyHint: 'Измените запрос или добавьте новую команду',
    tmNewTeam: 'Новая команда',
    tmEditTeam: 'Редактировать команду',
    tmCreated: 'Команда создана',
    tmShortName: 'Короткое имя',
    tmDoublesTitle: 'Связанные составы',
    tmDoublesHint: 'Основная команда и дубль. Можно строить цепочку: основа → -2 → -3.',
    tmDoublesAfterCreate: 'Связь с дублем или основной командой можно указать после создания команды.',
    tmDoubleParent: 'Основная команда',
    tmDoubleReserve: 'Дубль',
    tmDoublePickParent: 'Указать основную команду',
    tmDoublePickReserve: 'Указать дубль',
    tmDoubleSearchPh: 'Найти команду',
    tmDoubleUnlink: 'Снять связь',
    tmDoubleLinked: 'Связь составов сохранена',
    tmDoubleUnlinked: 'Связь составов снята',
    tmDoubleLinkError: 'Не удалось привязать дубль',
    tmDoubleUnlinkError: 'Не удалось снять связь',
    tmDoubleConflictTitle: 'Конфликт связей',
    tmDoubleConflictText: 'У одной из команд уже есть другая связь. Перезаписать?',
    tmDoubleConflictGeneric: 'Конфликт связей дубля',
    tmDoubleConflictMainHasReserve: 'У основной команды уже есть дубль #{id}',
    tmDoubleConflictDoubleHasParent: 'У дубля уже указана основная команда #{id}',
    tmDoubleConflictDoubleIsReserve: 'Эта команда уже дубль у: {names}',
    tmDoubleConflictMainHasChild: 'К основной команде уже привязан дубль: {names}',
    tmDoubleReplace: 'Перезаписать',
    tmCountryRequired: 'Выберите чемпионат',
    tmNumber: 'Номер',
    tmAddPlayer: 'Добавить игрока',
    tmEmptyPlayers: 'Игроки ещё не добавлены',
    tmOfficials: 'Официальные представители',
    tmAddOfficial: 'Новый представитель',
    tmNewOfficial: 'Новый представитель',
    tmEditOfficial: 'Представитель',
    tmEmptyOfficials: 'Представители ещё не добавлены',
    tmOfficialNotFound: 'Представитель не найден',
    tmOfficialCreated: 'Представитель добавлен',
    tmRole: 'Роль',
    tmRolePh: 'Главный тренер',
    tmBirthDate: 'Дата рождения',
    tmDeleteOfficialTitle: 'Удалить представителя?',
    tmDeleteOfficialText: 'Представитель будет удалён. Это действие нельзя отменить.',
    mtBack: 'Назад к командам',
    mtBackList: 'Вернуться к списку команд',
    mtLoading: 'Загрузка данных команды...',
    mtLoadError: 'Ошибка загрузки данных команды',
    mtNotFound: 'Команда не найдена',
    mtEdit: 'Редактировать',
    mtLeagues: 'Лиги, в которых играет команда',
    mtAddToLeague: 'Добавить в лигу',
    mtNoLeagues: 'Команда пока не присоединена ни к одной лиге',
    mtRoster: 'Состав команды',
    mtAddPlayer: 'Добавить игрока',
    mtAddExcel: 'Добавить из Excel',
    mtPickApp: 'Выберите заявку',
    mtAppPlayers: '{name} ({count} игроков)',
    mtAppFallback: 'Заявка #{id}',
    mtSort: 'Сортировка',
    mtSortNumber: 'По игровому номеру',
    mtSortPosition: 'По позиции',
    mtSortFamily: 'По фамилии',
    mtPosition: 'Позиция',
    mtBirthday: 'Дата рождения',
    mtUnenroll: 'Отзаявить',
    mtNoPlayers: 'Нет игроков в этой заявке',
    mtPickAppHint: 'Выберите заявку для просмотра состава',
    mtNoApps: 'У команды пока нет заявок',
    mtRemoveLeagueTitle: 'Отключение от лиги',
    mtRemoveLeagueConfirm: 'Отключить команду от «{league}», сезон {season}?',
    mtRemovedLeague: 'Команда успешно отключена от лиги',
    mtRemoveLeagueError: 'Ошибка при отключении от лиги',
    mtRemovePlayerTitle: 'Удалить из заявки',
    mtRemovePlayerConfirm: 'Удалить «{name}» из заявки «{app}»?',
    mtRemovedPlayer: 'Игрок удалён из заявки',
    mtRemovePlayerError: 'Не удалось удалить игрока из заявки',
    mtNoUser: 'Ошибка: данные пользователя не загружены',
    mtEditDenied: 'Вы можете менять данные только созданных вашей лигой игроков. Для изменения данных обратитесь к разработчикам приложения',
    mtMissingData: 'Отсутствуют необходимые данные',
    mtBadNumber: 'Некорректный номер игрока',
    mtNumberChanged: 'Номер успешно изменен',
    mtNumberChangeError: 'Произошла ошибка при изменении номера игрока',
    mtTimeout: 'Превышено время ожидания ответа сервера',
    mtServerError: 'Ошибка сервера: {status}',
    atlTitle: 'Добавить команду в лигу',
    atlLoadError: 'Ошибка загрузки лиг',
    atlNoSeasons: 'У этой лиги нет доступных сезонов',
    atlSeasonsError: 'Ошибка загрузки сезонов',
    atlAdded: 'Команда успешно добавлена в лигу',
    atlAddError: 'Ошибка при добавлении команды в лигу',
    atlAdd: 'Добавить',
    atlSeasonFallback: 'Сезон {id}',
    epnTitle: 'Изменить игровой номер',
    epnNumber: 'Игровой номер',
    epnRequired: 'Укажите номер игрока',
    epnRange: 'Номер должен быть от 0 до 99',
    epnTaken: 'Номер {n} уже занят другим игроком',
    epnPh: 'Введите номер',
    epnOccupied: 'Занятые номера: {list}',
    epnNone: 'нет',
    apmTitle: 'Дозаявить игрока',
    apmSingle: 'Один игрок',
    apmMultiple: 'Несколько игроков',
    apmSearch: 'Поиск игрока',
    apmSearchPh: 'Фамилия и/или имя (минимум 2 символа)',
    apmSearchHint: 'Введите фамилию или фамилию и имя через пробел. Автопоиск при 4+ символах.',
    apmNeedQuery: 'Введите фамилию игрока для поиска',
    apmMinChars: 'Введите минимум 2 символа для поиска',
    apmSearchError: 'Ошибка при поиске игроков: {error}',
    apmNoPhoto: 'Нет фото',
    apmSelect: 'Выбрать',
    apmNotFoundHint: 'Не нашли нужного игрока?',
    apmCreate: 'Создать нового игрока',
    apmNoResults: 'Игроки с запросом «{query}» не найдены',
    apmSearchStart: 'Введите минимум 2 символа и нажмите «Искать» или введите 4+ символа для автопоиска',
    apmBackSearch: 'Вернуться к поиску',
    apmNumberPh: 'Введите номер (1–99)',
    apmNumberTaken: 'Номер {n} уже занят',
    apmAdding: 'Добавление...',
    apmAdd: 'Дозаявить игрока',
    apmNoAppId: 'Ошибка: ID заявки не определён',
    apmPickPlayer: 'Выберите игрока',
    apmNeedNumber: 'Введите игровой номер от 1 до 99',
    apmAdded: 'Игрок успешно дозаявлен',
    apmAddError: 'Ошибка при дозаявке игрока',
    apmCopyFrom: 'Выберите заявку для копирования игроков',
    apmLoadingApps: 'Загрузка заявок...',
    apmNoCopyApps: 'Нет доступных заявок для копирования',
    apmBackApps: 'Назад к списку заявок',
    apmSortFio: 'По ФИО',
    apmSelectAllCount: 'Выбрать всех ({count})',
    apmSelectedCount: 'Выбрано игроков: {count}',
    apmAddCount: 'Добавить {count} игроков',
    apmAddedCount: 'Успешно добавлено игроков: {count}',
    apmAddManyError: 'Ошибка при добавлении игроков',
    apmLoadAppsError: 'Ошибка при загрузке заявок',
    apmPickOne: 'Выберите хотя бы одного игрока',
    epmCreateTitle: 'Создать нового игрока',
    epmEditTitle: 'Редактировать данные игрока',
    epmPhoto: 'Фото игрока',
    epmUpload: 'Загрузить фото',
    epmFamily: 'Фамилия',
    epmName: 'Имя',
    epmFather: 'Отчество',
    epmNationality: 'Национальность',
    epmHeight: 'Рост (см)',
    epmWeight: 'Вес (кг)',
    epmFoot: 'Рабочая нога',
    epmFamilyPh: 'Введите фамилию',
    epmNamePh: 'Введите имя',
    epmFatherPh: 'Введите отчество',
    epmNationalityPh: 'Введите национальность',
    epmRequiredFields: 'Заполните обязательные поля: фамилия, имя и дата рождения',
    epmFile10: 'Размер файла слишком большой. Максимум: 10MB',
    epmFile5: 'Размер файла слишком большой. Максимум: 5MB',
    epmCreated: 'Игрок успешно создан',
    epmUpdated: 'Данные игрока успешно обновлены',
    epmCreateError: 'Ошибка при создании игрока',
    epmUpdateError: 'Ошибка при обновлении данных игрока',
    epmCreateBtn: 'Создать игрока',
    epmSaveBtn: 'Сохранить изменения',
    epmCropTitle: 'Выберите область фото',
    epmZoom: 'Масштаб',
    epmApply: 'Применить',
    epmCropError: 'Ошибка при обрезке изображения',
    epmPosFW: 'Нападающий',
    epmPosMF: 'Полузащитник',
    epmPosDF: 'Защитник',
    epmPosGK: 'Вратарь',
    epmPosUNI: 'Универсал',
    epmFootRight: 'Правая',
    epmFootLeft: 'Левая',
    epmFootBoth: 'Обе',
    pmDesc: 'Поиск игроков по базе данных. Введите фамилию или фамилию и имя.',
    pmSearchPh: 'Имя, фамилия или команда',
    pmSearchHint: 'Введите фамилию или фамилию и имя через пробел, например: Иванов Иван. Автопоиск при 2+ символах.',
    pmMinChars: 'Введите минимум 2 символа для поиска',
    pmSearchError: 'Ошибка при поиске игроков',
    pmSearching: 'Поиск игроков...',
    pmFound: 'Найдено игроков: {count}',
    pmPage: 'Страница {current} из {total} (показаны {from}–{to})',
    pmPhoto: 'Фото',
    pmFio: 'ФИО',
    pmBirthday: 'Дата рождения',
    pmPosition: 'Позиция',
    pmNoResults: 'Игроки не найдены',
    pmNoResultsHint: 'Измените запрос или создайте нового игрока',
    pmStart: 'Начните поиск',
    pmStartHint: 'Введите фамилию или имя игрока в поле поиска',
    dupSearchPh: 'Фамилия или имя',
    dupScope: 'Область',
    dupScopeAll: 'Все чемпионаты',
    dupScopeChamp: 'Текущий чемпионат',
    dupScopeChampNamed: '{name}',
    dupFields: 'Сравнивать',
    dupFieldName: 'Имя',
    dupFieldFamily: 'Фамилия',
    dupFieldFather: 'Отчество',
    dupFieldBirthday: 'Дата рождения',
    dupFieldsHint: 'Имя и фамилия сравниваются всегда. Пустое отчество или дата не попадают в группу, если это поле включено. Без фильтра чемпионата в одной группе могут быть карточки с разных чемпионатов.',
    dupFound: 'Групп: {groups} · игроков: {players}',
    dupPageOf: 'Стр. {page} из {pages}',
    dupPrevPage: 'Назад',
    dupNextPage: 'Далее',
    dupLoading: 'Загрузка дубликатов',
    dupEmpty: 'Похожих игроков нет',
    dupEmptyHint: 'Измените поля сравнения или поиск',
    dupLoadError: 'Не удалось загрузить дубликаты',
    dupMergeError: 'Не удалось объединить игроков',
    dupMerged: 'Профили объединены',
    dupMerge: 'Объединить',
    dupKeep: 'Основной',
    dupInclude: 'В склейку',
    dupGroupTitle: 'Группа {n} · {count}',
    dupMergeHint: 'Отметьте профили и выберите, кого оставить',
    dupNoTeams: 'Нет заявок',
    dupId: 'ID {id}',
    dupMergeTitle: 'Объединить профили',
    dupMergeText: 'Карточка «{name}» останется. Остальные выбранные профили удалятся, их данные переедут на основного — в том числе с других чемпионатов.',
    dupNeedChamp: 'Выберите чемпионат',
    pmChampionship: 'Чемпионат',
    pdTitle: 'Информация об игроке',
    pdBack: 'Назад',
    pdLoadError: 'Ошибка загрузки данных игрока',
    pdNotFound: 'Игрок не найден',
    pdHeight: 'Рост',
    pdWeight: 'Вес',
    pdNationality: 'Гражданство',
    pdFoot: 'Рабочая нога',
    pdCm: '{n} см',
    pdKg: '{n} кг',
    pdYears: '({age} лет)',
    pdEdit: 'Редактировать данные',
    pdNoPermission: 'Вы можете менять данные только игроков, созданных вашей лигой. Для изменения обратитесь к разработчикам приложения.',
    pdApps: 'Заявки игрока',
    pdAddToApp: 'Добавить в заявку',
    pdTeam: 'Команда',
    pdApp: 'Заявка',
    pdNumber: 'Номер',
    pdActions: 'Действия',
    pdEmptyApps: 'Игрок пока не добавлен ни в одну заявку',
    pdRemoveTitle: 'Удалить из заявки',
    pdRemoveConfirm: 'Удалить игрока из заявки «{app}» команды «{team}»?',
    pdRemoved: 'Игрок удалён из заявки',
    pdRemoveError: 'Ошибка при удалении из заявки',
    pdLoading: 'Загрузка данных игрока...',
    plNewPlayer: 'Новый игрок',
    plAddingToTeam: 'Игрок будет добавлен в команду «{team}»',
    plCheckExists: 'Проверить, существует ли игрок',
    plCheckingExists: 'Проверяем...',
    plExistsFound: 'Найдено игроков: {count}',
    plExistsEmpty: 'Игрок с таким именем и фамилией не найден',
    plSelectExisting: 'Выбрать игрока',
    plClearExisting: 'Создать нового игрока',
    plEditPlayer: 'Редактирование игрока',
    plAddPlayer: 'Добавить игрока',
    plCreatePlayer: 'Создать игрока',
    plCreatePlayerShort: 'Игрок',
    plGender: 'Пол',
    plGenderMale: 'Мужской',
    plGenderFemale: 'Женский',
    plStatus: 'Статус',
    plStatusAmateur: 'Любитель',
    plStatusPro: 'Профессионал',
    plStatusProShort: 'Прф',
    plInsured: 'Застрахован',
    plInsuranceUntil: 'Страховка до',
    plInsuranceUntilHint: 'Дата окончания страховки. Без галочки «Застрахован» поле недоступно.',
    plCitizenship: 'Гражданство',
    plTeamsBlock: 'Команды',
    plTransfersBlock: 'История трансферов',
    plRelatedProfiles: 'Связанные профили',
    plPossibleProfiles: 'Возможные профили',
    plEmptyTransfers: 'История трансферов пуста',
    plTransferAddApp: 'Добавлен в заявку',
    plEmptyRelated: 'Связанных профилей нет',
    plEmptyPossible: 'Возможных профилей не найдено',
    plLinkSelected: 'Привязать выбранные профили',
    plProfilesLinked: 'Профили привязаны',
    plProfilesLinkError: 'Ошибка при привязке профилей',
    plAddApp: 'Добавить заявку',
    plChangeApp: 'Изменить заявку',
    plAppPickRequired: 'Выберите команду и заявку',
    plAppSaveError: 'Ошибка при сохранении заявки',
    plUnlinkProfile: 'Отвязать профиль',
    plUnlinkConfirm: 'Отвязать профиль «{name}» от этого игрока?',
    plProfilesUnlinked: 'Профиль отвязан',
    plProfilesUnlinkError: 'Ошибка при отвязке профиля',
    plMakeCaptain: 'Назначить капитаном',
    plCaptain: 'Капитан',
    plCaptainSet: 'Игрок назначен капитаном',
    plCaptainError: 'Ошибка при назначении капитана',
    plRemoveCaptain: 'Убрать из капитанов',
    plCaptainRemoved: 'Игрок убран из капитанов',
    plCaptainRemoveError: 'Ошибка при снятии капитана',
    apaTitle: 'Добавить в заявку команды',
    apaSearchTeam: 'Поиск команды',
    apaSearchPh: 'Введите название команды...',
    apaNoTeams: 'Команды не найдены',
    apaStartTeam: 'Начните вводить название команды',
    apaApplication: 'Заявка',
    apaPickApp: 'Выберите заявку',
    apaNoApps: 'У команды нет заявок',
    apaNumber: 'Номер игрока',
    apaNumberPh: 'Введите номер (0–99)',
    apaOccupied: 'Занятые номера: {list}',
    apaPickTeam: 'Выберите команду',
    apaNeedNumber: 'Введите номер игрока',
    apaNumberRange: 'Номер должен быть от 0 до 99',
    apaNumberTaken: 'Номер {n} уже занят в этой заявке',
    apaTeamNotFound: 'Команда не найдена',
    apaAdded: 'Игрок успешно добавлен в заявку',
    apaAddError: 'Ошибка добавления игрока в заявку',
    apaAdding: 'Добавление...',
    apaAdd: 'Добавить в заявку',
    apaLoadTeamsError: 'Ошибка загрузки команд',
    apaLoadAppsError: 'Ошибка загрузки заявок',
    schPickLeague: 'Выбор лиги',
    schLoadingTeams: 'Загрузка команд...',
    schLeagueType: 'Тип лиги',
    schGroupPlayoff: 'Групповой этап + плей-офф',
    schGroups: 'Групп: {count}',
    schGroup: 'Группа {name}',
    schGroupTeams: '({count} команд):',
    schTeamsInLeague: 'Команд в лиге: {count}',
    schParams: 'Параметры генерации',
    schAuto: 'Автоматически',
    schManual: 'Задать первый тур',
    schFirstDate: 'Дата первого тура',
    schWithDates: 'Указывать даты',
    schWithoutDatesHint: 'Календарь только по турам — даты матчам поставите потом (например, через «Быстрое редактирование» в «Играх»).',
    schRounds: 'Количество кругов',
    schRound1: '1 круг',
    schRound2: '2 круга',
    schHalfTime: 'Время тайма (мин)',
    schDaysBetween: 'Дней между турами',
    schNeedHalfTime: 'Укажите время тайма',
    schNeedDaysBetween: 'Укажите число дней между турами',
    schStadiumNotFound: 'Стадион не найден',
    schStadiumPlaceholder: 'Выберите стадион',
    schReferee: 'Судья',
    schRefereeNotFound: 'Судья не найден',
    schRefereeNone: 'Не назначен',
    schGenerate: 'Сгенерировать расписание',
    schFirstRoundGroups: 'Матчи первого тура по группам',
    schFirstRound: 'Матчи первого тура',
    schFirstRoundHint: 'Укажите пары команд. Последний матч — хозяева будут «фиксированной» командой в алгоритме.',
    schByeHint: ' Одна команда автоматически пропустит тур.',
    schByeTeam: 'Пропускает тур: {name}',
    schNoAvailable: 'Нет доступных',
    schHome: 'Хозяева',
    schAway: 'Гости',
    schFillAll: 'Заполните все матчи для генерации расписания',
    schFillFirst: 'Заполните все матчи первого тура',
    schNoGroups: 'Группы не найдены для данной лиги',
    schFillFirstGroups: 'Заполните все матчи первого тура для каждой группы',
    schNeedTeams: 'В выбранной лиге должно быть минимум 2 команды',
    schLoadTeamsError: 'Не удалось загрузить команды сезона',
    schPreview: 'Предварительный просмотр расписания',
    schTours: 'Туров: {count}',
    schMatches: 'Матчей: {count}',
    schTeams: 'Команд: {count}',
    schGroupsStat: 'Групп: {count}',
    schExpandAll: 'Развернуть все',
    schCollapseAll: 'Свернуть все',
    schSave: 'Сохранить на сервер',
    schTour: 'Тур {n}',
    schCircle: 'Круг {n}',
    schMatchCount: '{count} матч(ей)',
    schSaveTitle: 'Сохранить расписание',
    schSaveConfirm: 'Будет создано {tours} стадий (туров){groups} и {matches} матчей в лиге «{league}».',
    schSaveGroups: ' ({count} групп)',
    schSaved: 'Расписание сохранено',
    schSaveError: 'Ошибка при сохранении: {error}',
    schNoChampionship: 'Без чемпионата',
    schStadiumId: 'Стадион #{id}',
    schRefereeId: 'Судья #{id}',
    schUngrouped: 'Без группы',
    ipeTitle: 'Импорт игроков из Excel',
    ipeStep1: 'Шаг 1: Загрузите файл Excel',
    ipeStep1Text: 'Файл должен содержать следующие данные об игроках:',
    ipeReqFamily: 'Фамилия (обязательно)',
    ipeReqName: 'Имя (обязательно)',
    ipeReqBirth: 'Дата рождения (обязательно, формат: ДД.ММ.ГГГГ)',
    ipeFather: 'Отчество',
    ipeHasHeaders: 'Первая строка содержит заголовки',
    ipeHasHeadersHint: 'Отметьте, если первая строка в файле — названия колонок',
    ipePickFile: 'Выбрать файл Excel',
    ipeEmptyFile: 'Файл пустой или неправильного формата',
    ipeReadError: 'Ошибка при чтении файла',
    ipeColumn: 'Колонка {letter}',
    ipeStep2: 'Шаг 2: Укажите соответствие колонок',
    ipeStep2Hint: 'Выберите, какая колонка в файле соответствует каждому полю',
    ipePickColumn: 'Выберите колонку',
    ipePreview: 'Предпросмотр данных (первые 3 строки)',
    ipeRow: 'Строка {n}',
    ipeProcessing: 'Обработка...',
    ipeNeedColumns: 'Укажите обязательные колонки: фамилия, имя, дата рождения',
    ipeStep3: 'Шаг 3: Проверка и подтверждение',
    ipeExisting: 'игрок найден в базе',
    ipeNew: 'новый игрок',
    ipeDuplicate: 'Дубликат',
    ipeOccupied: 'Занят',
    ipeWarnings: 'Обнаружены проблемы. Проверьте данные на следующем шаге.',
    ipeEmptyFields: '{count} игроков с пустыми обязательными полями (будут пропущены)',
    ipeBadDates: '{count} игроков с некорректными датами',
    ipeDupNumbers: 'Есть игроки с одинаковыми номерами ({list}). Номера должны быть уникальными.',
    ipeConflictNumbers: 'Номера {list} уже заняты другими игроками в этой заявке.',
    ipeResult: 'Добавлено: {added} из {total} игроков',
    ipeErrors: 'Найдено ошибок: {count}',
    ipeCritical: 'Критическая ошибка при добавлении игроков: {error}',
    olmRosterTitle: 'Выбор заявки на матч',
    olmRosterSubtitle: 'Отметьте игроков, участвующих в матче',
    olmSelectAll: 'Выбрать всех',
    olmDeselectAll: 'Снять всех',
    olmSelected: 'Выбрано: {count}',
    olmNext: 'Далее →',
    olmBack: '← Назад',
    olmLineupTitle: 'Расстановка и стартовый состав',
    olmLineupSubtitle: 'Выберите формат, схему и расставьте игроков. Нажмите на позицию → затем на игрока.',
    olmKitColor: 'Цвет формы {team}:',
    olmMatchFormat: 'Формат матча:',
    olmPlayers: 'Игроки ({count})',
    olmPickSlot: '📍 Выберите → {slot}',
    olmPos: 'поз. {n}',
    olmSelectFormation: 'Выберите схему',
    olmAllOnField: 'Все игроки на поле ✓',
    olmAuto: 'Авто',
    olmClear: 'Очистить',
    olmStartMatch: 'Начать матч →',
    olmEditLineup: 'Изменить расстановку',
    olmWaiting: 'Ожидание',
    olmHalf1: '1-й тайм',
    olmHalf1Paused: '1-й тайм (пауза)',
    olmHalf2: '2-й тайм',
    olmHalf2Paused: '2-й тайм (пауза)',
    olmMatchEnded: 'Матч завершён',
    olmStartHalf1: '▶ Начать 1-й тайм',
    olmPause: '⏸ Пауза',
    olmResume: '▶ Продолжить',
    olmStartHalf2: '▶ Начать 2-й тайм',
    olmStartExtra: '▶ Доп. время',
    olmStartExtra1: '▶ Начать доп. 1-й тайм',
    olmStartExtra2: '▶ Начать доп. 2-й тайм',
    olmExtraHalftime: '⏱ Перерыв доп. времени',
    olmExtra1: 'Доп. время, 1-й тайм',
    olmExtra1Paused: 'Доп. время, 1-й тайм (пауза)',
    olmExtra2: 'Доп. время, 2-й тайм',
    olmExtra2Paused: 'Доп. время, 2-й тайм (пауза)',
    olmExtra1Started: 'Начался 1-й тайм доп. времени',
    olmExtra2Started: 'Начался 2-й тайм доп. времени',
    olmEndMatch: '🏁 Завершить матч',
    olmHalftime: '⏱ Перерыв',
    olmBench: 'Скамейка ({count}) — перетащите на поле для замены',
    olmMatchEvents: 'События матча ({count})',
    olmNoEvents: 'Нет событий',
    olmPass: 'пас: {name}',
    olmApplyResults: '✓ Применить результаты',
    olmCloseNoSave: 'Закрыть',
    olmAllEvents: 'Все события ({count})',
    olmEditEvent: 'Редактировать событие',
    olmAddEvent: 'Добавить событие',
    olmSelectPlayer: '— Выберите игрока —',
    olmAssistOptional: 'Голевая передача (опционально)',
    olmNoAssist: '— Без ассиста —',
    olmSubIn: 'Замена: игрок на замену (входит)',
    olmSelectBench: '— Выберите игрока со скамейки —',
    olmMinuteSecond: 'Минута / секунда',
    olmMinPh: 'мин',
    olmSecPh: 'сек',
    olmLoadingServer: 'Загрузка данных матча с сервера...',
    olmNeedPlayers: 'Выберите хотя бы по одному игроку в каждой команде',
    olmNeedFormat: 'Выберите формат матча',
    olmNeedFormation: 'Выберите схему для обеих команд',
    olmErrState: 'Ошибка смены статуса матча',
    olmErrEvent: 'Ошибка отправки события на сервер',
    olmErrNoServerId: 'Не удалось удалить событие на сервере: нет server_id',
    olmErrRemove: 'Ошибка удаления события на сервере',
    olmErrChange: 'Ошибка изменения события на сервере',
    olmErrApp: 'Ошибка сохранения заявки на сервер',
    olmSavingApps: 'Сохранение заявок...',
    olmStarting: 'Запуск матча...',
    olmMatchStarted: 'Матч начался! 1-й тайм',
    olmHalfTimeNotif: 'Перерыв!',
    olmHalf2Started: '2-й тайм начался!',
    olmMatchEndedNotif: 'Матч завершён!',
    olmEventUpdated: 'Событие обновлено',
    olmAlreadySubbed: 'Игрок уже заменён',
    olmSubNotif: '🔄 Замена: {out} → {inName}',
    olm2YC: '🟨🟨 2-я ЖК → КК: {name}',
    olmEventNotif: '{icon} {label}: {name}',
    olmRemove: 'Удалить',
    stSearchPh: 'Поиск по названию или адресу',
    stEmpty: 'Стадионы не найдены',
    stEmptyHint: 'Измените запрос или добавьте новый стадион',
    stLoading: 'Загрузка стадионов',
    stStatus: 'Статус',
    stdName: 'Имя',
    stAddress: 'Адрес',
    stdPriority: 'Порядок',
    stEnabled: 'Показывается',
    stEnabledShort: 'Вкл',
    stDisabled: 'Скрыт',
    stDisabledShort: 'Скрыт',
    stReorder: 'Изменить порядок',
    stReorderShort: 'Порядок',
    stSaveOrder: 'Сохранить',
    stCancelReorder: 'Отменить',
    stAddStadium: 'Добавить стадион',
    stAddStadiumShort: 'Стадион',
    stNewStadium: 'Новый стадион',
    stEditStadium: 'Изменить стадион',
    stdSaveChanges: 'Сохранить изменения',
    stdSaveChangesShort: 'Сохранить',
    stShowOnSite: 'Показывать на сайте/приложении',
    stDescription: 'Описание',
    stLat: 'Широта',
    stLong: 'Долгота',
    stPitchSize: 'Размер поля',
    stPitchCover: 'Покрытие поля',
    stCapacity: 'Вместимость',
    stPhoto: 'Фото',
    stPhotoHint: 'JPG, PNG или WEBP, до 5 МБ · можно выбрать область',
    stPhotoChoose: 'Выбрать фото',
    stPhotoChange: 'Заменить фото',
    stPhotoRemove: 'Убрать',
    stdNamePh: 'Арена Химки',
    stAddressPh: 'г. Химки, ул. Кирова, 27',
    stDescriptionPh: 'Краткое описание стадиона',
    stLatPh: '55.889',
    stLongPh: '37.445',
    stPitchSizePh: '105x68',
    stPitchCoverPh: 'искусственная трава',
    stCapacityPh: '5000',
    stPitchNamePh: 'Поле 1',
    stPitchDescriptionPh: 'Основное поле',
    stdNameRequired: 'Укажите название',
    stChampionshipRequired: 'Выберите чемпионат',
    stPitches: 'Поля',
    stAddPitch: 'Добавить поле',
    stAddPitchShort: 'Поле',
    stNewPitch: 'Новое поле',
    stEditPitch: 'Изменить поле',
    stCreatePitch: 'Создать поле',
    stNoPitches: 'Поля ещё не добавлены',
    stDeleteStadiumTitle: 'Удалить стадион?',
    stDeleteStadiumText: 'Стадион и все его поля будут удалены. Это действие нельзя отменить.',
    stDeletePitchTitle: 'Удалить поле?',
    stDeletePitchText: 'Поле будет удалено. Это действие нельзя отменить.',
    stSaved: 'Изменения сохранены',
    stdCreated: 'Стадион создан',
    stPitchCreated: 'Поле создано',
    stDeleted: 'Удалено',
    stOrderSaved: 'Порядок сохранён',
    stLoadError: 'Не удалось загрузить данные',
    stSaveError: 'Не удалось сохранить изменения',
    stOrderError: 'Не удалось сохранить порядок',
    stdDeleteError: 'Не удалось удалить',
    stNeedImage: 'Выберите изображение',
    stFileSize: 'Файл больше 5 МБ',
    stMoveUp: 'Выше',
    stMoveDown: 'Ниже',
    stFound: 'Найдено: {count}',
    stBack: 'Назад',
    stDragHint: 'Перетащите строки или используйте стрелки, чтобы изменить порядок',
    stNotFound: 'Стадион не найден',
    stPitchNotFound: 'Поле не найдено',
    trChampionships: 'Чемпионаты',
    trSearchPh: 'Поиск по имени',
    trEmptyCountries: 'Чемпионаты не найдены',
    trEmptyCountriesHint: 'Измените запрос или добавьте новый чемпионат',
    trLoading: 'Загрузка',
    trAddCountry: 'Добавить чемпионат',
    trNewCountry: 'Новый чемпионат',
    trEditCountry: 'Редактировать чемпионат',
    trSaveCountry: 'Сохранить чемпионат',
    trFlag: 'Флаг',
    trFlagPlaceholder: 'Выберите флаг',
    trFlagSearch: 'Поиск флага',
    trFlagEmpty: 'Флаги не найдены',
    trFlagRequired: 'Выберите флаг',
    trFounded: 'Дата основания',
    trVk: 'VK ссылка',
    trVkPh: 'https://vk.com/...',
    trCountryNamePh: 'Россия',
    trTournaments: 'Турниры',
    trAddLeague: 'Добавить турнир',
    trAddLeagueShort: 'Турнир',
    trNewLeague: 'Новый турнир',
    trEditLeague: 'Редактировать турнир',
    trCreateLeague: 'Создать турнир',
    trLeagueNamePh: 'Высшая лига',
    trCountry: 'Страна',
    trCountryPlaceholder: 'Выберите страну',
    trCountryRequired: 'Выберите страну',
    trEmptyLeagues: 'Турниры ещё не добавлены',
    trSeasons: 'Сезоны',
    trAddSeason: 'Создать сезон',
    trAddSeasonShort: 'Сезон',
    trNewSeason: 'Новый сезон',
    trEditSeason: 'Редактировать сезон',
    trCreateSeason: 'Создать сезон',
    trChangeLeague: 'Изменить лигу',
    trChangeLeagueShort: 'Лига',
    trMoveSeasonTitle: 'Перенести сезон в другую лигу',
    trMoveSeasonCurrent: 'Сейчас: {league}',
    trMoveSeasonTarget: 'Целевая лига',
    trMoveSeasonTargetPh: 'Выберите лигу',
    trMoveSeasonConfirm: 'Вы уверены, что хотите перенести весь сезон «{season}» из «{from}» в «{to}»?',
    trMoveSeasonHint: 'Вместе с сезоном переедут матчи, стадии, настройки и связанные данные. Операцию нельзя отменить из админки.',
    trMoveSeasonEmpty: 'В этом чемпионате нет других лиг',
    trMoveSeasonSubmit: 'Перенести',
    trMoveSeasonSuccess: 'Сезон перенесён в «{league}»',
    trMoveSeasonError: 'Не удалось перенести сезон',
    trEmptySeasons: 'Сезоны ещё не добавлены',
    trSeasonNamePh: 'Весна 2026',
    trInProgress: 'Не завершен',
    trActive: 'Активный',
    trActiveShort: 'Акт.',
    trActiveSeasonHint: 'Самый верхний сезон считается активным',
    trFirstSeasonLocked: 'Первый сезон всегда активный',
    trRateRatioPlaceholder: 'Выберите коэффициент',
    trStartingAt: 'Дата начала',
    trEndingAt: 'Дата окончания',
    trLeagueType: 'Тип турнира',
    trLeagueTypeRegular: 'Круговой',
    trLeagueTypeGroups: 'Группы + плей-офф',
    trTableCountType: 'Подсчёт таблицы',
    trTableCountTypePersonal: 'Личные встречи',
    trTableCountTypeGoalDiff: 'Разница мячей',
    trTableCountTypeHint: 'Как ранжировать команды с равными очками: по личным встречам или по разнице мячей.',
    trTiebreakers: 'Порядок мест при равенстве очков',
    trTiebreakersHint: 'Критерии применяются по порядку только между командами с равными очками. Снимите галочку, чтобы не учитывать критерий.',
    trTiebreakersDragHint: 'Перетащите строки или используйте стрелки, чтобы изменить порядок.',
    trTiebreakersPresetH2h: 'Регламент (сначала личные)',
    trTiebreakersPresetGoalDiff: 'Сначала разница мячей',
    trTiebreakersReset: 'Сбросить',
    trTiebreaker_h2h_points: 'Очки в личных встречах',
    trTiebreaker_h2h_goal_diff: 'Разница мячей в личных встречах',
    trTiebreaker_h2h_goals_for: 'Забитые мячи в личных встречах',
    trTiebreaker_h2h_wins: 'Победы в личных встречах',
    trTiebreaker_goal_diff: 'Разница мячей во всех матчах',
    trTiebreaker_goals_for: 'Забитые мячи во всех матчах',
    trTiebreaker_wins: 'Победы во всех матчах',
    trRateRatio: 'Коэффициент рейтинга',
    trRateRatioHint: 'Сила чемпионата. Влияет на то, сколько рейтинга команды получают за матчи этого сезона.',
    trPenaltyDrawScore: 'Очки за победу по пенальти',
    trPenaltyDrawScorePh: 'Пусто = выкл. (обычно 2 или 3)',
    trPenaltyDrawScoreHint: 'Если матч закончился ничьей и сыграли пенальти — столько очков получает победитель серии. Пустое поле — правило выключено, ничья всегда даёт 1 очко.',
    trPenaltyDrawScoreInvalid: 'Укажите положительное число или очистите поле',
    trApplication: 'Заявка',
    trApplicationPlaceholder: 'Выберите заявку',
    trApplicationRequired: 'Выберите заявку для сезона',
    trApplicationActive: 'Трансферное окно открыто',
    trApplicationActiveHint: 'Пока включено, капитаны могут подавать и менять заявки.',
    trApplications: 'Заявки',
    trManageApplications: 'Управление заявками',
    trAddApplication: 'Добавить заявку',
    trNewApplication: 'Новая заявка',
    trEditApplication: 'Редактировать заявку',
    trCreateApplication: 'Создать заявку',
    trApplicationSearchPh: 'Поиск по имени или году',
    trEmptyApplications: 'Заявки не найдены',
    trEmptyApplicationsHint: 'Создайте заявку, чтобы выбрать её в сезоне',
    trApplicationNotFound: 'Заявка не найдена',
    trApplicationCreated: 'Заявка создана',
    trApplicationLocked: 'Эту заявку нельзя менять через админку (только в БД)',
    trApplicationYear: 'Год',
    trApplicationYearPh: '2026',
    trApplicationYearRequired: 'Укажите год',
    trApplicationNamePh: 'AFL 2026',
    trApplicationLimit: 'Лимит заявки',
    trApplicationLimitPh: '25',
    trApplicationLimitHint: 'Базовый лимит игроков. Пусто → 30. −1 — без лимита.',
    trApplicationThroughLimit: 'Сквозной лимит',
    trApplicationThroughLimitShort: 'Сквозной',
    trApplicationThroughLimitPh: '15',
    trApplicationThroughLimitHint: 'Добавка на каждый доп. состав в цепочке дублей. Эффективный лимит = база + (цепочка − 1) × сквозной. По умолчанию 15.',
    trApplicationProfessionalLimit: 'Лимит профессионалов',
    trApplicationProfessionalLimitShort: 'Профи',
    trApplicationProfessionalLimitPh: 'Без лимита',
    trApplicationProfessionalLimitHint: 'Максимум профессионалов в заявке команды. Пустое поле — без лимита.',
    trApplicationCanDouble: 'Игрок может играть за несколько команд',
    trApplicationCanDoubleHint: 'Если выключено, в рамках этой заявки игрок закреплён ровно за одной командой.',
    trApplicationIsActive: 'Заявка активна',
    trApplicationIsActiveHint: 'Неактивная заявка остаётся в базе, но не предлагается командам',
    trApplicationStatusActive: 'Активна',
    trApplicationStatusActiveShort: 'Акт.',
    trApplicationStatusInactive: 'Неактивна',
    trApplicationStatusInactiveShort: 'Выкл',
    trApplicationInactiveMark: 'неактивна',
    trGroupStagesAmount: 'Количество групповых стадий',
    trGroupStagesAmountHint: 'Сколько туров учитывается в групповом этапе. Остальные туры считаются плей-офф.',
    trGroupStagesAmountRequired: 'Укажите количество групповых стадий',
    trRules: 'Правила',
    trRulesHint: 'Текст или HTML. Пустое поле очищает правила.',
    trRulesPageHint: 'Регламент турнира — открывается на отдельной странице.',
    trRulesOpen: 'Открыть правила',
    trRulesPh: '1. Матч 2×25 мин.\n2. …',
    trRulesSave: 'Сохранить правила',
    trRulesWordImport: 'Из Word',
    trRulesWordHint: 'Только .docx — текст подставится в поле, потом сохраните.',
    trRulesWordImported: 'Текст из Word подставлен — нажмите «Сохранить правила».',
    trRulesWordEmpty: 'В файле Word нет текста.',
    trRulesWordType: 'Нужен файл .docx (Word).',
    trRulesWordLegacy: 'Старый .doc не поддерживается — сохраните как .docx.',
    trRulesWordError: 'Не удалось прочитать Word-файл.',
    trContacts: 'Контакты',
    trAddContact: 'Добавить контакт',
    trNewContact: 'Новый контакт',
    trEditContact: 'Контакт',
    trChangeContact: 'Изменить контакт',
    trEmptyContacts: 'Контакты ещё не добавлены',
    trContactNotFound: 'Контакт не найден',
    trFirstName: 'Имя',
    trLastName: 'Фамилия',
    trFatherName: 'Отчество',
    trPosition: 'Должность',
    trPositionPh: 'Куратор лиги',
    trPhone: 'Телефон',
    trPhonePh: '+7 999 000-11-22',
    trTelegram: 'Telegram',
    trTelegramPh: '@curator',
    trInfo: 'Информация',
    trFirstNameRequired: 'Укажите имя',
    trLastNameRequired: 'Укажите фамилию',
    trStages: 'Стадии',
    trAddStage: 'Добавить стадию',
    trAddStageShort: 'Стадия',
    trNewStage: 'Новая стадия',
    trEditStage: 'Редактировать стадию',
    trCreateStage: 'Создать стадию',
    trEmptyStages: 'Стадии ещё не добавлены',
    trStageName: 'Название',
    trStageNamePh: '1 тур',
    trStageShortName: 'Короткое имя',
    trStageShortNamePh: '1 тур',
    trStagePriority: 'Приоритет',
    trStagePlayoffHint: 'Если включено, стадия идёт после группового этапа.',
    trStageGroup: 'Группа',
    trStageGroupNone: 'Без группы',
    trStageGroupHint: 'Присоединять стадию к группе нужно только если одна и та же команда играет в двух или более группах. Иначе это необязательно.',
    trStageRateRatio: 'Коэффициент сложности',
    trStageRateRatioHint: 'Влияет на то, сколько рейтинга команды получают за матчи этой стадии.',
    trStageNameRequired: 'Укажите название стадии',
    trStageNotFound: 'Стадия не найдена',
    trStageMatches: 'Матчи',
    trStageMatchesHint: 'Матчи этой стадии. Создайте один матч или сгенерируйте сразу весь тур.',
    trDeleteCountryTitle: 'Удалить чемпионат?',
    trDeleteCountryText: 'Чемпионат будет удалён. Лиги не удаляются автоматически.',
    trDeleteLeagueTitle: 'Удалить турнир?',
    trDeleteLeagueText: 'Турнир будет удалён. Сезоны и матчи не удаляются автоматически.',
    trDeleteContactTitle: 'Удалить контакт?',
    trDeleteContactText: 'Куратор будет удалён. Это действие нельзя отменить.',
    trDeleteStageTitle: 'Удалить стадию?',
    trDeleteStageText: 'Стадия будет удалена. Это действие нельзя отменить.',
    trDeleteMatchTitle: 'Удалить матч?',
    trDeleteMatchText: 'Будут удалены события, заявки, фото, видео, протокол и сам матч. Это нельзя отменить.',
    trMatchDeleted: 'Матч удалён',
    trCountryCreated: 'Чемпионат создан',
    trLeagueCreated: 'Турнир создан',
    trSeasonCreated: 'Сезон создан',
    trContactCreated: 'Контакт добавлен',
    trStageCreated: 'Стадия создана',
    trSeasonTeams: 'Команды-участницы',
    trSeasonTeamsHint: 'Кто играет в лиге в этом сезоне.',
    trAddTeam: 'Добавить команду',
    trEmptySeasonTeams: 'В этом сезоне команд пока нет. Добавьте их кнопкой выше.',
    trRemoveFromSeason: 'Убрать из сезона',
    trSaveTeams: 'Сохранить команды',
    trSaveTeamsShort: 'Сохранить',
    trTeamsSaved: 'Состав сохранён',
    trOpenTeam: 'Открыть страницу команды',
    trUnsaved: 'не сохранено',
    trTeamSearchPh: 'Поиск по названию команды',
    trTeamSearching: 'Ищем…',
    trTeamsNotFound: 'Команды не найдены',
    trTeamsShown: 'Показано {shown} из {total}',
    trShowMore: 'Показать ещё',
    trSeasonGroups: 'Группы',
    trSeasonGroupsHint: 'Как участники разбиты по группам. Одну команду можно отметить в нескольких группах.',
    trCreateGroup: 'Создать группу',
    trRandomDraw: 'Раскидать случайно',
    trDrawCeremony: 'Жеребьёвка',
    trDrawNeedTeams: 'Нужны хотя бы одна группа и одна команда',
    trGroupNameNote: 'Название пишите целиком — «Группа А», а не «А». В приложении оно выводится как есть.',
    trGroupNamePh: 'например «Группа А»',
    trGroupNameRequired: 'Введите название группы.',
    trGroupNameExists: 'Группа с таким названием уже есть.',
    trEmptyGroups: 'Групп пока нет. Создайте их («Группа А», «Группа Б», …) и распределите команды.',
    trDrawSizes: 'При случайном распределении получится по {sizes} команд в группах.',
    trSeededTeams: 'Сеяные команды',
    trClearSeeded: 'снять все',
    trSeededHint: 'Отметьте команды, которые не должны попасть в одну группу. При жеребьёвке они разводятся по разным группам.',
    trUnassignedGroup: 'Без группы',
    trEmptyGroupTeams: 'В группе нет команд — назначьте их в списке ниже.',
    trAllTeamsAssigned: 'Все команды распределены по группам.',
    trRenameGroup: 'Переименовать',
    trDeleteGroup: 'Удалить группу',
    trSaveGroups: 'Сохранить группы',
    trSaveGroupsShort: 'Сохранить',
    trGroupsSaved: 'Группы сохранены',
    trSeasonActions: 'Действия',
    trSeasonActionsHint: 'Замена меняет состав сезона и группу. Штраф меняет очки в таблице.',
    trAddReplacement: 'Замена команды',
    trAddPenalty: 'Штраф',
    trEmptyActions: 'Действий пока нет. Добавьте замену или штраф.',
    trReplacement: 'Замена',
    trPenalty: 'Штраф',
    trPreviousTeam: 'Старая команда',
    trCurrentTeam: 'Новая команда',
    trPreviousTeamHint: 'Команда из состава этого сезона.',
    trCurrentTeamHint: 'Команда, которой ещё нет в этом сезоне.',
    trPenaltyTeam: 'Команда',
    trPenaltyScore: 'Очки',
    trPenaltyScoreHint: 'Отрицательное число снимает очки из таблицы, положительное добавляет.',
    trPenaltyScorePh: '-10',
    trActionDate: 'Дата',
    trActionDateHint: 'Необязательно. Если пусто — поставится текущее время.',
    trActionGroup: 'Группа',
    trActionGroupAuto: 'Определить автоматически',
    trActionGroupHint: 'Если не указать, сервер возьмёт текущую группу команды.',
    trReplacementHint: 'Старая команда уйдёт из состава, новая займёт её место, в том числе в группе. Матчи старой будут считаться за новую.',
    trSameTeams: 'Старая и новая команда должны отличаться.',
    trCurrentTeamInSeason: 'Эта команда уже в составе сезона.',
    trScoreRequired: 'Укажите ненулевое число очков.',
    trTeamRequired: 'Выберите команду.',
    trActionAdded: 'Действие добавлено',
    trActionDeleted: 'Действие удалено',
    trDeleteActionTitle: 'Удалить действие?',
    trDeleteReplacementText: 'Состав и группа откатятся к старой команде, затем замена удалится. Если новую команду уже меняли ещё раз, сначала отмените позднюю замену.',
    trDeletePenaltyText: 'Штраф будет удалён из турнирной таблицы.',
    trPenaltyPoints: '{score} оч.',
    trSelectTeam: 'Выберите команду',
    trActionCreate: 'Добавить',
    trTeamSearchStart: 'Начните вводить название',
    gmQuickEdit: 'Быстрое редактирование',
    gmQuickFailed: 'Не сохранились матчи ({count}): {list}. Остальные обновлены.',
    gmQuickHalf: 'Тайм',
    gmQuickHint: 'Строки не открываются — правьте дату, время, длину тайма, стадион и судью прямо здесь, затем нажмите «Сохранить».',
    gmQuickLoadingRefs: 'Загружаем судей и стадионы…',
    gmQuickNeedDate: 'Укажите дату для матча {match}',
    gmQuickNeedHalfTime: 'Укажите время тайма (> 0) для матча {match}',
    gmQuickNoMatches: 'На странице нет матчей',
    gmQuickNoPitch: 'Поле не выбрано',
    gmQuickNoReferee: 'Судья не назначен',
    gmQuickNoStadium: 'Стадион не выбран',
    gmQuickReferee: 'Судья',
    gmQuickRefereePh: 'Фамилия судьи',
    gmQuickRefsError: 'Не удалось загрузить судей и стадионы',
    gmQuickSaveCount: 'Сохранить ({count})',
    gmQuickSaved: 'Сохранено матчей: {count}',
    gmQuickSaving: 'Сохраняем…',
    gmQuickStadiumPh: 'Название стадиона',
    olmEditTimer: 'Изменить время таймера',
    olmEditTimerShort: 'Время',
    olmPauseShort: 'Пауза',
    olmSpaceHint: 'Пробел — пауза / продолжить',
    tabloClockPaused: 'пауза',
    olmResumeShort: 'Запустить',
    olmUseTimerTime: 'Подставить время с таймера онлайна',
    ssNothingFound: 'Ничего не найдено',
    ssShownFirst: 'Показаны первые {shown} из {total} — начните вводить для поиска',
  },
  en: {
    login: 'Sign in',
    loginAdmin: 'Sign in to admin',
    menu: 'Menu',
    logout: 'Log out',
    accEdit: 'My profile',
    accTitle: 'My profile',
    accSaved: 'Profile saved',
    accVkHint: 'An empty value clears the link',
    accTimezoneOffset: 'Timezone offset, minutes',
    accTimezoneHint: 'Same as Date.getTimezoneOffset(): Moscow is usually −180. Sent on sign-in. Change it only if the browser offset is wrong.',
    accTimezoneInvalid: 'Enter a number from −1440 to 1440',
    language: 'Language',
    heroBrand: 'Amateur Football League',
    heroTitle: 'Admin panel',
    heroSubtitle: 'Tournaments, applications, stats and results — all league tools in one place.',
    community: 'Community',
    featuresTitle: 'Key features',
    featureMatches: 'Matches',
    featureMatchesTitle: 'Match management',
    featureMatchesText: 'Create matches, assign referees and stadiums, and enter results in real time',
    featureApps: 'Applications',
    featureAppsTitle: 'Application management',
    featureAppsText: 'Review team applications, add and remove players',
    featureStats: 'Statistics',
    featureStatsTitle: 'Stats and reports',
    featureStatsText: 'Full player, team and match statistics update automatically',
    ctaTitle: 'Ready to get started?',
    ctaSubtitle: 'Get full access to your league administration tools',
    authTitle: 'Administrator sign in',
    loginPlaceholder: 'Phone or email',
    passwordPlaceholder: 'Password',
    authTermsPrefix: 'By clicking "Sign in", you agree to the',
    authTermsLink: 'terms of use',
    authContinue: 'Continue',
    authBack: 'Back',
    authLoading: 'Please wait…',
    authNeedLogin: 'Enter phone or email',
    authNeedPassword: 'Enter password',
    authNeedCode: 'Enter the verification code',
    authNeedEmail: 'Enter email',
    authNeedEmailCode: 'Enter the email code',
    authPasswordShort: 'Password must be at least 8 characters',
    authPasswordsMismatch: 'Passwords do not match',
    authCheckError: 'Could not verify login',
    authLoginError: 'Invalid login or password',
    authCodeInvalid: 'Invalid or expired code',
    authResendError: 'Could not resend the code',
    authSmsError: 'Could not send SMS',
    authEmailSendError: 'Could not send the email code',
    authSetupError: 'Could not finish setup',
    authForgotError: 'Could not start password reset',
    authPhoneRequired: 'This account has no phone and no password — code recovery is unavailable',
    authMergeAccounts: 'Merge accounts',
    authMergeConfirm: 'Confirm merge',
    authMergeTitle: 'Merge accounts',
    authMergeHint: 'A client duplicate with the same phone was found. You can merge it into the admin account.',
    authMergeKeep: 'Admin account to keep: #{id}',
    authMergeKill: 'Client account to merge: #{ids}',
    authMergePhone: 'Phone: {phone}',
    authMergeEmails: 'Duplicate email: {emails}',
    authMergeSuccess: 'Accounts merged. Continuing sign-in…',
    authMergeError: 'Could not merge accounts',
    authMergeUnavailable: 'Merge is not available for this login',
    authTitleTelegram: 'Telegram code',
    authTitleSms: 'SMS code',
    authTitleSetup: 'Create a password',
    authTitleForgot: 'Reset password',
    authTitleForgotCode: 'Reset code',
    authTitleForgotReset: 'New password',
    authCodePlaceholder: 'Code ({n} digits)',
    authCodeSentTelegram: 'Code sent to Telegram',
    authCodeSentSms: 'Code sent by SMS',
    authEmailCodeSent: 'Code sent to email',
    authMockCode: 'Test code: {code}',
    authConfirmCode: 'Confirm',
    authResendCode: 'Resend code',
    authResendIn: 'Resend in {n}s',
    authSendSmsInstead: 'Send SMS',
    authForgotPassword: 'Forgot password?',
    authSendReset: 'Send code',
    authForgotEmailSent: 'Code sent to {email}',
    authForgotSmsSent: 'Reset code sent by SMS',
    authForgotSetPassword: 'Choose a new password',
    authSetupNeedEmail: 'Add an email and create a password',
    authSetupNeedPassword: 'Create a sign-in password',
    authEmailPlaceholder: 'Email',
    authEmailCodePlaceholder: 'Email code',
    authSendEmailCode: 'Email code',
    authNewPasswordPlaceholder: 'New password',
    authConfirmPasswordPlaceholder: 'Confirm password',
    authSavePassword: 'Save and sign in',
    accChangePassword: 'Change password',
    accOldPassword: 'Current password',
    accNewPassword: 'New password',
    accConfirmPassword: 'Confirm new password',
    accPasswordChanged: 'Password changed',
    accPasswordChangeError: 'Could not change password',
    accPasswordShort: 'Password must be at least 8 characters',
    accPasswordsMismatch: 'Passwords do not match',
    unknownError: 'Unknown error',
    documents: 'Documents',
    downloadDocument: 'Download document',
    docPrivacy: 'Privacy policy',
    docTerms: 'User agreement',
    docPersonalData: 'Personal data processing policy',
    docAgreement: 'Consent to personal data processing',
    docCookies: 'Cookie policy',
    navMatches: 'Games',
    navApplications: 'Applications',
    navClientForms: 'Inquiries',
    navBlackList: 'Blacklist',
    cfLoading: 'Loading inquiries…',
    cfLoadError: 'Failed to load inquiries',
    cfNotFound: 'Inquiry not found',
    cfEmpty: 'No inquiries yet',
    cfEmptyHint: 'New forms from the site and app will appear here',
    cfFound: 'Found: {count}',
    cfScopeCity: 'city #{id}',
    cfFilterStatus: 'Status',
    cfFilterType: 'Type',
    cfFilterAll: 'All',
    cfStatusNew: 'New',
    cfStatusDone: 'Processed',
    cfStatusRejected: 'Rejected',
    cfStatusUnknown: 'Status',
    cfTypeJoin: 'Join championship',
    cfTypeOpenLeague: 'Open a league',
    cfTypeRegisterTeam: 'Register a team',
    cfTypeUnknown: 'Form',
    cfColDate: 'Date',
    cfColType: 'Type',
    cfColName: 'Name',
    cfColContact: 'Contact',
    cfColStatus: 'Status',
    cfColProcessedBy: 'Processed by',
    cfDetailTitle: 'Inquiry',
    cfPhone: 'Phone',
    cfEmail: 'Email',
    cfCity: 'City',
    cfContact: 'Contact',
    cfVk: 'VKontakte',
    cfHowLearned: 'How they found us',
    cfExperience: 'Experience',
    cfComment: 'Comment',
    cfChampionship: 'Championship',
    cfUserId: 'User',
    cfCreatedAt: 'Created',
    cfUpdatedAt: 'Updated',
    cfProcessedAt: 'Processed at',
    cfProcessedBy: 'Processed by',
    cfMarkDone: 'Mark processed',
    cfMarkRejected: 'Reject',
    cfMarkNew: 'Back to new',
    cfStatusSaved: 'Status updated',
    cfStatusError: 'Failed to update status',
    cfNoAccess: 'No access to inquiries',
    cfNoValue: '—',
    navStages: 'Stage management',
    navChampions: 'League podium',
    navChampionsShort: 'Podium',
    navTourTeam: 'Team of the round',
    navTourTeamShort: 'Squad',
    navDisqualifications: 'Disqualifications',
    navMedia: 'Media management',
    navTeams: 'Teams',
    navPlayers: 'Players',
    navDuplicates: 'Duplicates',
    navSchedule: 'Schedule management',
    navTournaments: 'Tournaments',
    navStadiums: 'Stadiums',
    navUsers: 'Users',
    navTransferWindows: 'Transfer window',
    navMatchStaff: 'Assignments',
    navTablo: 'Scoreboard',
    tabloTitle: 'OBS scoreboard',
    tabloSubtitle: 'Match session + transparent overlay for Browser Source',
    tabloPickMatchTitle: 'Match',
    tabloSessionTitle: 'Session & overlay',
    tabloAirTools: 'Broadcast: scenes & style',
    tabloAirToolsShow: 'Show broadcast settings',
    tabloAirToolsHide: 'Hide broadcast settings',
    tabloControlsTitle: 'Controls',
    tabloPreviewTitle: 'Preview',
    tabloPickMatch: 'Pick a match',
    tabloChangeMatch: 'Change match',
    tabloMatchSearchPh: 'Search match…',
    tabloRefresh: 'Refresh',
    tabloNoMatches: 'No matches found',
    tabloMatchesError: 'Could not load matches',
    tabloStyle: 'Scoreboard style',
    tabloCreateSession: 'Create session',
    tabloUpdateSession: 'Update style',
    tabloSessionReady: 'Scoreboard session ready',
    tabloSessionError: 'Could not create scoreboard session',
    tabloNeedSession: 'Create a session to get the OBS URL',
    tabloOverlayKey: 'Key',
    tabloCopyUrl: 'Copy URL',
    tabloOpenOverlay: 'Open overlay',
    tabloOpenMatch: 'Match card',
    tabloUrlCopied: 'URL copied',
    tabloLive: 'live',
    tabloControlsHint: 'Score and play state push to overlay via socket. Events and lineups are on the match card.',
    tabloWaitingState: 'Waiting for match data…',
    tabloHome: 'Home',
    tabloGuest: 'Away',
    tabloLayoutLineupsHint: 'Full lineups in this build are score + style label only',
    tabloLayoutStatsHint: 'Stats in this build are score + style label only',
    tabloScenes: 'Scene',
    tabloScoreGroup: 'Scoreboard',
    tabloGroupPrematch: 'Before the match',
    tabloGroupBreak: 'Halftime',
    tabloGroupFulltime: 'Full time',
    tabloScoreToggleHint: 'Scoreboard stays under the scene. Click a scene again to turn it off and leave only the scoreboard',
    tabloEventPulses: 'Event plaques',
    tabloEventPulsesHint: 'YC, RC and goals auto-show the event card and detailed result. Turn off to log events without overlay plaques',
    tabloScoreLayerMissing: 'Scoreboard layer missing from server response',
    tabloUnderlozhka: 'Color',
    tabloAccent: 'Accent',
    tabloBackground: 'Background',
    tabloTextColor: 'Text',
    tabloStyleSource: 'Style source',
    tabloResetStyle: 'Reset to league style',
    tabloEventFallback: 'Event',
    tabloCloseAir: 'Close broadcast',
    tabloRotateKey: 'Rotate key',
    tabloCloseConfirm: 'Close the broadcast? The overlay URL will stop working.',
    tabloRotateConfirm: 'Rotate overlay_key? Update the URL in OBS.',
    tabloClosedOk: 'Broadcast closed',
    tabloRotatedOk: 'Key rotated — update the OBS URL',
    tabloCloseError: 'Could not close broadcast',
    tabloRotateError: 'Could not rotate key',
    tabloClosed: 'Broadcast closed',
    tabloNoLineup: 'No lineup',
    tabloQuickHint: 'Tap a player to quickly add a goal, YC or RC using the live match clock.',
    tabloQuickAt: 'at',
    tabloQuickAssistTitle: 'Who assisted?',
    tabloQuickNoAssist: 'No assist',
    tabloShowTools: 'Scenes & OBS air',
    tabloHideTools: 'Hide scenes & air',
    navNews: 'News',
    navHelp: 'Instructions',
    navTimeSlots: 'Time slots',
    navReports: 'Reports',
    navPlayerStats: 'Player statistics',
    navInfographics: 'Infographics',
    navSponsors: 'My sponsors',
    igPictureType: 'Template',
    igPictureTypePh: 'Select template',
    igPictureTypeNotFound: 'Template not found',
    igTypeTable: 'Table',
    igTypeTop10: 'Top-10',
    igTypeCards: 'Cards',
    igTypeDisqualifications: 'Disqualifications',
    igTypeAfisha: 'Poster',
    igTypePlayoff: 'Bracket',
    igTypePreview: 'Match preview',
    igTypeDetailedResult: 'Detailed result',
    igTypeAnnouncement: 'Announcement',
    igTypeQuote: 'Quote',
    igTypeAchievements: 'Achievements',
    igTypeMatchCoverGoal: 'Video plates',
    igTypeBroadcastPreview: 'Broadcast preview',
    igBroadcastTitle: 'Broadcast headline',
    igBroadcastTournamentTitle: 'Tournament line',
    igBroadcastTournamentTitlePh: 'LEAGUE | 2026',
    igBroadcastTournamentTitleHint: 'Optional. If empty, the server builds it from the match league and year.',
    igTypeSchedule: 'Schedule',
    igTypeResults: 'Results',
    igTypeChess: 'Chess table',
    igTypeGroupTables: 'Group tables',
    igTypeCalendar: 'Calendar',
    igAfishaDate: 'Date',
    igAfishaCode: 'Text above date',
    igAfishaCodePh: 'Any text',
    igAfishaCodeHint: 'Optional — line above the date on the layout',
    igPlayoffLayout: 'Layout',
    igPlayoffVerticalHint: 'Single-sided layout — all sides left-to-right toward the final',
    igPlayoffVerticalForcedHint: 'Mirror unavailable — single-sided (no final or team filter)',
    igPlayoffTracks: 'Cups',
    igPlayoffTracksHint: 'Empty — all cups. Any subset is allowed; stages are picked within cups',
    igPlayoffTracksClear: 'Clear cups',
    igPlayoffStages: 'Stages',
    igPlayoffStagesHint: 'Empty — full bracket. Multiple — contiguous within one cup (1/8+1/4+1/2). No final → single-sided',
    igPlayoffStagesLoading: 'Stages appear after the first preview',
    igPlayoffStagesClear: 'Clear stages',
    igPlayoffStagesInvalid: 'Stages must be contiguous within a cup. 3rd place — with final or alone',
    igPlayoffStageEmpty: 'empty',
    igPlayoffTeams: 'Teams',
    igPlayoffTeamsHint: 'Empty — all. Otherwise only matches with selected teams (mirror turns off)',
    igPlayoffTeamsLoading: 'Teams appear after the first preview',
    igPlayoffTeamsClear: 'Clear teams',
    igAnnouncementText: 'Announcement text',
    igAnnouncementTextPh: 'ANNOUNCEMENT',
    igAnnouncementTextHint: 'Up to 6 lines — one per line break',
    igQuoteTeam: 'Team',
    igQuoteTeamPh: 'Select a team',
    igQuoteTeamNotFound: 'No teams found',
    igQuoteTeamsError: 'Failed to load teams',
    igQuoteName: 'Name',
    igQuoteNamePh: 'NAME',
    igQuoteText: 'Quote',
    igQuoteTextPh: 'QUOTE',
    igQuoteTextHint: 'Up to 4 lines — one per line break',
    igAchievementsTitle: 'Achievement',
    igAchievementsTitlePh: 'MVP',
    igAchievementsName: 'Name',
    igAchievementsNamePh: 'NAME',
    igCoverGoalDownload: 'Download ZIP',
    igCoverGoalDownloadDone: 'Plates pack downloaded',
    igCoverGoalTitle: 'MATCHDAY',
    igCoverGoalSettings: 'Video plates',
    igCoverGoalSettingsHint: 'Matchday 1920×1080: underlay, accent, socials; ZIP with goal/card frames',
    igErrMissingLeagueOrMatch: 'League and match are required.',
    igErrMissingTeamId: 'A team is required.',
    igErrMissingPlayerId: 'A player is required.',
    igErrMissingTourTeamOrPlayers: 'A saved squad or players lineup is required.',
    igErrPlayerNotFound: 'Player not found.',
    igErrTeamNotFound: 'Team not found.',
    igMvpPlayer: 'Player',
    igMvpTeam: 'Team',
    igMvpTeamPh: 'Select a team',
    igMvpLabel: 'Label',
    igMvpLabelPh: 'MVP OF THE ROUND',
    igMatchSubsRoster: 'Lineup',
    igMatchSubsFromDb: 'From DB',
    igMatchSubsManual: 'Manual',
    igMatchSubsDbHint: 'Lineup from the match application. You can fill positions manually (LB, CB…) via positionOverrides. If empty — use manual entry.',
    igMatchSubsManualHint: 'Search the DB or type number, family, name, position. No player limit.',
    igMatchSubsStarters: 'Starting XI',
    igMatchSubsBench: 'Bench',
    igMatchSubsHome: 'Home',
    igMatchSubsGuest: 'Away',
    igMatchSubsFamilyPh: 'Family name',
    igMatchSubsNamePh: 'First name',
    igMatchSubsPositionPh: 'Pos.',
    igMatchSubsPositionHint: 'Code or short label: LB, CB, CM…',
    igMatchSubsSearchPlayer: 'Find player in database',
    igMatchSubsEditPositions: 'Edit positions',
    igMatchSubsHidePositions: 'Hide positions',
    igMatchSubsOverwritePositions: 'Overwrite positions from player profile',
    igMatchSubsAdd: 'Add player',
    igMatchSubsRemove: 'Remove',
    igMatchSubsReloadDb: 'Load from DB',
    igMatchLineupsDbHint: 'Starters on two pitches (from lineup_position_id), bench as rows. You can override position/slot manually.',
    igMatchLineupsManualHint: 'For the pitch layout set slot: gk, def_0, mid_1, fwd_2… Plus number, name and position.',
    igMatchLineupsSlotPh: 'Slot',
    igMatchLineupsSlotHint: 'lineup_position_id: fwd_0…gk',
    igPictureGroupTournament: 'By tournament',
    igPictureGroupMatch: 'By match',
    igPictureGroupOther: 'Other',
    igFiltersNeedSeason: 'Select a season first',
    igMatchSubsNeedMatch: 'Select a match first',
    igTourTeamPick: 'Team of the round',
    igTourTeamPh: 'Select a squad',
    igTourTeamNotFound: 'No squads found',
    igTourTeamsError: 'Failed to load team of the round',
    igTourTeamFallback: 'Squad',
    igTourTeamHint: 'Edit the lineup in',
    igTourTeamOpenEditor: 'Team of the round',
    igPreviewMatch: 'Match',
    igPreviewMatchPh: 'Select a match',
    igPreviewMatchNotFound: 'No matches found',
    igPreviewMatchesError: 'Failed to load matches',
    igPreviewPhotos: 'Side photos',
    igPreviewPhotosHint: '300×1080 slots on left and right. Empty if no photo',
    igPreviewPhotoLeft: 'Left',
    igPreviewPhotoRight: 'Right',
    igPreviewPhotoEmpty: 'No photo',
    igPreviewPhotoUpload: 'Upload',
    igPreviewPhotoReplace: 'Replace',
    igPreviewPhotoCrop: 'Crop slot photo',
    igPreviewHeadline: 'Headline',
    igPreviewHeadlinePh: 'Stadium by default',
    igCalendarColumns: 'Columns',
    igCalendarGroupStagesOnly: 'Group stage only',
    igCalendarGroupStagesOnlyHint: 'For group leagues — only group-stage rounds',
    igGroupTablesPick: 'Groups',
    igGroupTablesPickHint: 'Up to 4 groups. Empty — server takes the first by priority',
    igGroupTablesEmpty: 'No season groups found',
    igSplitByGroups: 'Layout',
    igSplitByGroupsOn: 'By groups',
    igSplitByGroupsOff: 'Whole league',
    igTopStatsGroupsPick: 'Groups',
    igTopStatsGroupsHint: 'Empty — all season groups. Pick some to limit the picture',
    igErrLeagueTypeNotGroups: 'This league is not a group league (not type 2). Use the Table or Chess templates instead.',
    igErrLeagueTypeNotPlayoff: 'Bracket is only for playoff leagues (league_type = 2).',
    igErrLeagueSettingsMissing: 'Season settings are missing for this league — check the season.',
    igErrNoGroups: 'This season has no groups. Add groups in the season roster or pick another league.',
    igErrNoPlayoffRounds: 'This season has no playoff rounds.',
    igErrGroupsNotFound: 'Selected groups were not found in this season. Refresh the group list and pick again.',
    igErrUnknownStageIds: 'Selected stage is not in the bracket.',
    igErrStagesNotContiguous: 'Stages must be contiguous in the bracket.',
    igErrUnknownTrackKeys: 'Unknown cups in selection.',
    igErrEmptyTrackSelection: 'Select at least one cup.',
    igErrThirdRequiresFinal: '3rd place can only be with the final (or alone).',
    igErrUnknownTeamIds: 'Selected team is not in the playoff.',
    igErrNoMatchesForTeams: 'No matches for the selected teams.',
    igErrMissingLeagueOrSeason: 'League and season are required.',
    igErrMissingLeagueSeasonOrDate: 'League, season and date are required.',
    igErrMissingMatchId: 'A match is required.',
    igErrMatchNotFound: 'Match not found.',
    igMatchStatsBars: 'Bar colors',
    igMatchStatsBarsHint: 'Default — team color or theme accent / translucent white. Reset clears the manual override.',
    igMatchStatsHomeBar: 'Home',
    igMatchStatsGuestBar: 'Away',
    igMatchStatsBarReset: 'Use team',
    igMatchStatsBarSourceOverride: 'manual',
    igMatchStatsBarSourceTeam: 'team color',
    igMatchStatsBarSourceDefault: 'theme default',
    igErrInvalidDate: 'Date must be YYYY-MM-DD.',
    igResultsIncludeUpcoming: 'Upcoming',
    igResultsIncludeUpcomingHint: 'Show kickoff time for unplayed matches',
    igScheduleFilter: 'Matches',
    igScheduleByStage: 'By round',
    igScheduleByDates: 'By dates',
    igScheduleStage: 'Round',
    igScheduleStagePh: 'Select round',
    igScheduleStageNotFound: 'No rounds found',
    igScheduleDateFrom: 'From',
    igScheduleDateTo: 'To',
    igScheduleSeasonOptional: 'Season (optional)',
    igScheduleSeasonOptionalPh: 'Narrow by season',
    igMatchListPick: 'Matches on image',
    igMatchListPickHint: 'All by default. Uncheck matches to hide them from the image.',
    igMatchListMyStaff: 'My assignments',
    igMatchListMyStaffHint: 'Only matches where you are assigned as staff',
    igMatchListMyStaffEmpty: 'No matches with your assignment',
    igMatchListAll: 'All',
    igMatchListNone: 'Clear all',
    igMatchListEmpty: 'No matches',
    igMatchListLoading: 'Loading matches…',
    igMatchListError: 'Failed to load match list',
    igMatchListSelected: 'Selected: {n} of {total}',
    igSubtitle: 'Tournament table for social media',
    igPreview: 'Preview',
    igPreviewCollapse: 'Collapse',
    igPreviewExpand: 'Show preview',
    igPreviewOpen: 'Open',
    igPreviewClose: 'Close',
    igSponsors: 'Sponsors',
    igSponsorsHint: 'Pick a logo from the pool, drag on the preview, scale from the corner',
    igSponsorsMy: 'My sponsors',
    igSponsorsPickPh: 'Find a sponsor…',
    igSponsorsPickEmpty: 'Pool is empty — add logos in My sponsors',
    igSponsorsPickNeedLeague: 'Select a league first',
    igSponsorsNeedLeague: 'Select a league above — then the sponsor pool will load',
    igSponsorsAddBtn: 'Add to image',
    igSponsorsLeague: 'League default',
    igSponsorsLeagueEmpty: 'No default yet — will save on PNG download',
    igSponsorsLeagueFallback: 'League default (other type)',
    igSponsorsLeagueHint: 'Updates automatically when you download a PNG',
    igSponsorsLeagueApply: 'Apply default',
    igSponsorsSchemes: 'Sponsor schemes',
    igSponsorsSchemeNamePh: 'Sponsor scheme name',
    igSponsorsSchemeSave: 'Save scheme',
    igSponsorsSchemeSaved: 'Sponsor scheme saved',
    igSponsorsSchemeSaveError: 'Failed to save sponsor scheme',
    igSponsorsSchemeDeleted: 'Sponsor scheme deleted',
    igSponsorsSchemeDeleteError: 'Failed to delete sponsor scheme',
    igSponsorsSchemeDelete: 'Delete scheme',
    igSponsorsSchemeNameRequired: 'Enter a scheme name',
    igSponsorsLoadError: 'Failed to load sponsors',
    igSponsorsPlaced: 'On image',
    igSponsorsEmpty: 'No sponsors on the image yet',
    igSponsorsNeedPreview: 'Select a league and season first',
    igSponsorsBringFront: 'Bring front',
    igSponsorsRemove: 'Remove',
    igSponsorsAddError: 'Failed to add sponsor',
    igSponsorsAnchorHint: 'Logos in the lower half of the canvas are pinned to the bottom automatically — they stay there at any image height',
    spLoadError: 'Failed to load sponsors',
    spLoading: 'Loading sponsors…',
    spSearchPh: 'Search by name',
    spFound: 'Found: {count}',
    spEmpty: 'No sponsors yet',
    spEmptyHint: 'Add a logo — it will appear in the infographics pool',
    spImage: 'Logo',
    spName: 'Name',
    spNamePh: 'e.g. Puma',
    spNameRequired: 'Enter a sponsor name',
    spImageRequired: 'Upload a sponsor image',
    spAdd: 'Add sponsor',
    spAddShort: 'Add',
    spAddTitle: 'New sponsor',
    spSaving: 'Saving…',
    spAdded: 'Sponsor added',
    spAddError: 'Failed to add sponsor',
    spDelete: 'Delete',
    spDeleteTitle: 'Delete sponsor?',
    spDeleteConfirm: 'Delete sponsor “{name}”?',
    spDeleteText: 'Are you sure you want to delete “{name}”? This cannot be undone.',
    spDeleted: 'Sponsor deleted',
    spDeleteError: 'Failed to delete sponsor',
    spBackToInfographics: 'Back to infographics',
    igDownload: 'Download PNG',
    igDownloading: 'Rendering PNG…',
    igLoadingPreview: 'Loading preview…',
    igLoadingPreviewHint: 'This may take a few seconds',
    igSelectLeagueSeason: 'Select a league and season',
    igTheme: 'Backdrop',
    igUnderSolid: 'New',
    igUnderPattern: 'Old',
    igThemeBlue: 'Blue',
    igThemeGreen: 'Green',
    igThemeBrown: 'Brown',
    igThemeYellow: 'Yellow',
    igThemeRed: 'Red',
    igThemePurple: 'Purple',
    igLogoCaption: 'Shield caption',
    igLogoCaptionPh: 'e.g. MOSCOW 8X8',
    igTitle: 'Title',
    igTitleColor: 'Title color',
    igAccent: 'Accent',
    igBgColor: 'Background color',
    igStadiumBg: 'Stadium ribbon',
    igTableBg: 'Table background',
    igLeagueBarBg: 'League bar background',
    igAlpha: 'Opacity',
    igFooter: 'Footer socials',
    igFooterColor: 'Socials color',
    igFooterWeb: 'Website',
    igBgUrl: 'Backdrop',
    igUploadOwn: 'Custom',
    igUploadHint: 'PNG, JPG or WebP · crop to table size',
    igUploadBusy: 'Processing…',
    igUploadError: 'Failed to load image',
    igUploadTypeError: 'Use a PNG, JPG or WebP file',
    igUploadNeedPreview: 'Select a league and season first — preview size is needed for cropping',
    igCropTitle: 'Backdrop crop',
    igCustomPalette: 'Palette for custom backdrop',
    igRemoveUpload: 'Remove file',
    igAdvanced: 'Advanced',
    igStyles: 'Color schemes',
    igStyleApplied: 'Selected',
    igStyleLeague: 'This league colors',
    igStyleLeagueFallback: 'This league colors',
    igStyleFallbackShort: 'similar',
    igStyleLeagueHint: 'Updates automatically when you download a PNG',
    igStyleLeagueHintZip: 'Updates automatically when you download a ZIP',
    igStyleLeagueEmpty: 'Appears after the first PNG download',
    igStyleLeagueEmptyZip: 'Appears after the first ZIP download',
    igStyleLeagueSave: 'Save for league',
    igStyleLeagueSaved: 'League style saved',
    igStyleLeagueSaveError: 'Failed to save league style',
    igSchemes: 'Shared schemes',
    igSchemeSave: 'Save scheme',
    igSchemeNamePh: 'Color scheme name',
    igSchemeNameRequired: 'Enter a scheme name',
    igSchemeSaved: 'Color scheme saved',
    igSchemeSaveError: 'Failed to save scheme',
    igSchemeDelete: 'Delete scheme',
    igSchemeDeleted: 'Scheme deleted',
    igSchemeDeleteError: 'Failed to delete scheme',
    igRecent: 'Recent colors',
    igStylesLoadError: 'Failed to load color schemes',
    igReset: 'Reset',
    igPreviewEmpty: 'Select a league and season to see the preview',
    igPreviewError: 'Failed to load preview',
    igDownloadError: 'Failed to download PNG',
    igDownloadDone: 'PNG downloaded',
    igUnderlozhkiError: 'Backdrop catalog unavailable, showing local presets',
    rpSummary: 'Summary',
    rpMatches: 'Match report',
    rpStaff: 'Staff',
    rpPlayersCount: 'Player count',
    rpBirthdays: 'Birthdays',
    rpBest: 'Top players / teams',
    rpTabPlayersCount: 'Players',
    rpTabBirthdays: 'B-days',
    rpTabBest: 'Top',
    rpTabSummary: 'Overview',
    rpTabMatches: 'Games',
    rpTabStaff: 'Staff',
    rpDateFrom: 'From',
    rpDateTo: 'To',
    rpSearchTeams: 'Search teams',
    rpSearchStaff: 'Name or role',
    rpSearchCity: 'Search city',
    rpFlag: 'Games',
    rpFlagAll: 'All games',
    rpFlagNoResult: 'No result',
    rpFlagNoVideo: 'No video',
    rpFlagNoPhoto: 'No photo',
    rpFlagNoLineup: 'Lineups not set',
    rpGender: 'Gender',
    rpGenderAll: 'All',
    rpGenderMale: 'Male',
    rpGenderFemale: 'Female',
    rpStatus: 'Status',
    rpStatusAll: 'All',
    rpStatusAmateur: 'Amateur',
    rpStatusPro: 'Professional',
    rpAge: 'Age',
    rpAgeFrom: 'From',
    rpAgeTo: 'To',
    rpAgeInvalid: 'Age from cannot be greater than age to',
    rpMatchesCount: 'Matches: {count}',
    rpPlayersTotal: 'Players: {count}',
    rpShowPlayers: 'Show players',
    rpHidePlayers: 'Hide players',
    rpPlayersLoading: 'Loading players…',
    rpInsured: 'Insured',
    rpNotInsured: 'Not insured',
    rpInsuranceUntil: 'until {date}',
    rpNoStadium: 'No stadium',
    rpNoData: 'No data',
    rpNeedDates: 'Enter dates',
    rpNeedChamp: 'Select a championship',
    rpCapLineup: 'Captain set lineup',
    rpAdminLineup: 'Lineup',
    rpHome: 'Home',
    rpGuest: 'Away',
    rpSlots: 'Slots',
    rpGamesPlayed: 'Games: {count}',
    rpScorers: 'Scorers',
    rpAssists: 'Assists',
    rpGoalsAssists: 'Goals + assists',
    rpYellow: 'Yellow cards',
    rpRed: 'Red cards',
    rpTeamsGoals: 'Teams by goals',
    rpBiggestWins: 'Biggest wins',
    rpRoughest: 'Roughest matches',
    rpUnknown: 'Untitled',
    rpLeagues: 'Leagues',
    tsAddMatch: 'Add match',
    tsGames: 'Matches',
    tsAddSlot: 'Add time slot',
    tsSlots: 'Time slots',
    tsSelectCountry: 'Country',
    tsLeague: 'League',
    tsSelectLeague: 'League',
    tsSeason: 'Season',
    tsSelectSeason: 'Season',
    tsTour: 'Tour',
    tsSelectTour: 'All tours',
    tsSearchTeams: 'Search by team',
    tsPickCascade: 'Select country, league and season',
    tsMatchesLoading: 'Loading matches',
    tsMatchesEmpty: 'No matches found',
    tsLoadMore: 'More matches',
    tsLoading: 'Loading...',
    tsGamesEmpty: 'Pick matches in the first block',
    tsRemoveMatch: 'Remove match',
    tsDeleteWishes: 'Delete wishes',
    tsOpenWishes: 'Open wishes',
    tsStadium: 'Stadium',
    tsStadiumPh: 'Search stadium',
    tsStadiumLoading: 'Searching stadiums...',
    tsStadiumEmpty: 'No stadiums found',
    tsTimezone: 'Venue timezone',
    tsTimezoneAuto: 'Auto ({tz})',
    tsTimezoneHint: 'Wall-clock time at the venue (championship city / stadium), not the admin laptop',
    tsClearStadium: 'Clear stadium',
    tsPitch: 'Pitch',
    tsSelectPitch: 'Select a pitch',
    tsStart: 'Start',
    tsEnd: 'End',
    tsDuration: 'Duration, min',
    tsAddSlots: 'Add slots',
    tsNeedRange: 'Set start, end and duration',
    tsRangeInvalid: 'End must be after start',
    tsNeedStadium: 'Select a stadium first',
    tsTooManySlots: 'Too many slots — only part was added',
    tsNoSlotsFit: 'No slot fits into the selected range',
    tsSlotsAdded: 'Slots added: {count}',
    tsSelectScheme: 'Saved scheme',
    tsLoadScheme: 'Load',
    tsDeleteScheme: 'Delete scheme',
    tsDeleteSchemeConfirm: 'Delete this scheme on the server?',
    tsSchemeName: 'Scheme name',
    tsSchemeNamePh: 'e.g. Weekends, venue 1',
    tsNeedSchemeName: 'Enter a scheme name',
    tsSlotsEmpty: 'No slots yet. Load a scheme or add slots',
    tsEmptySlot: 'Empty',
    tsAssignHint: 'Select a match here, then click an empty slot',
    tsDropHere: 'Assign selected match',
    tsRemoveSlot: 'Remove slot',
    tsDetachMatch: 'Detach match from slot',
    tsAssignTime: 'Assign time',
    tsAutoAssign: 'Auto-assign',
    tsAutoAssignOk: 'Filled {count} matches. Click “Assign time” to save',
    tsAutoAssignPartial: 'Auto-assigned {ok}, failed {fail}',
    tsAutoAssignNone: 'Nowhere to place: no free slots',
    tsAutoAssignError: 'Could not auto-assign',
    tsWishHome: 'Home',
    tsWishAway: 'Away',
    tsWishFits: 'Fits {times}',
    tsWishNoFits: 'Does not fit {times}',
    tsWishNoAnswer: 'No wish answers yet',
    tsSlotWishHint: 'Captain wishes for this slot: home / away',
    tsSaveScheme: 'Save slot scheme',
    tsSaveText: 'Save text',
    tsLoadCountriesError: 'Could not load countries',
    tsLoadLeaguesError: 'Could not load leagues',
    tsLoadSeasonsError: 'Could not load seasons',
    tsLoadStagesError: 'Could not load tours',
    tsLoadMatchesError: 'Could not load matches',
    tsLoadPitchesError: 'Could not load pitches',
    tsLoadSchemesError: 'Could not load schemes',
    tsSchemeLoaded: 'Loaded scheme “{name}”, matches in slots: {count}',
    tsSchemeLoadedEmpty: 'Scheme “{name}” loaded, but the server returned empty slots',
    tsSchemeLoadedNoMatches: 'Scheme “{name}” loaded. Slots stay empty until both teams set fits = 1 — that is expected.',
    tsNeedWeekDate: 'Week date is missing',
    tsSchemeDeleted: 'Scheme deleted',
    tsDeleteSchemeError: 'Could not delete the scheme',
    tsWishesOpened: 'Wishes opened. Not created for matches: {skipped}.',
    tsWishesOpenedOk: 'Wishes opened.',
    tsWishesSkippedHint: 'Skipped matches did not get wishes. Usually they are already played.',
    tsOpenWishesError: 'Could not open wishes',
    tsDeleteWishesConfirm: 'Delete all wishes for the selected matches?',
    tsWishesDeleted: 'Wishes deleted: {deleted}',
    tsDeleteWishesError: 'Could not delete wishes',
    tsAssignOk: 'Matches assigned: {count}',
    tsAssignPartial: 'Assigned {ok}, failed {fail}',
    tsAssignError: 'Could not assign time',
    tsSchemeSaved: 'Scheme saved',
    tsSaveSchemeError: 'Could not save the scheme',
    tsTxtEmpty: 'No matches in slots to export',
    tsOk: 'OK',
    tsOkTitle: 'Done',
    tsErrorTitle: 'Error',
    tsTxtSaved: 'File saved',
    newsSearchPh: 'Search by title',
    newsFound: 'News found: {count}',
    newsEmpty: 'No news found',
    newsEmptyHint: 'Change the search or add a new post',
    newsLoading: 'Loading news',
    newsLoadingCard: 'Loading news item',
    newsLoadError: 'Could not load news',
    newsNotFound: 'News item not found',
    newsCreate: 'Add post',
    newsNew: 'New post',
    newsEdit: 'Edit post',
    newsTitle: 'Title',
    newsTitlePh: 'News title',
    newsPreview: 'Subtitle',
    newsPreviewPh: 'Short description',
    newsTags: 'Tags',
    newsTagsPh: 'Find or add a tag',
    newsTagsFilterPh: 'Filter by tag',
    newsTagAdd: 'Add “{key}”',
    newsTagRemove: 'Remove tag {key}',
    newsTagInvalid: 'Tag: latin letters, digits, _ and -',
    newsTagsLoading: 'Loading tags',
    newsTagsEmpty: 'No tags found',
    newsTagsLoadError: 'Could not load tags',
    newsNoTags: 'No tags',
    newsNoEntities: 'No entities',
    newsText: 'Post text',
    newsTextPh: 'Write the news text',
    newsSave: 'Save post',
    newsSaved: 'Post saved',
    newsCreated: 'Post created',
    newsSaveError: 'Could not save the post',
    newsDeleteTitle: 'Delete this post?',
    newsDeleteText: 'The post, its tags and read marks will be deleted. This cannot be undone.',
    newsDeleted: 'Post deleted',
    newsDeleteError: 'Could not delete the post',
    newsNeedTitle: 'Enter a title',
    newsDate: 'Date',
    newsSortDate: 'By date',
    newsSortTitle: 'By title',
    newsSortTag: 'By tag',
    newsTagBindingsHint: 'These bindings are applied to a new tag. Existing tags stay as they are.',
    newsEntities: 'Linked entities',
    newsEntitiesPh: 'Find a team, player, match…',
    newsEntityRemove: 'Remove {name}',
    searchAddFilter: 'Add filter',
    searchTypeAll: 'All types',
    searchTypeCity: 'City',
    searchTypeLeague: 'League',
    searchTypeChamp: 'Championship',
    searchTypeTeam: 'Team',
    searchTypeStadium: 'Stadium',
    searchTypeMatch: 'Match',
    searchTypePlayer: 'Player',
    searchTypeClient: 'Client',
    searchTypePerson: 'Person',
    searchTypeMigration: 'Migration ID',
    searchEntityPh: 'Find an entity',
    searchMigrationPh: 'migrationId',
    searchApply: 'OK',
    searchLoading: 'Searching...',
    searchEmpty: 'Nothing found',
    searchLoadError: 'Could not search',
    searchRemoveFilter: 'Remove filter {label}',
    globalSearchPh: 'Player, team, league, stadium, match',
    globalSearchPhShort: 'Search',
    globalSearchLabel: 'Global search',
    globalSearchNeedChamp: 'Select a championship first',
    globalSearchHint: 'Start typing a name',
    globalSearchType: 'Entity type',
    globalSearchOpen: 'Open search',
    globalSearchClose: 'Close search',
    newsEditorBold: 'Bold',
    newsEditorItalic: 'Italic',
    newsEditorHeading: 'Heading',
    newsEditorQuote: 'Quote',
    newsEditorLink: 'Link',
    newsEditorImage: 'Insert photo',
    newsEditorLinkPh: 'Link URL',
    usrSearchPh: 'Login, name, last name, email or identifier',
    usrFound: 'Users found: {count}',
    usrLogin: 'Login',
    usrId: 'ID',
    usrRoles: 'Roles',
    usrChampionships: 'Championships',
    usrEmpty: 'No users found',
    usrEmptyHint: 'Change the search or filters',
    usrLoading: 'Loading users',
    usrLoadingCard: 'Loading user card',
    usrLoadError: 'Could not load users',
    usrNotFound: 'User not found',
    usrAllRoles: 'All roles',
    usrAllChamps: 'All championships',
    usrCardTitle: 'User card',
    usrFields: 'User details',
    usrEditRoles: 'Roles and championships',
    usrEditChamps: 'Championships',
    usrPlayers: 'Linked players',
    usrMainRole: 'Primary role',
    usrConfirmed: 'Confirmed',
    usrYes: 'Yes',
    usrNo: 'No',
    usrNoChamps: 'No championships',
    usrNoPlayers: 'No linked players',
    usrEmail: 'Email',
    usrPhone: 'Phone',
    usrCity: 'City',
    usrCityId: 'City ID',
    usrIdentificator: 'Identifier',
    usrDefaultChamp: 'Default championship',
    usrBirthday: 'Date of birth',
    usrVk: 'VK',
    usrTelegram: 'Telegram',
    usrName: 'First name',
    usrFamily: 'Last name',
    usrFatherName: 'Patronymic',
    usrRootLocked: 'You cannot remove the root role from yourself',
    usrAutoRolesHint: 'Each assignment is a role + championship pair. Captain and vice-captain are assigned with a team. Guest and player roles are set by the server: linked player → player, otherwise → guest.',
    usrRolesScopedHint: 'Only assignments in your championships are shown. On save this list is sent as the full set for your scope — the server keeps other championships.',
    usrRolesAutosaveHint: 'A role is saved as soon as you click “Add” or remove it.',
    usrForbidden: 'Access denied: role above yours, another championship, or a user with a higher role',
    usrNoPlayerRole: 'A user without a linked player cannot have the player role.',
    usrLinkPlayer: 'Link player',
    usrUnlinkPlayer: 'Unlink player',
    usrUnlinkPlayerText: 'Unlink {name} from this account?',
    usrLinkError: 'Could not link the player',
    usrUnlinkError: 'Could not unlink the player',
    usrPickPlayerTitle: 'Link player',
    usrPlayerSearchPh: 'Last or first name',
    usrAlreadyLinked: 'Already linked',
    usrCreate: 'Create user',
    usrNewUser: 'New user',
    usrPassword: 'Password',
    usrConfirmPassword: 'Confirm password',
    usrPasswordPh: 'At least 8 characters',
    usrPhonePh: '+7 999 123-45-67',
    usrPasswordOrPhone: 'Password or phone is required',
    usrPasswordMin: 'Password must be at least 8 characters',
    usrPasswordMismatch: 'Passwords do not match',
    usrLoginRequired: 'Enter a login',
    usrNameRequired: 'Enter a first name',
    usrFamilyRequired: 'Enter a last name',
    usrPhoneInvalid: 'Invalid phone number',
    usrChampSearchPh: 'Search championship',
    usrChampsSelected: 'Selected: {count}',
    usrAddAssignment: 'Add',
    usrSelectRole: 'Role',
    usrSelectChamp: 'Championship',
    usrSelectTeam: 'Team',
    usrPickTeam: 'Choose a team',
    usrPickTeamTitle: 'Assign a team',
    usrTeamSearchPh: 'Team name',
    usrAssignmentExists: 'This assignment already exists',
    usrChampRequired: 'Select a championship for this role',
    usrChampNoAccess: 'You do not have permission to change a team in this championship',
    usrTeamRequired: 'Captain and vice-captain require a team',
    usrNoAssignments: 'No assignments',
    usrAssignmentsSelected: 'Assignments: {count}',
    usrRemoveAssignment: 'Remove assignment',
    usrAlreadyAssignedTeam: 'Team already assigned',
    roleGuest: 'User',
    rolePlayer: 'Player',
    roleCaptain: 'Captain',
    roleViceCap: 'Vice-captain',
    roleAdministrator: 'Administrator',
    roleHead: 'Head',
    roleRoot: 'Root',
    roleOperator: 'Operator',
    roleJournalist: 'Journalist',
    rolePhotographer: 'Photographer',
    roleDoctor: 'Doctor',
    roleInspector: 'Inspector',
    roleReferee: 'Referee',
    msStaff: 'Staff',
    msStaffSearch: 'Find an employee',
    msStaffEmpty: 'No employees found',
    msPool: 'Selected staff',
    msPoolEmpty: 'The list is empty — pick an employee above',
    msPoolHint: 'Click a person, then tap + on a match, or drag the card onto a match',
    msMatches: 'Upcoming matches',
    msMatchesHint: 'Unplayed matches for the next 7 calendar days',
    msMatchesEmpty: 'No matches in the next 7 days',
    msNoStadium: 'No stadium',
    msNoStaff: 'No staff assigned',
    msAssignHint: 'Click + or drop to assign {name}',
    msUnassignHint: 'Remove {name} from the match',
    msInspectorHint: 'Inspectors appear in the staff list but cannot be assigned to a match',
    msAlreadyAssigned: '{name} is already assigned to this match',
    msSlotsFull: 'This match has no free slot for the {role} role',
    msCannotAssign: 'This employee cannot be assigned to a match',
    msRefereePickTitle: 'Referee type',
    msRefereeMain: 'Main referee',
    msRefereeAssistant1: 'First assistant',
    msRefereeAssistant2: 'Second assistant',
    msRefereeTimekeeper: 'Timekeeper',
    msRefereeLine: 'Line judge',
    msRemoveMatch: 'Remove match from the current set',
    msRemoveStaff: 'Remove employee from the pool',
    msRestoreAll: 'Show all matches',
    msLoading: 'Loading assignments',
    msLoadError: 'Could not load assignments',
    msSaved: 'Assignments saved',
    msSaveError: 'Could not save assignments',
    msNoChamp: 'Select a championship in the header to assign staff',
    msNeedWrite: 'View only. Match write access is required to assign staff',
    msVs: 'vs',
    msGames: 'games: {count}',
    capSearchPh: 'Team, captain, comment or application',
    capAllLeagues: 'All leagues',
    capEmpty: 'No applications',
    capEmptyHint: 'Change the filter or wait for new captain applications',
    capLoading: 'Loading applications',
    capLoadingOne: 'Loading application',
    capTeam: 'Team',
    capPlace: 'Country / league',
    capName: 'Application name',
    capDate: 'Date',
    capStatus: 'Status',
    capStatusAccepted: 'Accepted',
    capStatusDeclined: 'Declined',
    capStatusPartial: 'Partially accepted',
    capStatusPending: 'Pending',
    capFromBot: 'From bot',
    capOnlyNew: 'Show new only',
    capLoadError: 'Could not load applications',
    capNotFound: 'Application not found',
    capManageTitle: 'Application #{id}',
    capInfo: 'Details',
    capComments: 'Comments',
    capCounts: 'Totals',
    capPlayers: 'Players',
    capCaptain: 'Captain',
    capCapComment: 'Captain comment',
    capAdminComment: 'Admin comment',
    capTotal: 'Total requested',
    capApproved: 'Accepted',
    capRejected: 'Declined',
    capWaiting: 'Pending',
    capExpandAll: 'Expand all players',
    capCollapseAll: 'Collapse all players',
    capApproveAll: 'Accept all players',
    capResetAll: 'Reset all player statuses',
    capCurrentRoster: 'Current squad ({count})',
    capAccept: 'Accept',
    capDecline: 'Decline',
    capSaving: 'Saving...',
    capActionAdd: 'Add',
    capActionRemove: 'Remove',
    capActionChange: 'Change',
    capPlayerStatusPending: 'Pending',
    capPlayerStatusAccepted: 'Accepted',
    capPlayerStatusDeclined: 'Declined',
    capHeight: 'Height',
    capWeight: 'Weight',
    capBirthday: 'Date of birth',
    capNationality: 'Nationality',
    capFoot: 'Preferred foot',
    capPosition: 'Position',
    capPlayerApps: 'Other applications',
    capMoreApps: 'And {count} more',
    capNoActiveApps: 'No active applications',
    capMore: 'Details',
    capBlacklist: 'This player is on the blacklist!',
    capWarnSameNumber: 'Two players have the same number',
    capWarnNumberTaken: 'This number is already taken in the team squad',
    capWarnAlreadyIn: 'This player is already in the team squad',
    capCommentTitle: 'Leave a comment',
    capCommentPh: 'Comment',
    capAddComment: 'Add',
    capPlayerTeamsTitle: 'Teams of {name}',
    capLeague: 'League',
    capPlayerAppsEmpty: 'No active applications',
    capPlayerAppsError: 'Could not load player applications',
    capDeclineTitle: 'Decline application',
    capDeclineText: 'Changes will not be added to the squad. Do you really want to decline this application?',
    capDeclineText2: 'Add a comment for the captain if needed',
    capDeclinePh: 'Reason for declining',
    capAcceptTitle: 'Accept application',
    capAcceptText: 'Changes will be added to the squad ({decided} of {total} players). Do you really want to accept this application?',
    capContinue: 'Continue',
    capAcceptError: 'Could not accept the application',
    capDeclineError: 'Could not decline the application',
    capAcceptSuccess: 'Application accepted',
    capDeclineSuccess: 'Application declined',
    capForgotDecisions: 'No players marked yet — accept or decline changes for each player',
    capAcceptEmptyWarn: 'Warning: no players are marked. The application will be accepted without roster changes.',
    capRelated: 'And {count} more {word}',
    capRelatedOne: 'related team',
    capRelatedFew: 'related teams',
    capRelatedMany: 'related teams',
    capNumber: 'Shirt number',
    capNoPlayers: 'This application has no players',
    capRoster: 'Squad',
    capRosterLoading: 'Loading squad',
    capRosterLoadError: 'Could not load the squad',
    capRosterEmpty: 'No players in this application',
    capRosterEmptyHint: 'Pick another application or add players on the team page',
    capRosterEmptySearchHint: 'Change the query or clear the search',
    matchCenter: 'Games',
    createMatch: 'Create game',
    cmTitle: 'Create match',
    cmNeedCountry: 'Select a country',
    cmNeedHome: 'Select the home team',
    cmNeedGuest: 'Select the away team',
    cmTeamsDifferent: 'Teams must be different',
    cmCreateError: 'Could not create the match',
    cmCountryNotFound: 'Country not found',
    cmCountryPh: 'Select a country',
    cmSeasonNotFound: 'Season not found',
    cmNoStages: 'No stages in this season',
    cmStageNotFound: 'Stage not found',
    cmNeedStage: 'Select a stage',
    cmHomeTeam: 'Home team',
    cmGuestTeam: 'Away team',
    cmLoadingTeams: 'Loading teams...',
    cmPickTeam: 'Tap to pick a team',
    cmNoTeams: 'No teams in this season',
    cmCheckingDuplicates: 'Checking for duplicates...',
    cmDuplicatesFound: 'Duplicates found: {count}',
    cmTour: 'Round',
    cmStillCreate: 'You can still create this match',
    cmStadiumNotFound: 'Stadium not found',
    cmStadiumPh: 'Select a stadium',
    cmRefereePh: 'Select a referee',
    cmRefereeNotFound: 'Referee not found',
    cmDateOptional: 'Date (required if time is set)',
    cmHalfMinutes: 'Half length, minutes',
    cmNetPosition: 'Bracket position',
    cmNetPositionAuto: 'Auto (next free slot)',
    cmNetPositionClear: 'Clear',
    cmNetPositionSlot: 'Slot {slot}',
    cmNetPositionHint: 'Pick a round cell (e.g. 1/8-1). Pairs 1+2 → next round-1, 3+4 → -2',
    cmCreating: 'Creating...',
    cmClear: 'Clear',
    gmSearchPh: 'Team, stadium or league',
    gmFound: 'Games found: {count}',
    gmMyGames: 'My games',
    gmNoLineup: 'No lineup',
    gmUnplayed: 'Unfinished',
    gmNoDate: 'No date',
    gmFilterAll: 'All games',
    gmAllCountries: 'All countries',
    gmAllLeagues: 'All leagues',
    gmAllSeasons: 'All seasons',
    gmAllDates: 'All dates',
    gmEmpty: 'No games found',
    gmEmptyHint: 'Change the search or filters',
    gmDate: 'Date',
    gmPitch: 'Pitch',
    gmPitchPlaceholder: 'Select a pitch',
    gmPitchNotFound: 'Pitch not found',
    gmLoadMore: 'Load more',
    gmResult: 'Result',
    gmTournament: 'Tournament',
    gmPlace: 'Date and venue',
    gmStaff: 'Staff',
    gmVideos: 'Video',
    gmPhotos: 'Photos',
    gmEvents: 'Events',
    gmMainEventsOnly: 'Main events only',
    gmQuickEvents: 'Quick events',
    gmQuickHotkeysHint: 'Keys G / A / Y / R — goal, own goal, YC, RC. Work outside input fields, without Ctrl/⌘. Enter in the modal saves.',
    gmUseLiveClock: 'Now',
    gmLineups: 'Lineups',
    gmProtocol: 'Protocol',
    gmFillProtocol: 'Fill as protocol',
    gmFillEvents: 'Show events',
    gmDownloadPdf: 'Download PDF',
    gmMessageIdle: 'Every block is saved by its own button — the result will appear here',
    gmProtocolTimeNote: 'This mode records match totals only, so events get random minutes and assists are assigned to random teammates. You can fix the time and assists in the “Events” block or turn the timeline off in match settings — then the app hides minutes.',
    gmSaveLineup: 'Save',
    gmLineupSaved: 'Lineup saved',
    gmLineupSetup: 'Formation',
    gmSaveSetup: 'Save formation',
    gmLineupSetupSaved: 'Formation saved',
    gmCaptainLineup: 'Captain lineup',
    gmCaptainShort: 'cap.',
    gmCaptainLineupPending: 'Lineup submitted, not approved by admin',
    gmCaptainLineupHint: 'The captain sent a lineup. You can work with it; saving turns it into the admin lineup.',
    gmApproveLineup: 'Approve lineup',
    gmEditSetup: 'Edit',
    gmNoFormation: 'No formation selected',
    gmLegendMvp: 'best player of the match',
    gmLegendKeeper: 'goalkeeper',
    gmLegendDouble: 'player from the reserve team',
    gmLongPressHint: 'Press and hold a player row (or right-click) to mark MVP or goalkeeper',
    gmMarkMvp: 'Mark as MVP',
    gmUnmarkMvp: 'Remove MVP mark',
    gmMaxMvp: 'You can mark at most {count} MVPs per team',
    gmMarkKeeper: 'Mark as goalkeeper',
    gmUnmarkKeeper: 'Remove goalkeeper mark',
    gmSubmitProtocol: 'Submit',
    gmProtocolEmpty: 'Unfilled protocol',
    gmProtocolFilled: 'Filled protocol',
    gmProtocolEmptyHint: 'Lineups included, events left blank — for printing',
    gmProtocolFilledHint: 'Lineups and match events',
    gmSaveChanges: 'Save changes',
    gmSetPenalties: 'Set penalties',
    gmEditPenalties: 'Edit shootout',
    gmDeleteMatch: 'Delete match',
    gmDeleteMatchError: 'Failed to delete match',
    gmDeletePenalties: 'Remove shootout',
    gmPenaltiesDeleted: 'Penalty shootout removed',
    gmMarkPostponed: 'Mark as postponed',
    gmUnpostpone: 'Clear postponement',
    gmPostponed: 'Match postponed',
    gmAddStaff: 'Add staff',
    gmAddVideo: 'Add video',
    gmAddEvent: 'Add event',
    gmEditEvent: 'Edit event',
    gmDeleteEvent: 'Delete event',
    gmSecondPlayer: 'Second player',
    gmPlayerIn: 'Player in',
    gmEventTime: 'Time',
    gmMinute: 'Minute',
    gmSecond: 'Second',
    gmMinuteRequired: 'Enter the event minute',
    gmNeedEventPlayer: 'Select a player',
    gmNeedEventPlayerIn: 'Select the player coming on',
    gmPosition: 'Position',
    gmMatchNumber: 'Match number',
    gmMvp: 'MVP',
    gmNotListed: 'Not listed',
    gmAddPhotoSet: 'Album link',
    gmInvalidPhotoUrl: 'Enter a valid URL, for example https://vk.com/album-...',
    gmSavePhotoSet: 'Save album',
    gmDeletePhotoSet: 'Remove album',
    gmUploadPhotos: 'Upload photos',
    gmOpenMedia: 'Open media',
    gmStatistics: 'Statistics',
    gmEnterStatistics: 'Enter statistics',
    gmSaveStatistics: 'Save statistics',
    gmExtraTime: 'Extra time allowed',
    gmHalfTime: 'Half length, min',
    gmExtraHalfTime: 'Extra-time half, min',
    gmPenaltiesAvailable: 'Penalties allowed',
    gmEnableTimeline: 'Timeline',
    gmTimelineHint: 'The app will show a match feed: goals, cards and substitutions with the minute',
    gmMatchFlags: 'Settings',
    gmPlayState: 'Match progress',
    gmPlayStart: 'Start match',
    gmPlayTimeout: 'Half-time',
    gmPlayContinue: 'Second half',
    gmPlayEnd: 'Finish match',
    gmPlayReset: 'Reset',
    gmPlayExtraBreak: 'Break before extra time',
    gmPlayExtraStart: 'Extra time',
    gmPlayExtraTimeout: 'Extra-time break',
    gmPlayExtraSecond: 'Second extra half',
    gmPlayExtraEnd: 'End extra time',
    gmPlayStateSaved: 'Match state updated',
    gmSaveScore: 'Save score',
    gmSaveScoreAndFinish: 'Save score and finish match',
    gmSaveComment: 'Save comment',
    gmClearComment: 'Clear comment',
    gmCommentPlaceholder: 'The comment will be visible in the app before kick-off. It can be a postponement reason, a technical defeat reason, or any other information',
    gmScoreSaved: 'Score saved',
    gmScoreFinished: 'Score saved, match finished',
    gmSettingsSaved: 'Match settings saved',
    gmNoStaff: 'No staff assigned',
    gmNoVideos: 'No videos',
    gmNoPhotos: 'No photos',
    gmNoEvents: 'No events yet',
    gmHome: 'Home',
    gmGuest: 'Away',
    gmPenaltiesTitle: 'Penalty shootout',
    gmPenaltiesSaved: 'Penalties saved',
    gmTournamentSaved: 'Tournament saved',
    gmPlaceSaved: 'Venue saved',
    gmTimeNeedsDate: 'To save the kickoff time, set the match date first',
    gmSavePlace: 'Save date and time',
    gmStaffSaved: 'Staff saved',
    gmEventSaved: 'Event saved',
    gmEventDeleted: 'Event deleted',
    gmVideoSaved: 'Video saved',
    gmVideoDeleted: 'Video deleted',
    gmStatsSaved: 'Statistics saved',
    gmLoadError: 'Failed to load the game',
    gmSaveError: 'Failed to save changes',
    gmNeedChamp: 'Select a championship',
    gmVideoUrl: 'Video URL',
    gmInvalidVideoUrl: 'Enter a valid URL, for example https://vkvideo.ru/...',
    gmVideoName: 'Title',
    gmVideoType: 'Video type',
    gmPickStaff: 'Select a staff member',
    gmStaffSearch: 'Name, login or role',
    gmAllStaffRoles: 'All roles',
    gmStaffEmpty: 'No staff found',
    gmCountry: 'Country',
    gmStage: 'Stage',
    gmDatetime: 'Date and time',
    gmAddPhotos: 'Add photos',
    evt_goal: 'Goal!',
    evt_assist: 'Assist',
    evt_yellow_card: 'Yellow card',
    evt_red_card: 'Red card',
    evt_penalty_kick: 'Penalty!',
    evt_penalty_kick_goal: 'Penalty scored',
    evt_penalty_kick_no_goal: 'Penalty missed',
    evt_autogoal: 'Own goal',
    evt_match_begin: 'Kick-off',
    evt_timeout: 'Half-time',
    evt_match_end: 'Full-time',
    evt_penalty_series: 'Penalty shootout',
    evt_second_yellow_card: 'Second yellow card',
    evt_main_time_end: 'End of regular time',
    evt_substitution: 'Substitution',
    evt_ten_meters_goal: '10m scored',
    evt_ten_meters_nogoal: '10m missed',
    evt_six_meters_penalty_goal: '6m scored',
    evt_six_meters_penalty_nogoal: '6m missed',
    evt_goal_assist: 'Goal+assist',
    evt_free_event: 'Free event',
    evt_shtanga: 'Post',
    evt_perekladina: 'Crossbar',
    evt_shot: 'Shot',
    evt_miss: 'Miss',
    evt_corner: 'Corner',
    evt_dangerous_moment: 'Dangerous moment',
    evt_foul: 'Foul',
    championship: 'Championship',
    championshipPlaceholder: 'Select a championship',
    championshipNotFound: 'Championship not found',
    championshipSearchPh: 'Search championship',
    championshipsLoading: 'Loading championships...',
    championshipsEmpty: 'No championships found',
    championshipsLoadError: 'Failed to load championships',
    champNoAccess: 'This championship has no access to this section',
    league: 'League',
    leaguePlaceholder: 'Select a league',
    leagueNotFound: 'League not found',
    yesterday: 'Yesterday',
    today: 'Today',
    tomorrow: 'Tomorrow',
    time: 'Time',
    match: 'Match',
    stadium: 'Stadium',
    status: 'Status',
    noMatches: 'Looks like there are no matches on this day...',
    loadingMatches: 'Loading matches',
    matchPostponed: 'Match postponed',
    technicalDefeat: 'TF',
    halfTime: 'Half-time',
    matchFinished: 'Match finished',
    matchNotStarted: 'Match not started',
    firstHalf: '1st half in progress',
    extraFirstHalf: 'Extra time. 1st half in progress',
    secondHalf: '2nd half in progress',
    extraSecondHalf: 'Extra time. 2nd half in progress',
    extraBreak: 'Break before extra time',
    extraHalfTime: 'Extra-time half-time',
    success: 'Success',
    error: 'Error',
    cancel: 'Cancel',
    add: 'Add',
    next: 'Next',
    done: 'Done',
    save: 'Save',
    delete: 'Delete',
    close: 'Close',
    referee: 'Referee',
    dateTime: 'Date and time',
    player: 'Player',
    team: 'Team',
    goal: 'Goal',
    assist: 'Assist',
    comment: 'Comment',
    evtGoal: 'Goal',
    evtPenScored: 'Penalty scored',
    evtPenMissed: 'Penalty missed',
    evtOG: 'Own goal',
    evt10Scored: '10m scored',
    evt10Missed: '10m missed',
    evt6Scored: '6m scored',
    evt6Missed: '6m missed',
    evtYC: 'YC',
    evtRC: 'RC',
    evtPenScoredShort: 'Pen (scored)',
    evtPenMissedShort: 'Pen (missed)',
    evt10ScoredShort: '10m (scored)',
    evt10MissedShort: '10m (missed)',
    evt6ScoredShort: '6m (scored)',
    evt6MissedShort: '6m (missed)',
    evt2YC: '2nd YC',
    evtSub: 'Substitution',
    evtShtanga: 'Post',
    evtPerekladina: 'Crossbar',
    sysKickOff: '▶ Kick-off',
    sysHalfTime: '⏸ Half-time',
    sysFullTime: '🏁 Full-time',
    posFW: 'FW',
    posMF: 'MF',
    posDF: 'DF',
    posGK: 'GK',
    posUNI: 'UT',
    mrTitle: 'Match. Edit results.',
    mrMedia: 'Match media',
    mrSaveMeta: 'Save date, time, stadium, referee',
    mrTechLose: 'Technical defeat',
    mrPostpone: 'Postpone',
    mrMinutes: 'Set minutes',
    mrMinutesCount: 'Minutes ({count})',
    mrOnlineMatch: 'Live match',
    mrLoading: 'Loading match',
    mrEventTimeline: 'Event times',
    mrStadiumNotFound: 'Stadium not found',
    mrRefereeNotFound: 'Referee not found',
    mrDateNotSet: 'Not set',
    mrHours: 'Hours',
    mrMinutesField: 'Minutes',
    mrPresence: 'P*',
    mrOG: 'OG',
    mrYC: 'YC',
    mrRC: 'RC',
    mrTotal: 'Total',
    mrNoSquad: 'Squad not submitted',
    mrHintPresence: 'played in the match',
    mrHintGoals: 'goals',
    mrHintAssists: 'assists',
    mrHintOG: 'own goals',
    mrHintYC: 'yellow cards',
    mrHintRC: 'red cards',
    mrHintMvp: 'Click a player’s name to mark them as MVP or goalkeeper',
    mrWarning: 'Warning',
    mrCommentTitle: 'Leave a match comment',
    mrPostponeTitle: 'Mark the match as postponed',
    mrPostponePh: 'Enter a reason or new date if needed',
    mrTechLoseTitle: 'Technical defeat',
    mrTechLosePh: 'Enter a reason for the technical defeat if needed',
    mrTechHomeWins: 'Home win 5:0',
    mrTechGuestWins: 'Away win 0:5',
    mrScore: 'Score',
    mrEventsTitle: 'Set event minutes',
    mrEventType: 'Event type',
    mrSelect: '-- Select --',
    mrAssistOptional: 'Assist (optional)',
    mrNoAssist: '-- No assist --',
    mrMinute: 'Minute',
    mrSecond: 'Second',
    mrAddedEvents: 'Added events ({count})',
    mrMin: 'Min.',
    mrType: 'Type',
    mrEventsAllSet: '✓ All events are set. The specified minutes will be used on save.',
    mrEventsNotAll: '⚠ Not all events are set. Add minutes for every goal, own goal, YC and RC in the table.',
    mrClearAll: 'Clear all',
    mrResultsSaved: 'Match results saved.',
    mrCommentSaved: 'Match comment saved.',
    mrPlayerNotListed: 'Player {name} ({team}) recorded events but is not listed for the match.',
    mrPlayersNotListed: 'Players {name} ({team}) and {count} more recorded events but are not listed for the match.',
    mrManualDqUntil: 'Manual disqualification until {date}',
    mrManualDqMatches: 'Manual disqualification for {count} match(es)',
    mrGoalsMismatch: 'Goal count for {team} ({goals}) does not match the score ({score})',
    mrDqInSquad: 'The active squad includes disqualified players: {list}',
    mrPlayerDq: 'player is disqualified',
    mrDouble: '(D)',
    mrKeeperTag: '(GK)',
    mrKeeperShort: 'GK',
    mrDqTag: '(DQ)',
    mrGoalkeeper: 'Goalkeeper',
    mrPresenceName: 'Played',
    blTitle: 'Blacklist',
    blAdd: 'Add to list',
    blAddShort: 'Add',
    blSearchPh: 'First name, last name or patronymic',
    blEmpty: 'Nobody is on the blacklist',
    blEmptyHint: 'Add a player or change the search',
    blLoading: 'Loading blacklist',
    blDate: 'Date',
    blReason: 'Comment',
    blPlayer: 'Player',
    blAddedBy: 'Added by',
    blFound: 'Found: {count}',
    blNotSet: 'Not set',
    blDeleteTitle: 'Remove from blacklist',
    blDeleteConfirm: 'Do you really want to remove this player from the blacklist?',
    blNew: 'Add to blacklist',
    blEdit: 'Blacklisted player',
    blPickPlayer: 'Select a player',
    blNeedPlayer: 'Select a player',
    blNeedComment: 'Enter a comment',
    blAlreadyListed: 'Already on the blacklist',
    blLoadError: 'Could not load the blacklist',
    blSaveError: 'Could not save changes',
    blRemoveError: 'Could not remove the player from the list',
    blSaved: 'Changes saved',
    blNotFound: 'Player was not found on the blacklist',
    blNoPlayers: 'No players found',
    blReasonPh: 'Enter a reason',
    blAddConfirm: 'Add to list',
    stTitle: 'Stage management',
    stCreate: 'Create stage',
    stCreateMultiple: 'Create several',
    stCreateFirst: 'Create the first stage',
    stLoading: 'Loading stages...',
    stNoStages: 'No stages found for the selected season',
    stSelectPrompt: 'Select a league and season to view stages',
    stGenerate: 'Generate matches',
    stGenerateShort: 'Generate',
    stCreateMatch: 'Create match',
    stCreateMatchShort: 'Match',
    stSeason: 'Season',
    stSeasonPlaceholder: 'Select a season',
    stSeasonNotFound: 'Season not found',
    stNoMatches: 'No matches found',
    stStatusFinished: 'Finished',
    stStatusLive: 'Live',
    stStatusNotStarted: 'Not started',
    stStatusUnknown: 'Unknown',
    stDeleteTitle: 'Delete stage',
    stDeleteConfirm: 'Are you sure you want to delete this stage?',
    stDeleteHasMatches: 'This stage cannot be deleted. It contains {count} matches. Remove the matches first.',
    stDeleteError: 'Failed to delete the stage',
    stCreateTitle: 'Create stage',
    stName: 'Stage name',
    stNamePh: 'For example: Matchday 1, Semi-final, Group A',
    stShortName: 'Short name (optional)',
    stShortPh: 'For example: MD1, SF',
    stPlayoff: 'Play-off stage',
    stCreating: 'Creating...',
    stCreateBtn: 'Create stage',
    stNameRequired: 'Enter a stage name',
    stCreated: 'Stage created!',
    stCreateError: 'Failed to create the stage',
    stEditTitle: 'Edit stage',
    stPriority: 'Priority (optional)',
    stPriorityPh: 'Order number',
    stSaving: 'Saving...',
    stSaveChanges: 'Save changes',
    stUpdated: 'Stage updated!',
    stUpdateError: 'Failed to update the stage',
    stMultiTitle: 'Create several stages',
    stMultiCount: 'Number of stages',
    stMultiHint: 'The specified number of stages will be created with automatic numbering',
    stMultiBase: 'Base name',
    stMultiBaseHint: 'Stages will be named “1 {name}”, “2 {name}”, and so on',
    stMultiCreate: 'Create {count} stages',
    stMultiAmountError: 'Enter a number from 1 to 50',
    stMultiNameError: 'Enter a base name',
    stMultiCreated: '{count} stages created!',
    stMultiError: 'Failed to create stages',
    noChampionship: 'No championship',
    lcSubtitle: 'Set 1st, 2nd and 3rd place for the selected league and season.',
    lcLoadLeaguesError: 'Failed to load leagues',
    lcLoadDataError: 'Failed to load league podium data',
    lcTeamAlreadyPlace: '“{name}” is already assigned to place {place}',
    lcSelectLeagueSeason: 'Select a league and season',
    lcDuplicateTeams: 'The same team cannot occupy more than one podium place',
    lcSaved: 'Podium saved',
    lcSaveError: 'Failed to save podium',
    lcNotSelected: 'Not selected',
    lcTeamNotSelected: 'No team selected',
    lcPlace1: '1st place',
    lcPlace2: '2nd place',
    lcPlace3: '3rd place',
    lcTeamNotFound: 'Team not found',
    lcTeamPlaceholder: 'Select a team',
    lcSelectPrompt: 'Select a country, league and season',
    lcSelectHint: 'Current podium places and the team list will load after you choose them.',
    lcLoading: 'Loading podium and teams...',
    ttSubtitle: 'Choose a country, league, season, round and formation. Tap a player on the pitch to replace them.',
    ttLoadError: 'Failed to load team of the round',
    ttSelectLeagueSeasonTour: 'Select a country, league, season and round',
    ttSaved: 'Team of the round saved',
    ttSaveError: 'Failed to save the team of the round',
    ttLoading: 'Loading team of the round...',
    ttSelectHint: 'The team of the round and the league player list will load after you choose them.',
    ttPlayersInTeam: 'Players in the squad',
    ttSelect: 'Select',
    ttNotSelected: 'Not selected',
    ttChange: 'Change',
    ttPickTitle: 'Select a player for slot #{n}',
    ttSearching: 'Searching...',
    ttSearch: 'Search',
    ttLoadingPlayers: 'Loading players...',
    ttNoPlayers: 'No players found',
    ttSearchHint: 'Enter a query and press Search',
    ttNoTeam: 'No team',
    ttTour: 'Round',
    ttTourPlaceholder: 'Select a round',
    ttTourNotFound: 'Round not found',
    ttScheme: 'Formation',
    ttSchemeNotFound: 'Formation not found',
    ttFieldAlt: 'Football pitch',
    dqTitle: 'Disqualifications',
    dqAutoTitle: 'Automatic',
    dqCurrentTitle: 'Current disqualifications',
    dqCurrentTab: 'Current',
    dqAddAutoShort: 'Auto',
    dqAddShort: 'Disq.',
    dqStatus: 'Status',
    dqLeague: 'League',
    dqYC: 'YC',
    dqYCCount: 'YC',
    dqPlayer: 'Player',
    dqTournament: 'Tournament',
    dqTournamentPh: 'Select a tournament',
    dqGames: 'Games',
    dqEnabled: 'Enabled',
    dqDisabled: 'Disabled',
    dqMode: 'Mode',
    dqModeMatches: 'Games',
    dqModeTime: 'Time',
    dqUntilDate: 'Until',
    dqComment: 'Comment',
    dqCommentPh: 'For example: violent conduct',
    dqSearchPh: 'Search by player or tournament',
    dqAddAuto: 'Add disqualifier',
    dqEditAuto: 'Edit disqualifier',
    dqNewAuto: 'New disqualifier',
    dqAdd: 'Add disqualification',
    dqNewManual: 'New disqualification',
    dqEditManual: 'Edit disqualification',
    dqPickPlayer: 'Select a player',
    dqChangePlayer: 'Change player',
    dqPickTitle: 'Select a player',
    dqAuto: 'Auto',
    dqAutoReadonlyHint: 'Automatic disqualifications cannot be changed or deleted.',
    dqAutoEmpty: 'No automatic disqualifiers configured',
    dqAutoEmptyHint: 'Add a disqualifier for a league',
    dqCurrentEmpty: 'No current disqualifications',
    dqCurrentEmptyHint: 'Change the query or add a manual disqualification',
    dqLoading: 'Loading disqualifications',
    dqLoadMore: 'Show more',
    dqFound: 'Found: {count}',
    dqNoTournaments: 'No tournaments available',
    dqNoLeaguesInCountry: 'No available leagues in this country',
    dqNeedTournament: 'Select a league',
    dqNeedPlayer: 'Select a player',
    dqNeedYC: 'Enter the yellow-card threshold',
    dqInvalidMatches: 'Enter a valid number of games',
    dqNeedEndDate: 'Select an end date',
    dqLoadError: 'Failed to load disqualification data',
    dqSaveError: 'Failed to save changes',
    dqAddError: 'Failed to add the disqualification',
    dqRemoveError: 'Failed to remove the disqualification',
    dqLoadPlayersError: 'Failed to load players',
    dqSaved: 'Changes saved',
    dqCreated: 'Disqualification added',
    dqAutoCreated: 'Disqualifier added',
    dqRemoved: 'Deleted',
    dqUntil: 'Until {date}',
    dqPlayerFallback: 'Player #{id}',
    dqNotFound: 'Record not found',
    dqDeleteAutoTitle: 'Delete disqualifier?',
    dqDeleteAutoText: 'Automatic disqualification settings for this league will be cleared.',
    dqDeleteTitle: 'Delete disqualification?',
    dqDeleteConfirm: 'This manual disqualification will be removed. This cannot be undone.',
    twStatus: 'Status',
    twLeague: 'League',
    twFrom: 'Starts',
    twTo: 'Ends',
    twPeriod: 'Period',
    twRange: 'from {from} to {to}',
    twRangeTime: 'from {from} {fromTime} to {to} {toTime}',
    twEnabled: 'Enabled',
    twDisabled: 'Disabled',
    twNotSet: 'Not set',
    twDayFrom: 'From day',
    twTimeFrom: 'From time',
    twDayTo: 'To day',
    twTimeTo: 'To time',
    twDayPh: 'Select a day',
    twLeaguePh: 'Select a league',
    twAdd: 'Add window',
    twAddShort: 'Window',
    twCreate: 'Create transfer window',
    twNew: 'New transfer window',
    twEdit: 'Edit transfer window',
    twEmpty: 'No enabled transfer windows',
    twEmptyHint: 'Add an application window for a league',
    twLoading: 'Loading transfer windows',
    twLoadError: 'Could not load transfer windows',
    twSaveError: 'Could not save the transfer window',
    twRemoveError: 'Could not delete the transfer window',
    twSaved: 'Changes saved',
    twNeedLeague: 'Select a league',
    twNeedCountry: 'Select a country',
    twNeedDay: 'Select a day',
    twNeedTime: 'Enter a time',
    twNoLeagues: 'There are no leagues without an enabled transfer window',
    twNoCountries: 'No countries available',
    twPickCountryFirst: 'Select a country first',
    twNoLeaguesInCountry: 'No leagues without an enabled window in this country',
    twSearchPh: 'Search by league name',
    twFound: 'Found: {count}',
    twNotFound: 'Transfer window not found',
    twDeleteTitle: 'Delete transfer window?',
    twDeleteText: 'The application window schedule for this league will be cleared.',
    twScheduleTitle: 'Window schedule',
    twSeasonTitle: 'Season window',
    twSeasonHint: 'Whether the active season transfer window is open',
    twSeasonOpen: 'Open',
    twSeasonClosed: 'Closed',
    twSeasonNone: 'No season',
    twSeasonEmpty: 'No leagues',
    twSeasonEmptyHint: 'This championship has no leagues yet',
    twSeasonsTitle: 'League seasons',
    twSeasonName: 'Season',
    twSeasonActive: 'Active',
    twOpenWindow: 'Open',
    twCloseWindow: 'Close',
    twSeasonLoadError: 'Could not load seasons',
    twSeasonSaveError: 'Could not change the season transfer window',
    twNoSeasons: 'No seasons',
    twNoSeasonsHint: 'Create a season in tournaments first',
    twDay0: 'Sunday',
    twDay1: 'Monday',
    twDay2: 'Tuesday',
    twDay3: 'Wednesday',
    twDay4: 'Thursday',
    twDay5: 'Friday',
    twDay6: 'Saturday',
    twDayFrom0: 'Sunday',
    twDayFrom1: 'Monday',
    twDayFrom2: 'Tuesday',
    twDayFrom3: 'Wednesday',
    twDayFrom4: 'Thursday',
    twDayFrom5: 'Friday',
    twDayFrom6: 'Saturday',
    twDayTo0: 'Sunday',
    twDayTo1: 'Monday',
    twDayTo2: 'Tuesday',
    twDayTo3: 'Wednesday',
    twDayTo4: 'Thursday',
    twDayTo5: 'Friday',
    twDayTo6: 'Saturday',
    mmSelectTitle: 'Select a match for media',
    mmSelectPrompt: 'Select a championship, league, season and stage',
    mmStage: 'Stage / Round',
    mmStagePlaceholder: 'Select a stage',
    mmStageNotFound: 'Stage not found',
    mmMedia: 'Media',
    mmTitle: 'Match media #{id}',
    mmSummary: 'Videos: {videos} of 3, photos: {photos}',
    mmSummaryTotal: 'Videos: {videos} of 3, photos: {photos} of {total}',
    mmBack: 'Back to match',
    mmLoadError: 'Failed to load match media',
    mmPhotosLoadError: 'Failed to load match photos',
    mmLoading: 'Loading media...',
    mmVideos: 'Videos',
    mmSaveVideos: 'Save videos',
    mmVideosSaved: 'Videos saved',
    mmVideosSaveError: 'Failed to save video links',
    mmBroadcast: '1. Live stream',
    mmReview: '2. Highlights',
    mmExtra: '3. Extra',
    mmUrlPh: 'https://...',
    mmVkTitle: 'Import from VK',
    mmVkPh: 'VK album link...',
    mmLoad: 'Load',
    mmLoadingGeneric: 'Loading...',
    mmVkLoadError: 'Failed to load the VK album',
    mmVkAlbumLoading: 'Loading album...',
    mmVkAlbumTitle: '{title} — {count} photos',
    mmVkCount: '{count} photos',
    mmAddToMatch: 'Add to match',
    mmAdding: 'Adding...',
    mmVkAdded: 'VK photos added to the match',
    mmVkAddError: 'Failed to add photos from VK',
    mmPhotos: 'Photos',
    mmAddPhotos: 'Add photos',
    mmUploading: 'Uploading...',
    mmPhotosLoading: 'Loading photos...',
    mmNoPhotos: 'No photos yet',
    mmPhotoDeleted: 'Photo deleted',
    mmPhotoDeleteError: 'Failed to delete the photo',
    mmPhotosUploaded: 'Photos uploaded',
    mmPhotosUploadError: 'Failed to upload photos',
    mmLoadMore: 'Load more',
    mmDeletePhotoTitle: 'Delete photo',
    mmDeletePhotoConfirm: 'Delete this photo?',
    tmAdd: 'Add team',
    tmAddShort: 'Team',
    tmSearchPh: 'Search by name or country',
    tmFound: 'Teams found: {count}',
    tmShown: '(showing {shown} of {count})',
    tmLoading: 'Loading teams...',
    tmLoadError: 'Failed to load teams: {error}',
    tmNoResults: 'Nothing found for “{query}”',
    tmEmpty: 'No teams found',
    tmUntitled: 'Untitled',
    tmPlayers: 'Players',
    tmPlayersBlock: 'Players',
    tmPlayerSearchPh: 'Name, last name or number',
    tmNoPlayerSearch: 'No players found',
    tmAdded: 'Team added',
    tmSessionExpired: 'Session expired. Please sign in again.',
    tmSaveError: 'Failed to save the team',
    tmAddTitle: 'Add a new team',
    tmListName: 'Name',
    tmName: 'Team name',
    tmNameRequired: 'Team name is required',
    tmNamePh: 'Enter a team name',
    tmPlayer: 'Player',
    tmShort: 'Short name (max 3 letters)',
    tmShortError: 'Short name must be 3 letters or fewer',
    tmLogo: 'Team logo',
    tmPickImage: 'Choose an image',
    tmImageHint: 'PNG, JPG, GIF up to 5MB',
    tmNeedImage: 'Please choose an image',
    tmFileSize: 'File size must not exceed 5MB',
    tmLogoDefault: 'If no logo is added, the default logo will be used',
    tmRemoveLogo: 'Remove',
    tmEditTitle: 'Edit team',
    tmChangeLogo: 'Change logo',
    tmLogoDefaultHint: 'Tap the cross to restore the default logo',
    tmUpdated: 'Team updated',
    tmUpdateError: 'Failed to update the team',
    tmEmptyHint: 'Change the query or add a new team',
    tmNewTeam: 'New team',
    tmEditTeam: 'Edit team',
    tmCreated: 'Team created',
    tmShortName: 'Short name',
    tmDoublesTitle: 'Related squads',
    tmDoublesHint: 'Main team and reserve. You can chain: main → -2 → -3.',
    tmDoublesAfterCreate: 'You can link a reserve or main team after creating this team.',
    tmDoubleParent: 'Main team',
    tmDoubleReserve: 'Reserve',
    tmDoublePickParent: 'Set main team',
    tmDoublePickReserve: 'Set reserve',
    tmDoubleSearchPh: 'Find a team',
    tmDoubleUnlink: 'Unlink',
    tmDoubleLinked: 'Squad link saved',
    tmDoubleUnlinked: 'Squad link removed',
    tmDoubleLinkError: 'Could not link reserve squad',
    tmDoubleUnlinkError: 'Could not remove the link',
    tmDoubleConflictTitle: 'Link conflict',
    tmDoubleConflictText: 'One of the teams already has another link. Overwrite it?',
    tmDoubleConflictGeneric: 'Reserve-squad link conflict',
    tmDoubleConflictMainHasReserve: 'Main team already has reserve #{id}',
    tmDoubleConflictDoubleHasParent: 'Reserve already has main team #{id}',
    tmDoubleConflictDoubleIsReserve: 'This team is already a reserve of: {names}',
    tmDoubleConflictMainHasChild: 'Main team already has a reserve: {names}',
    tmDoubleReplace: 'Overwrite',
    tmCountryRequired: 'Select a championship',
    tmNumber: 'Number',
    tmAddPlayer: 'Add player',
    tmEmptyPlayers: 'No players yet',
    tmOfficials: 'Officials',
    tmAddOfficial: 'New official',
    tmNewOfficial: 'New official',
    tmEditOfficial: 'Official',
    tmEmptyOfficials: 'No officials yet',
    tmOfficialNotFound: 'Official not found',
    tmOfficialCreated: 'Official added',
    tmRole: 'Role',
    tmRolePh: 'Head coach',
    tmBirthDate: 'Date of birth',
    tmDeleteOfficialTitle: 'Delete this official?',
    tmDeleteOfficialText: 'The official will be deleted. This cannot be undone.',
    mtBack: 'Back to teams',
    mtBackList: 'Back to the team list',
    mtLoading: 'Loading team data...',
    mtLoadError: 'Failed to load team data',
    mtNotFound: 'Team not found',
    mtEdit: 'Edit',
    mtLeagues: 'Leagues this team plays in',
    mtAddToLeague: 'Add to league',
    mtNoLeagues: 'This team is not in any league yet',
    mtRoster: 'Squad',
    mtAddPlayer: 'Add player',
    mtAddExcel: 'Add from Excel',
    mtPickApp: 'Select an application',
    mtAppPlayers: '{name} ({count} players)',
    mtAppFallback: 'Application #{id}',
    mtSort: 'Sort',
    mtSortNumber: 'By shirt number',
    mtSortPosition: 'By position',
    mtSortFamily: 'By last name',
    mtPosition: 'Position',
    mtBirthday: 'Date of birth',
    mtUnenroll: 'Remove from squad',
    mtNoPlayers: 'No players in this application',
    mtPickAppHint: 'Select an application to view the squad',
    mtNoApps: 'This team has no applications yet',
    mtRemoveLeagueTitle: 'Remove from league',
    mtRemoveLeagueConfirm: 'Remove this team from “{league}”, season {season}?',
    mtRemovedLeague: 'Team removed from the league',
    mtRemoveLeagueError: 'Failed to remove the team from the league',
    mtRemovePlayerTitle: 'Remove from application',
    mtRemovePlayerConfirm: 'Remove “{name}” from application “{app}”?',
    mtRemovedPlayer: 'Player removed from the application',
    mtRemovePlayerError: 'Failed to remove the player from the application',
    mtNoUser: 'Error: user data is not loaded',
    mtEditDenied: 'You can only edit players created by your league. Contact the app developers to change other players.',
    mtMissingData: 'Required data is missing',
    mtBadNumber: 'Invalid shirt number',
    mtNumberChanged: 'Shirt number updated',
    mtNumberChangeError: 'Failed to change the shirt number',
    mtTimeout: 'The server did not respond in time',
    mtServerError: 'Server error: {status}',
    atlTitle: 'Add team to a league',
    atlLoadError: 'Failed to load leagues',
    atlNoSeasons: 'This league has no available seasons',
    atlSeasonsError: 'Failed to load seasons',
    atlAdded: 'Team added to the league',
    atlAddError: 'Failed to add the team to the league',
    atlAdd: 'Add',
    atlSeasonFallback: 'Season {id}',
    epnTitle: 'Change shirt number',
    epnNumber: 'Shirt number',
    epnRequired: 'Enter a shirt number',
    epnRange: 'Number must be between 0 and 99',
    epnTaken: 'Number {n} is already taken',
    epnPh: 'Enter a number',
    epnOccupied: 'Taken numbers: {list}',
    epnNone: 'none',
    apmTitle: 'Add player to squad',
    apmSingle: 'One player',
    apmMultiple: 'Several players',
    apmSearch: 'Player search',
    apmSearchPh: 'Last and/or first name (min. 2 characters)',
    apmSearchHint: 'Enter a last name, or last name and first name. Autosearch after 4+ characters.',
    apmNeedQuery: 'Enter a last name to search',
    apmMinChars: 'Enter at least 2 characters',
    apmSearchError: 'Failed to search players: {error}',
    apmNoPhoto: 'No photo',
    apmSelect: 'Select',
    apmNotFoundHint: 'Couldn’t find the player?',
    apmCreate: 'Create a new player',
    apmNoResults: 'No players found for “{query}”',
    apmSearchStart: 'Enter at least 2 characters and press Search, or type 4+ characters for autosearch',
    apmBackSearch: 'Back to search',
    apmNumberPh: 'Enter a number (1–99)',
    apmNumberTaken: 'Number {n} is already taken',
    apmAdding: 'Adding...',
    apmAdd: 'Add to squad',
    apmNoAppId: 'Error: application ID is missing',
    apmPickPlayer: 'Select a player',
    apmNeedNumber: 'Enter a shirt number from 1 to 99',
    apmAdded: 'Player added to the squad',
    apmAddError: 'Failed to add the player to the squad',
    apmCopyFrom: 'Select an application to copy players from',
    apmLoadingApps: 'Loading applications...',
    apmNoCopyApps: 'No applications available to copy from',
    apmBackApps: 'Back to applications',
    apmSortFio: 'By name',
    apmSelectAllCount: 'Select all ({count})',
    apmSelectedCount: 'Selected: {count}',
    apmAddCount: 'Add {count} players',
    apmAddedCount: 'Players added: {count}',
    apmAddManyError: 'Failed to add players',
    apmLoadAppsError: 'Failed to load applications',
    apmPickOne: 'Select at least one player',
    epmCreateTitle: 'Create a new player',
    epmEditTitle: 'Edit player details',
    epmPhoto: 'Player photo',
    epmUpload: 'Upload photo',
    epmFamily: 'Last name',
    epmName: 'First name',
    epmFather: 'Patronymic',
    epmNationality: 'Nationality',
    epmHeight: 'Height (cm)',
    epmWeight: 'Weight (kg)',
    epmFoot: 'Preferred foot',
    epmFamilyPh: 'Enter last name',
    epmNamePh: 'Enter first name',
    epmFatherPh: 'Enter patronymic',
    epmNationalityPh: 'Enter nationality',
    epmRequiredFields: 'Fill in the required fields: last name, first name and date of birth',
    epmFile10: 'File is too large. Maximum size: 10MB',
    epmFile5: 'File is too large. Maximum size: 5MB',
    epmCreated: 'Player created',
    epmUpdated: 'Player details updated',
    epmCreateError: 'Failed to create the player',
    epmUpdateError: 'Failed to update player details',
    epmCreateBtn: 'Create player',
    epmSaveBtn: 'Save changes',
    epmCropTitle: 'Crop the photo',
    epmZoom: 'Zoom',
    epmApply: 'Apply',
    epmCropError: 'Failed to crop the image',
    epmPosFW: 'Forward',
    epmPosMF: 'Midfielder',
    epmPosDF: 'Defender',
    epmPosGK: 'Goalkeeper',
    epmPosUNI: 'Utility',
    epmFootRight: 'Right',
    epmFootLeft: 'Left',
    epmFootBoth: 'Both',
    pmDesc: 'Search players in the database. Enter a last name, or last name and first name.',
    pmSearchPh: 'First name, last name or team',
    pmSearchHint: 'Enter a last name, or last name and first name, e.g. Ivanov Ivan. Autosearch after 2+ characters.',
    pmMinChars: 'Enter at least 2 characters to search',
    pmSearchError: 'Failed to search players',
    pmSearching: 'Searching players...',
    pmFound: 'Players found: {count}',
    pmPage: 'Page {current} of {total} (showing {from}–{to})',
    pmPhoto: 'Photo',
    pmFio: 'Name',
    pmBirthday: 'Date of birth',
    pmPosition: 'Position',
    pmNoResults: 'No players found',
    pmNoResultsHint: 'Change the query or create a new player',
    pmStart: 'Start searching',
    pmStartHint: 'Enter a player’s last name or first name',
    dupSearchPh: 'Last or first name',
    dupScope: 'Scope',
    dupScopeAll: 'All championships',
    dupScopeChamp: 'Current championship',
    dupScopeChampNamed: '{name}',
    dupFields: 'Match by',
    dupFieldName: 'First name',
    dupFieldFamily: 'Last name',
    dupFieldFather: 'Patronymic',
    dupFieldBirthday: 'Date of birth',
    dupFieldsHint: 'First and last name are always matched. An empty patronymic or birth date keeps the player out of a group if that field is selected. Without a championship filter, a group may include cards from different championships.',
    dupFound: 'Groups: {groups} · players: {players}',
    dupPageOf: 'Page {page} of {pages}',
    dupPrevPage: 'Previous',
    dupNextPage: 'Next',
    dupLoading: 'Loading duplicates',
    dupEmpty: 'No similar players',
    dupEmptyHint: 'Change the match fields or the search',
    dupLoadError: 'Could not load duplicates',
    dupMergeError: 'Could not merge players',
    dupMerged: 'Profiles merged',
    dupMerge: 'Merge',
    dupKeep: 'Primary',
    dupInclude: 'Include',
    dupGroupTitle: 'Group {n} · {count}',
    dupMergeHint: 'Select profiles and choose who to keep',
    dupNoTeams: 'No applications',
    dupId: 'ID {id}',
    dupMergeTitle: 'Merge profiles',
    dupMergeText: 'The “{name}” card will remain. The other selected profiles will be deleted and their data moved to the primary player — including from other championships.',
    dupNeedChamp: 'Select a championship',
    pmChampionship: 'Championship',
    pdTitle: 'Player details',
    pdBack: 'Back',
    pdLoadError: 'Failed to load player data',
    pdNotFound: 'Player not found',
    pdHeight: 'Height',
    pdWeight: 'Weight',
    pdNationality: 'Nationality',
    pdFoot: 'Preferred foot',
    pdCm: '{n} cm',
    pdKg: '{n} kg',
    pdYears: '({age} y.o.)',
    pdEdit: 'Edit details',
    pdNoPermission: 'You can only edit players created by your league. Contact the app developers to change this player.',
    pdApps: 'Player applications',
    pdAddToApp: 'Add to application',
    pdTeam: 'Team',
    pdApp: 'Application',
    pdNumber: 'Number',
    pdActions: 'Actions',
    pdEmptyApps: 'This player is not on any application yet',
    pdRemoveTitle: 'Remove from application',
    pdRemoveConfirm: 'Remove the player from “{app}” of team “{team}”?',
    pdRemoved: 'Player removed from the application',
    pdRemoveError: 'Failed to remove the player from the application',
    pdLoading: 'Loading player data...',
    plNewPlayer: 'New player',
    plAddingToTeam: 'The player will be added to «{team}»',
    plCheckExists: 'Check if the player already exists',
    plCheckingExists: 'Checking...',
    plExistsFound: 'Players found: {count}',
    plExistsEmpty: 'No player with this first and last name was found',
    plSelectExisting: 'Select player',
    plClearExisting: 'Create a new player',
    plEditPlayer: 'Edit player',
    plAddPlayer: 'Add player',
    plCreatePlayer: 'Create player',
    plCreatePlayerShort: 'Player',
    plGender: 'Gender',
    plGenderMale: 'Male',
    plGenderFemale: 'Female',
    plStatus: 'Status',
    plStatusAmateur: 'Amateur',
    plStatusPro: 'Professional',
    plStatusProShort: 'Pro',
    plInsured: 'Insured',
    plInsuranceUntil: 'Insured until',
    plInsuranceUntilHint: 'Insurance end date. Disabled unless “Insured” is checked.',
    plCitizenship: 'Citizenship',
    plTeamsBlock: 'Teams',
    plTransfersBlock: 'Transfer history',
    plRelatedProfiles: 'Related profiles',
    plPossibleProfiles: 'Possible profiles',
    plEmptyTransfers: 'No transfer history',
    plTransferAddApp: 'Added to application',
    plEmptyRelated: 'No related profiles',
    plEmptyPossible: 'No possible profiles found',
    plLinkSelected: 'Link selected profiles',
    plProfilesLinked: 'Profiles linked',
    plProfilesLinkError: 'Failed to link profiles',
    plAddApp: 'Add application',
    plChangeApp: 'Change application',
    plAppPickRequired: 'Select a team and application',
    plAppSaveError: 'Failed to save application',
    plUnlinkProfile: 'Unlink profile',
    plUnlinkConfirm: 'Unlink profile “{name}” from this player?',
    plProfilesUnlinked: 'Profile unlinked',
    plProfilesUnlinkError: 'Failed to unlink the profile',
    plMakeCaptain: 'Make captain',
    plCaptain: 'Captain',
    plCaptainSet: 'Player set as captain',
    plCaptainError: 'Failed to set the captain',
    plRemoveCaptain: 'Remove captain',
    plCaptainRemoved: 'Player removed as captain',
    plCaptainRemoveError: 'Failed to remove the captain',
    apaTitle: 'Add to a team application',
    apaSearchTeam: 'Search team',
    apaSearchPh: 'Enter a team name...',
    apaNoTeams: 'No teams found',
    apaStartTeam: 'Start typing a team name',
    apaApplication: 'Application',
    apaPickApp: 'Select an application',
    apaNoApps: 'This team has no applications',
    apaNumber: 'Shirt number',
    apaNumberPh: 'Enter a number (0–99)',
    apaOccupied: 'Taken numbers: {list}',
    apaPickTeam: 'Select a team',
    apaNeedNumber: 'Enter a shirt number',
    apaNumberRange: 'Number must be between 0 and 99',
    apaNumberTaken: 'Number {n} is already taken in this application',
    apaTeamNotFound: 'Team not found',
    apaAdded: 'Player added to the application',
    apaAddError: 'Failed to add the player to the application',
    apaAdding: 'Adding...',
    apaAdd: 'Add to application',
    apaLoadTeamsError: 'Failed to load teams',
    apaLoadAppsError: 'Failed to load applications',
    schPickLeague: 'Select a league',
    schLoadingTeams: 'Loading teams...',
    schLeagueType: 'League type',
    schGroupPlayoff: 'Group stage + play-off',
    schGroups: 'Groups: {count}',
    schGroup: 'Group {name}',
    schGroupTeams: '({count} teams):',
    schTeamsInLeague: 'Teams in the league: {count}',
    schParams: 'Generation settings',
    schAuto: 'Automatic',
    schManual: 'Set the first round',
    schFirstDate: 'First round date',
    schWithDates: 'Set dates',
    schWithoutDatesHint: 'Tours only — set match dates later (e.g. with “Quick edit” on the Games tab).',
    schRounds: 'Number of legs',
    schRound1: '1 leg',
    schRound2: '2 legs',
    schHalfTime: 'Half duration (min)',
    schDaysBetween: 'Days between rounds',
    schNeedHalfTime: 'Enter half duration',
    schNeedDaysBetween: 'Enter days between rounds',
    schStadiumNotFound: 'Stadium not found',
    schStadiumPlaceholder: 'Select a stadium',
    schReferee: 'Referee',
    schRefereeNotFound: 'Referee not found',
    schRefereeNone: 'Not assigned',
    schGenerate: 'Generate schedule',
    schFirstRoundGroups: 'First-round matches by group',
    schFirstRound: 'First-round matches',
    schFirstRoundHint: 'Set the pairings. The home team of the last match is the fixed team in the algorithm.',
    schByeHint: ' One team will automatically skip a round.',
    schByeTeam: 'Bye this round: {name}',
    schNoAvailable: 'None available',
    schHome: 'Home',
    schAway: 'Away',
    schFillAll: 'Fill in all matches to generate the schedule',
    schFillFirst: 'Fill in all first-round matches',
    schNoGroups: 'No groups found for this league',
    schFillFirstGroups: 'Fill in all first-round matches for each group',
    schNeedTeams: 'The selected league must have at least 2 teams',
    schLoadTeamsError: 'Could not load season teams',
    schPreview: 'Schedule preview',
    schTours: 'Rounds: {count}',
    schMatches: 'Matches: {count}',
    schTeams: 'Teams: {count}',
    schGroupsStat: 'Groups: {count}',
    schExpandAll: 'Expand all',
    schCollapseAll: 'Collapse all',
    schSave: 'Save to server',
    schTour: 'Round {n}',
    schCircle: 'Leg {n}',
    schMatchCount: '{count} matches',
    schSaveTitle: 'Save schedule',
    schSaveConfirm: '{tours} stages (rounds){groups} and {matches} matches will be created in league “{league}”.',
    schSaveGroups: ' ({count} groups)',
    schSaved: 'Schedule saved',
    schSaveError: 'Failed to save: {error}',
    schNoChampionship: 'No championship',
    schStadiumId: 'Stadium #{id}',
    schRefereeId: 'Referee #{id}',
    schUngrouped: 'Ungrouped',
    ipeTitle: 'Import players from Excel',
    ipeStep1: 'Step 1: Upload an Excel file',
    ipeStep1Text: 'The file should contain the following player data:',
    ipeReqFamily: 'Last name (required)',
    ipeReqName: 'First name (required)',
    ipeReqBirth: 'Date of birth (required, format: DD.MM.YYYY)',
    ipeFather: 'Patronymic',
    ipeHasHeaders: 'First row contains headers',
    ipeHasHeadersHint: 'Tick if the first row is column names',
    ipePickFile: 'Choose an Excel file',
    ipeEmptyFile: 'The file is empty or has the wrong format',
    ipeReadError: 'Failed to read the file',
    ipeColumn: 'Column {letter}',
    ipeStep2: 'Step 2: Map the columns',
    ipeStep2Hint: 'Choose which file column matches each field',
    ipePickColumn: 'Select a column',
    ipePreview: 'Data preview (first 3 rows)',
    ipeRow: 'Row {n}',
    ipeProcessing: 'Processing...',
    ipeNeedColumns: 'Map the required columns: last name, first name, date of birth',
    ipeStep3: 'Step 3: Review and confirm',
    ipeExisting: 'player found in the database',
    ipeNew: 'new player',
    ipeDuplicate: 'Duplicate',
    ipeOccupied: 'Taken',
    ipeWarnings: 'Issues found. Check the data on the next step.',
    ipeEmptyFields: '{count} players with empty required fields (will be skipped)',
    ipeBadDates: '{count} players with invalid dates',
    ipeDupNumbers: 'Duplicate shirt numbers ({list}). Numbers must be unique.',
    ipeConflictNumbers: 'Numbers {list} are already taken in this application.',
    ipeResult: 'Added: {added} of {total} players',
    ipeErrors: 'Errors found: {count}',
    ipeCritical: 'Critical error while adding players: {error}',
    olmRosterTitle: 'Select match squad',
    olmRosterSubtitle: 'Mark the players taking part in the match',
    olmSelectAll: 'Select all',
    olmDeselectAll: 'Deselect all',
    olmSelected: 'Selected: {count}',
    olmNext: 'Next →',
    olmBack: '← Back',
    olmLineupTitle: 'Formation and starting lineup',
    olmLineupSubtitle: 'Choose a format, formation and place the players. Tap a slot, then a player.',
    olmKitColor: '{team} kit colour:',
    olmMatchFormat: 'Match format:',
    olmPlayers: 'Players ({count})',
    olmPickSlot: '📍 Select → {slot}',
    olmPos: 'pos. {n}',
    olmSelectFormation: 'Choose a formation',
    olmAllOnField: 'All players are on the pitch ✓',
    olmAuto: 'Auto',
    olmClear: 'Clear',
    olmStartMatch: 'Start match →',
    olmEditLineup: 'Edit formation',
    olmWaiting: 'Waiting',
    olmHalf1: '1st half',
    olmHalf1Paused: '1st half (paused)',
    olmHalf2: '2nd half',
    olmHalf2Paused: '2nd half (paused)',
    olmMatchEnded: 'Match finished',
    olmStartHalf1: '▶ Start 1st half',
    olmPause: '⏸ Pause',
    olmResume: '▶ Resume',
    olmStartHalf2: '▶ Start 2nd half',
    olmStartExtra: '▶ Extra time',
    olmStartExtra1: '▶ Start extra 1st half',
    olmStartExtra2: '▶ Start extra 2nd half',
    olmExtraHalftime: '⏱ Extra-time break',
    olmExtra1: 'Extra time, 1st half',
    olmExtra1Paused: 'Extra time, 1st half (paused)',
    olmExtra2: 'Extra time, 2nd half',
    olmExtra2Paused: 'Extra time, 2nd half (paused)',
    olmExtra1Started: 'Extra-time first half started',
    olmExtra2Started: 'Extra-time second half started',
    olmEndMatch: '🏁 End match',
    olmHalftime: '⏱ Half-time',
    olmBench: 'Bench ({count}) — drag onto the pitch to substitute',
    olmMatchEvents: 'Match events ({count})',
    olmNoEvents: 'No events',
    olmPass: 'assist: {name}',
    olmApplyResults: '✓ Apply results',
    olmCloseNoSave: 'Close',
    olmAllEvents: 'All events ({count})',
    olmEditEvent: 'Edit event',
    olmAddEvent: 'Add event',
    olmSelectPlayer: '— Select a player —',
    olmAssistOptional: 'Assist (optional)',
    olmNoAssist: '— No assist —',
    olmSubIn: 'Substitution: player coming on',
    olmSelectBench: '— Select a bench player —',
    olmMinuteSecond: 'Minute / second',
    olmMinPh: 'min',
    olmSecPh: 'sec',
    olmLoadingServer: 'Loading match data from the server...',
    olmNeedPlayers: 'Select at least one player on each team',
    olmNeedFormat: 'Select a match format',
    olmNeedFormation: 'Select a formation for both teams',
    olmErrState: 'Failed to change match status',
    olmErrEvent: 'Failed to send event to the server',
    olmErrNoServerId: 'Could not delete event on the server: no server_id',
    olmErrRemove: 'Failed to delete event on the server',
    olmErrChange: 'Failed to update event on the server',
    olmErrApp: 'Failed to save squad to the server',
    olmSavingApps: 'Saving squads...',
    olmStarting: 'Starting match...',
    olmMatchStarted: 'Kick-off! 1st half',
    olmHalfTimeNotif: 'Half-time!',
    olmHalf2Started: '2nd half underway!',
    olmMatchEndedNotif: 'Match finished!',
    olmEventUpdated: 'Event updated',
    olmAlreadySubbed: 'Player has already been substituted',
    olmSubNotif: '🔄 Sub: {out} → {inName}',
    olm2YC: '🟨🟨 2nd YC → RC: {name}',
    olmEventNotif: '{icon} {label}: {name}',
    olmRemove: 'Remove',
    stSearchPh: 'Search by name or address',
    stEmpty: 'No stadiums found',
    stEmptyHint: 'Change the query or add a new stadium',
    stLoading: 'Loading stadiums',
    stStatus: 'Status',
    stdName: 'Name',
    stAddress: 'Address',
    stdPriority: 'Order',
    stEnabled: 'Visible',
    stEnabledShort: 'On',
    stDisabled: 'Hidden',
    stDisabledShort: 'Off',
    stReorder: 'Change order',
    stReorderShort: 'Order',
    stSaveOrder: 'Save',
    stCancelReorder: 'Cancel',
    stAddStadium: 'Add stadium',
    stAddStadiumShort: 'Stadium',
    stNewStadium: 'New stadium',
    stEditStadium: 'Edit stadium',
    stdSaveChanges: 'Save changes',
    stdSaveChangesShort: 'Save',
    stShowOnSite: 'Show on website/app',
    stDescription: 'Description',
    stLat: 'Latitude',
    stLong: 'Longitude',
    stPitchSize: 'Pitch size',
    stPitchCover: 'Pitch surface',
    stCapacity: 'Capacity',
    stPhoto: 'Photo',
    stPhotoHint: 'JPG, PNG or WEBP, up to 5 MB · crop area after pick',
    stPhotoChoose: 'Choose photo',
    stPhotoChange: 'Replace photo',
    stPhotoRemove: 'Remove',
    stdNamePh: 'Arena Khimki',
    stAddressPh: 'Khimki, Kirova st., 27',
    stDescriptionPh: 'Short stadium description',
    stLatPh: '55.889',
    stLongPh: '37.445',
    stPitchSizePh: '105x68',
    stPitchCoverPh: 'artificial turf',
    stCapacityPh: '5000',
    stPitchNamePh: 'Pitch 1',
    stPitchDescriptionPh: 'Main pitch',
    stdNameRequired: 'Enter a name',
    stChampionshipRequired: 'Select a championship',
    stPitches: 'Pitches',
    stAddPitch: 'Add pitch',
    stAddPitchShort: 'Pitch',
    stNewPitch: 'New pitch',
    stEditPitch: 'Edit pitch',
    stCreatePitch: 'Create pitch',
    stNoPitches: 'No pitches yet',
    stDeleteStadiumTitle: 'Delete stadium?',
    stDeleteStadiumText: 'The stadium and all of its pitches will be deleted. This cannot be undone.',
    stDeletePitchTitle: 'Delete pitch?',
    stDeletePitchText: 'The pitch will be deleted. This cannot be undone.',
    stSaved: 'Changes saved',
    stdCreated: 'Stadium created',
    stPitchCreated: 'Pitch created',
    stDeleted: 'Deleted',
    stOrderSaved: 'Order saved',
    stLoadError: 'Could not load data',
    stSaveError: 'Could not save changes',
    stOrderError: 'Could not save order',
    stdDeleteError: 'Could not delete',
    stNeedImage: 'Choose an image',
    stFileSize: 'File is larger than 5 MB',
    stMoveUp: 'Up',
    stMoveDown: 'Down',
    stFound: 'Found: {count}',
    stBack: 'Back',
    stDragHint: 'Drag rows or use the arrows to change the order',
    stNotFound: 'Stadium not found',
    stPitchNotFound: 'Pitch not found',
    trChampionships: 'Championships',
    trSearchPh: 'Search by name',
    trEmptyCountries: 'No championships found',
    trEmptyCountriesHint: 'Change the query or add a new championship',
    trLoading: 'Loading',
    trAddCountry: 'Add championship',
    trNewCountry: 'New championship',
    trEditCountry: 'Edit championship',
    trSaveCountry: 'Save championship',
    trFlag: 'Flag',
    trFlagPlaceholder: 'Select a flag',
    trFlagSearch: 'Search flags',
    trFlagEmpty: 'No flags found',
    trFlagRequired: 'Select a flag',
    trFounded: 'Founded',
    trVk: 'VK link',
    trVkPh: 'https://vk.com/...',
    trCountryNamePh: 'Russia',
    trTournaments: 'Tournaments',
    trAddLeague: 'Add tournament',
    trAddLeagueShort: 'Tournament',
    trNewLeague: 'New tournament',
    trEditLeague: 'Edit tournament',
    trCreateLeague: 'Create tournament',
    trLeagueNamePh: 'Premier League',
    trCountry: 'Country',
    trCountryPlaceholder: 'Select a country',
    trCountryRequired: 'Select a country',
    trEmptyLeagues: 'No tournaments yet',
    trSeasons: 'Seasons',
    trAddSeason: 'Create season',
    trAddSeasonShort: 'Season',
    trNewSeason: 'New season',
    trEditSeason: 'Edit season',
    trCreateSeason: 'Create season',
    trChangeLeague: 'Change league',
    trChangeLeagueShort: 'League',
    trMoveSeasonTitle: 'Move season to another league',
    trMoveSeasonCurrent: 'Current: {league}',
    trMoveSeasonTarget: 'Target league',
    trMoveSeasonTargetPh: 'Select a league',
    trMoveSeasonConfirm: 'Are you sure you want to move the entire season “{season}” from “{from}” to “{to}”?',
    trMoveSeasonHint: 'Matches, stages, settings and related data will move with the season. This cannot be undone from the admin panel.',
    trMoveSeasonEmpty: 'There are no other leagues in this championship',
    trMoveSeasonSubmit: 'Move',
    trMoveSeasonSuccess: 'Season moved to “{league}”',
    trMoveSeasonError: 'Failed to move season',
    trEmptySeasons: 'No seasons yet',
    trSeasonNamePh: 'Spring 2026',
    trInProgress: 'Not finished',
    trActive: 'Active',
    trActiveShort: 'On',
    trActiveSeasonHint: 'The top season is treated as active',
    trFirstSeasonLocked: 'The first season is always active',
    trRateRatioPlaceholder: 'Select a coefficient',
    trStartingAt: 'Start date',
    trEndingAt: 'End date',
    trLeagueType: 'Tournament type',
    trLeagueTypeRegular: 'Round robin',
    trLeagueTypeGroups: 'Groups + playoffs',
    trTableCountType: 'Table tie-breaker',
    trTableCountTypePersonal: 'Head-to-head',
    trTableCountTypeGoalDiff: 'Goal difference',
    trTableCountTypeHint: 'How to rank teams with equal points: by head-to-head results or by goal difference.',
    trTiebreakers: 'Tie-breaker order when points are equal',
    trTiebreakersHint: 'Criteria apply in order only among teams with equal points. Uncheck a criterion to ignore it.',
    trTiebreakersDragHint: 'Drag rows or use the arrows to change the order.',
    trTiebreakersPresetH2h: 'Regulation (head-to-head first)',
    trTiebreakersPresetGoalDiff: 'Goal difference first',
    trTiebreakersReset: 'Reset',
    trTiebreaker_h2h_points: 'Head-to-head points',
    trTiebreaker_h2h_goal_diff: 'Head-to-head goal difference',
    trTiebreaker_h2h_goals_for: 'Head-to-head goals scored',
    trTiebreaker_h2h_wins: 'Head-to-head wins',
    trTiebreaker_goal_diff: 'Overall goal difference',
    trTiebreaker_goals_for: 'Overall goals scored',
    trTiebreaker_wins: 'Overall wins',
    trRateRatio: 'Rating coefficient',
    trRateRatioHint: 'Championship strength. Affects how much rating teams earn from matches in this season.',
    trPenaltyDrawScore: 'Points for penalty-shootout win',
    trPenaltyDrawScorePh: 'Empty = off (usually 2 or 3)',
    trPenaltyDrawScoreHint: 'If a match ends in a draw and goes to penalties, the shootout winner gets this many points. Leave empty to disable — a draw always awards 1 point.',
    trPenaltyDrawScoreInvalid: 'Enter a positive number or clear the field',
    trApplication: 'Application',
    trApplicationPlaceholder: 'Select an application',
    trApplicationRequired: 'Select an application for the season',
    trApplicationActive: 'Transfer window open',
    trApplicationActiveHint: 'While enabled, captains can submit and change applications.',
    trApplications: 'Applications',
    trManageApplications: 'Manage applications',
    trAddApplication: 'Add application',
    trNewApplication: 'New application',
    trEditApplication: 'Edit application',
    trCreateApplication: 'Create application',
    trApplicationSearchPh: 'Search by name or year',
    trEmptyApplications: 'No applications found',
    trEmptyApplicationsHint: 'Create an application to select it in a season',
    trApplicationNotFound: 'Application not found',
    trApplicationCreated: 'Application created',
    trApplicationLocked: 'This application cannot be changed via admin (DB only)',
    trApplicationYear: 'Year',
    trApplicationYearPh: '2026',
    trApplicationYearRequired: 'Enter a year',
    trApplicationNamePh: 'AFL 2026',
    trApplicationLimit: 'Application limit',
    trApplicationLimitPh: '25',
    trApplicationLimitHint: 'Base player limit. Empty → 30. −1 — unlimited.',
    trApplicationThroughLimit: 'Through limit',
    trApplicationThroughLimitShort: 'Through',
    trApplicationThroughLimitPh: '15',
    trApplicationThroughLimitHint: 'Extra slots per additional squad in a doubles chain. Effective = base + (chain − 1) × through. Default 15.',
    trApplicationProfessionalLimit: 'Professional limit',
    trApplicationProfessionalLimitShort: 'Pro',
    trApplicationProfessionalLimitPh: 'Unlimited',
    trApplicationProfessionalLimitHint: 'Max professionals in a team roster. Empty field — no limit.',
    trApplicationCanDouble: 'Player can play for several teams',
    trApplicationCanDoubleHint: 'If this is off, a player is locked to exactly one team within this application.',
    trApplicationIsActive: 'Application is active',
    trApplicationIsActiveHint: 'An inactive application stays in the database, but is not offered to teams',
    trApplicationStatusActive: 'Active',
    trApplicationStatusActiveShort: 'On',
    trApplicationStatusInactive: 'Inactive',
    trApplicationStatusInactiveShort: 'Off',
    trApplicationInactiveMark: 'inactive',
    trGroupStagesAmount: 'Number of group stages',
    trGroupStagesAmountHint: 'How many rounds count as the group stage. The remaining rounds are playoffs.',
    trGroupStagesAmountRequired: 'Enter the number of group-stage rounds',
    trRules: 'Rules',
    trRulesHint: 'Plain text or HTML. Empty field clears the rules.',
    trRulesPageHint: 'Tournament rules open on a separate page.',
    trRulesOpen: 'Open rules',
    trRulesPh: '1. Match 2×25 min.\n2. …',
    trRulesSave: 'Save rules',
    trRulesWordImport: 'From Word',
    trRulesWordHint: '.docx only — text fills the field; then save.',
    trRulesWordImported: 'Word text inserted — click “Save rules”.',
    trRulesWordEmpty: 'The Word file has no text.',
    trRulesWordType: 'Please choose a .docx (Word) file.',
    trRulesWordLegacy: 'Legacy .doc is not supported — save as .docx first.',
    trRulesWordError: 'Could not read the Word file.',
    trContacts: 'Contacts',
    trAddContact: 'Add contact',
    trNewContact: 'New contact',
    trEditContact: 'Contact',
    trChangeContact: 'Update contact',
    trEmptyContacts: 'No contacts yet',
    trContactNotFound: 'Contact not found',
    trFirstName: 'First name',
    trLastName: 'Last name',
    trFatherName: 'Patronymic',
    trPosition: 'Position',
    trPositionPh: 'League curator',
    trPhone: 'Phone',
    trPhonePh: '+7 999 000-11-22',
    trTelegram: 'Telegram',
    trTelegramPh: '@curator',
    trInfo: 'Information',
    trFirstNameRequired: 'Enter a first name',
    trLastNameRequired: 'Enter a last name',
    trStages: 'Stages',
    trAddStage: 'Add stage',
    trAddStageShort: 'Stage',
    trNewStage: 'New stage',
    trEditStage: 'Edit stage',
    trCreateStage: 'Create stage',
    trEmptyStages: 'No stages yet',
    trStageName: 'Name',
    trStageNamePh: 'Round 1',
    trStageShortName: 'Short name',
    trStageShortNamePh: 'R1',
    trStagePriority: 'Priority',
    trStagePlayoffHint: 'If enabled, the stage comes after the group stage.',
    trStageGroup: 'Group',
    trStageGroupNone: 'No group',
    trStageGroupHint: 'Attach a stage to a group only if the same team plays in two or more groups. Otherwise it is optional.',
    trStageRateRatio: 'Difficulty coefficient',
    trStageRateRatioHint: 'Affects how much rating teams earn from matches in this stage.',
    trStageNameRequired: 'Enter a stage name',
    trStageNotFound: 'Stage not found',
    trStageMatches: 'Matches',
    trStageMatchesHint: 'Matches of this stage. Create one match or generate the whole round.',
    trDeleteCountryTitle: 'Delete championship?',
    trDeleteCountryText: 'The championship will be deleted. Leagues are not deleted automatically.',
    trDeleteLeagueTitle: 'Delete tournament?',
    trDeleteLeagueText: 'The tournament will be deleted. Seasons and matches are not deleted automatically.',
    trDeleteContactTitle: 'Delete contact?',
    trDeleteContactText: 'The curator will be deleted. This cannot be undone.',
    trDeleteStageTitle: 'Delete stage?',
    trDeleteStageText: 'The stage will be deleted. This cannot be undone.',
    trDeleteMatchTitle: 'Delete match?',
    trDeleteMatchText: 'Events, applications, photos, videos, protocol data and the match itself will be deleted. This cannot be undone.',
    trMatchDeleted: 'Match deleted',
    trCountryCreated: 'Championship created',
    trLeagueCreated: 'Tournament created',
    trSeasonCreated: 'Season created',
    trContactCreated: 'Contact added',
    trStageCreated: 'Stage created',
    trSeasonTeams: 'Participating teams',
    trSeasonTeamsHint: 'Who plays in the league this season.',
    trAddTeam: 'Add team',
    trEmptySeasonTeams: 'No teams in this season yet. Add them with the button above.',
    trRemoveFromSeason: 'Remove from season',
    trSaveTeams: 'Save teams',
    trSaveTeamsShort: 'Save',
    trTeamsSaved: 'Roster saved',
    trOpenTeam: 'Open team page',
    trUnsaved: 'unsaved',
    trTeamSearchPh: 'Search by team name',
    trTeamSearching: 'Searching…',
    trTeamsNotFound: 'No teams found',
    trTeamsShown: 'Showing {shown} of {total}',
    trShowMore: 'Show more',
    trSeasonGroups: 'Groups',
    trSeasonGroupsHint: 'How participants are split into groups. The same team can be in several groups.',
    trCreateGroup: 'Create group',
    trRandomDraw: 'Distribute randomly',
    trDrawCeremony: 'Draw ceremony',
    trDrawNeedTeams: 'Need at least one group and one team',
    trGroupNameNote: 'Write the full name — “Group A”, not “A”. The app shows it as-is.',
    trGroupNamePh: 'e.g. “Group A”',
    trGroupNameRequired: 'Enter a group name.',
    trGroupNameExists: 'A group with this name already exists.',
    trEmptyGroups: 'No groups yet. Create them (“Group A”, “Group B”, …) and assign teams.',
    trDrawSizes: 'A random draw will put {sizes} teams in the groups.',
    trSeededTeams: 'Seeded teams',
    trClearSeeded: 'clear all',
    trSeededHint: 'Mark teams that should not land in the same group. The draw spreads them across groups.',
    trUnassignedGroup: 'Unassigned',
    trEmptyGroupTeams: 'No teams in this group — assign them in the list below.',
    trAllTeamsAssigned: 'All teams are assigned to groups.',
    trRenameGroup: 'Rename',
    trDeleteGroup: 'Delete group',
    trSaveGroups: 'Save groups',
    trSaveGroupsShort: 'Save',
    trGroupsSaved: 'Groups saved',
    trSeasonActions: 'Actions',
    trSeasonActionsHint: 'Replacements update the season roster and group. Penalties change table points.',
    trAddReplacement: 'Team replacement',
    trAddPenalty: 'Penalty',
    trEmptyActions: 'No actions yet. Add a replacement or a penalty.',
    trReplacement: 'Replacement',
    trPenalty: 'Penalty',
    trPreviousTeam: 'Previous team',
    trCurrentTeam: 'New team',
    trPreviousTeamHint: 'A team from this season’s roster.',
    trCurrentTeamHint: 'Any team that is not already in this season.',
    trPenaltyTeam: 'Team',
    trPenaltyScore: 'Points',
    trPenaltyScoreHint: 'A negative number removes points from the table, a positive number adds them.',
    trPenaltyScorePh: '-10',
    trActionDate: 'Date',
    trActionDateHint: 'Optional. If empty, the current time is used.',
    trActionGroup: 'Group',
    trActionGroupAuto: 'Detect automatically',
    trActionGroupHint: 'If left empty, the server uses the team’s current group.',
    trReplacementHint: 'The old team leaves the roster and the new one takes its place, including the group slot. Matches of the old team will count for the new one.',
    trSameTeams: 'Previous and new team must be different.',
    trCurrentTeamInSeason: 'This team is already in the season roster.',
    trScoreRequired: 'Enter a non-zero points value.',
    trTeamRequired: 'Select a team.',
    trActionAdded: 'Action added',
    trActionDeleted: 'Action deleted',
    trDeleteActionTitle: 'Delete this action?',
    trDeleteReplacementText: 'The roster and group will roll back to the old team, then the replacement will be deleted. If this new team was replaced again later, undo the later replacement first.',
    trDeletePenaltyText: 'The penalty will be removed from the table.',
    trPenaltyPoints: '{score} pts',
    trSelectTeam: 'Select a team',
    trActionCreate: 'Add',
    trTeamSearchStart: 'Start typing a team name',
    gmQuickEdit: 'Quick edit',
    gmQuickFailed: 'Some matches were not saved ({count}): {list}. The rest were updated.',
    gmQuickHalf: 'Half',
    gmQuickHint: 'Rows do not open — edit date, time, half length, stadium and referee right here, then press “Save”.',
    gmQuickLoadingRefs: 'Loading referees and stadiums…',
    gmQuickNeedDate: 'Set a date for {match}',
    gmQuickNeedHalfTime: 'Set half length (> 0) for {match}',
    gmQuickNoMatches: 'No matches on the page',
    gmQuickNoPitch: 'No pitch',
    gmQuickNoReferee: 'No referee',
    gmQuickNoStadium: 'No stadium',
    gmQuickReferee: 'Referee',
    gmQuickRefereePh: 'Referee surname',
    gmQuickRefsError: 'Failed to load referees and stadiums',
    gmQuickSaveCount: 'Save ({count})',
    gmQuickSaved: 'Matches saved: {count}',
    gmQuickSaving: 'Saving…',
    gmQuickStadiumPh: 'Stadium name',
    olmEditTimer: 'Edit timer',
    olmEditTimerShort: 'Time',
    olmPauseShort: 'Pause',
    olmSpaceHint: 'Space — pause / resume',
    tabloClockPaused: 'paused',
    olmResumeShort: 'Start',
    olmUseTimerTime: 'Use the live match timer',
    ssNothingFound: 'Nothing found',
    ssShownFirst: 'Showing first {shown} of {total} — start typing to search',
  },
};

const LanguageContext = createContext({
  lang: 'ru',
  setLang: () => {},
  t: (key) => key,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(LANG_STORAGE_KEY);
    return saved === 'en' ? 'en' : 'ru';
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((nextLang) => {
    const value = nextLang === 'en' ? 'en' : 'ru';
    localStorage.setItem(LANG_STORAGE_KEY, value);
    setLangState(value);
  }, []);

  const t = useCallback((key, vars) => {
    let str = (translations[lang] && translations[lang][key]) || translations.ru[key] || key;
    if (vars && typeof str === 'string') {
      Object.keys(vars).forEach((name) => {
        str = str.split('{' + name + '}').join(String(vars[name]));
      });
    }
    return str;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useI18n() {
  return useContext(LanguageContext);
}
